/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: ' + 769 + 'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log('Impulse theme (' + theme.settings.themeVersion + ') by ARCHΞTYPE | Learn more at https://archetypethemes.co');
}

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 2;

(function () {
  'use strict';

  theme.delegate = {
    on: function (event, callback, options) {
      if (!this.namespaces) // save the namespaces on the DOM element itself
        this.namespaces = {};

      // Store callbacks as an array per namespace key. The previous single-callback
      // storage (this.namespaces[event] = callback) silently leaked listeners whenever
      // the same namespace was bound twice: the namespaces map was overwritten with
      // the new callback but the old native listener stayed attached and unreachable
      // forever. With an array, off() can iterate and remove every registered handler
      // for that namespace. For window/document this also means all namespaces share
      // a single map (this === window) so collisions across components must use
      // distinct namespace suffixes — already the existing convention.
      if (!this.namespaces[event]) this.namespaces[event] = [];
      this.namespaces[event].push(callback);
      options = options || false;

      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function (event) {
      if (!this.namespaces || !this.namespaces[event]) return this;
      var nativeType = event.split('.')[0];
      var callbacks = this.namespaces[event];
      for (var i = 0; i < callbacks.length; i++) {
        this.removeEventListener(nativeType, callbacks[i]);
      }
      delete this.namespaces[event];
      return this;
    }
  };

  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.utils = {
    defaultTo: function (value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },

    wrap: function (el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },

    debounce: function (wait, callback, immediate) {
      var timeout;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },

    throttle: function (limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },

    clearOtherMainCategory: function (currentCategory, container) {
      var parent = currentCategory.parentElement;
      Array.prototype.forEach.call(parent.children, function (sibling) {
        if (sibling !== currentCategory && sibling.hasAttribute('data-category-main')) {
          var inputList = sibling.querySelectorAll('.tag__input')
          inputList.forEach(function (item) {
            item.checked = false
            var name = item.dataset.name
            var value = item.dataset.value
            var listItem = item.closest('li.tag')
            if (listItem) listItem.classList.remove('tag--active')

            var input = container.querySelector('input[name="' + name + '"][value="' + value + '"]')
            if (input) input.checked = false
          })
        }
      });
    },

    prepareTransition: function (el, callback) {
      el.addEventListener('transitionend', removeClass);

      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }

      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === 'function') {
        callback();
      }
    },

    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function (array) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },

    decodeString: function (encodedString) {
      const textarea = document.createElement("textarea");
      textarea.innerHTML = encodedString;
      return textarea.value;
    },

    serialize: function (form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };

  theme.a11y = {
    trapFocus: function (options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };

      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();

      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function () {
        document.documentElement.off(eventsName.keydown);
      });

      document.documentElement.on(eventsName.focusin, function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

        document.documentElement.on(eventsName.keydown, function (evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
        /**
         * On the last focusable element and tab forward,
         * wrap back to the first element. Without this branch the focus
         * trap is one-directional and forward-Tab can escape drawers/modals.
         */
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
      }
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';

      if (options.container) {
        options.container.removeAttribute('tabindex');
      }

      document.documentElement.off(eventName);
    },

    lockMobileScrolling: function (namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function () {
        return true;
      });
    },

    unlockMobileScrolling: function (namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };

  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function (evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */

  theme.Currency = (function () {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);

          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }

          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');

          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }

          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();

  theme.Images = (function () {

    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }

      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }

      if (size == null) {
        return src;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }

    // Inserts a {width} placeholder into a Shopify CDN image URL
    // so lazysizes can substitute the actual width at runtime.
    // Uses the modern query-param format (?width={width}) instead of
    // the deprecated filename format (_{width}x).
    function lazyloadImagePath(string) {
      if (string == null) return string;

      // If URL already has query params, append &width={width}
      // Otherwise, add ?width={width}
      var separator = string.indexOf('?') !== -1 ? '&' : '?';
      return string + separator + 'width={width}';
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath
    };
  })();

  theme.loadImageSection = function (container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      container.classList.remove('loading', 'loading--delayed');
      container.classList.add('loaded');
    }

    function checkForLazyloadedImage() {
      return container.querySelector('.lazyloaded');
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if (container.querySelector('svg')) {
      setAsLoaded();
      return;
    };

    if (checkForLazyloadedImage()) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function () {
      if (checkForLazyloadedImage()) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 25);
  };

  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0;

    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
            // After the only target fires, drop the observer entirely so it can
            // be garbage-collected. Without disconnect() it lives on as long as
            // any closure references it — small per-call leak but adds up on
            // long browsing sessions (Recommendations / RecentlyViewed / Video).
            observer.disconnect();
          }
        }
      });
    }, { rootMargin: '0px 0px ' + threshold + 'px 0px' });

    observer.observe(options.element);
  };

  theme.LibraryLoader = (function () {
    var types = {
      link: 'link',
      script: 'script'
    };

    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };

    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];

      if (!library) return;
      if (library.status === status.requested) return;

      callback = callback || function () { };
      if (library.status === status.loaded) {
        callback();
        return;
      }

      library.status = status.requested;

      var tag;

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }

      tag.id = library.tagId;
      library.element = tag;

      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    return {
      load: load
    };
  })();

  theme.rteInit = function () {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });

    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });

    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.utils.wrap(iframe, wrapWith);
    }

    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');

      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }

      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },

    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function (id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }

      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');

      if (!section) {
        return;
      }

      this._createInstance(section);

      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },

    _onSectionUnload: function (evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },

    loadSubSections: function (scope) {
      if (!scope) {
        return;
      }

      var sections = scope.querySelectorAll('[data-section-id]');

      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },

    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },

    register: function (type, constructor, scope) {
      this.constructors[type] = constructor;

      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }

      sections.forEach(
        function (container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },

    reinit: function (section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });

  /*
    Options:
      container
      enableHistoryState - enable when on single product page to update URL
      singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
      originalSelectorId - selector for base variant selector (visually hidden)
      variants - JSON parsed object of product variant info
   */
  theme.Variants = (function () {

    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.dynamicVariantsEnabled = options.dynamicVariantsEnabled;
      this.currentlySelectedValues = this._getCurrentOptions();
      this.currentVariant = this._getVariantFromOptions();

      this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {

      _getCurrentOptions: function () {
        var result = [];

        this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
          var type = el.getAttribute('type');

          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index
            });
          }
        });

        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);

        return result;
      },

      // Pull the number out of the option index name, e.g. 'option1' -> 1
      _numberFromOptionKey: function (key) {
        return parseInt(key.substr(-1));
      },

      // Options should be ordered from highest to lowest priority. Make sure that priority
      // is represented using weighted values when finding best match
      _getWeightedOptionMatchCount: function (variant) {
        return this._getCurrentOptions().reduce((count, { value, index }) => {
          const optionIndex = this._numberFromOptionKey(index);
          const weightedCount = 4 - optionIndex; // The lower the index, the better the match we have
          return variant[index] === value ? count + weightedCount : count;
        }, 0)
      },

      _getFullMatch(needsToBeAvailable) {
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;

        return variants.find(variant => {
          const isMatch = currentlySelectedOptions.every(({ value, index }) => {
            return variant[index] === value;
          });

          if (needsToBeAvailable) {
            return isMatch && variant.available;
          } else {
            return isMatch;
          }
        });
      },

      // Find a variant that is available and best matches last selected option
      _getClosestAvailableMatch: function (lastSelectedOption) {
        if (!lastSelectedOption) return null;

        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;

        const potentialAvailableMatches = lastSelectedOption && variants.filter(variant => {
          return currentlySelectedOptions
            .filter(
              // Only match based selected options that are equal and preceeding the last selected option
              ({ value, index }) => this._numberFromOptionKey(index) <= this._numberFromOptionKey(lastSelectedOption.index)
            ).every(({ value, index }) => {
              // Variant needs to have options that match the current and preceeding selection options
              return variant[index] === value;
            }) && variant.available
        });

        return potentialAvailableMatches.reduce((bestMatch, variant) => {
          // If this is the first potential match we've found, store it as the best match
          if (bestMatch === null) return variant;

          // If this is not the first potential match, compare the number of options our current best match has in common
          // compared to the next contender.
          const bestMatchCount = this._getWeightedOptionMatchCount(bestMatch, lastSelectedOption);
          const newCount = this._getWeightedOptionMatchCount(variant, lastSelectedOption);

          return newCount > bestMatchCount ? variant : bestMatch;
        }, null);
      },

      _getVariantFromOptions: function (lastSelectedOption) {
        const availableFullMatch = this._getFullMatch(true);
        const closestAvailableMatch = this._getClosestAvailableMatch(lastSelectedOption);
        const fullMatch = this._getFullMatch(false);

        if (this.dynamicVariantsEnabled) {
          // Add some additional smarts to variant matching if Dynamic Variants are enabled
          return availableFullMatch || closestAvailableMatch || fullMatch || null;
        } else {
          // Only return a full match or null (variant doesn't exist) if Dynamic Variants are disabled
          return fullMatch || null;
        }

      },

      _updateInputState: function (variant, el) {
        return (input) => {
          if (variant === null) return;

          const index = input.dataset.index;
          const value = input.value;
          const type = input.getAttribute('type');

          if (type === 'radio' || type === 'checkbox') {
            input.checked = variant[index] === value
          } else {
            input.value = variant[index];
          }
        }
      },

      _onSelectChange: function ({ srcElement }) {
        const optionSelectElements = this.container.querySelectorAll(this.singleOptionSelector);
        // Get the best variant based on the current selection + last selected element
        const variant = this._getVariantFromOptions({
          index: srcElement.dataset.index,
          value: srcElement.value
        });

        // Update DOM option input states based on the variant that was found
        optionSelectElements.forEach(this._updateInputState(variant, srcElement))

        // Make sure our currently selected values are up to date after updating state of DOM
        const currentlySelectedValues = this.currentlySelectedValues = this._getCurrentOptions();

        const detail = {
          variant,
          currentlySelectedValues,
          value: srcElement.value,
          index: srcElement.parentElement.dataset.index
        }
        // variant is null when the selected option combo has no matching
        // variant — the change events below must STILL dispatch (the
        // unavailable-state UI relies on them), so only the price toggling
        // is skipped instead of letting variant.price throw here.
        const option1Selector = document.querySelectorAll('.variant-input-wrap[data-index="option1"] .option--item')
        if (variant && option1Selector.length > 0) {
          const price = Math.round(variant.price / 100) * 100
          option1Selector.forEach(el => {
            const priceEl = el.querySelector('.price--identifier')
            if (priceEl) {
              const priceFromEl = parseInt(priceEl.dataset.price)

              if (price == priceFromEl) {
                if (!priceEl.classList.contains('v-hidden')) priceEl.classList.add('v-hidden')
              }
              else {
                if (priceEl.classList.contains('v-hidden')) priceEl.classList.remove('v-hidden')
              }
            }
          })
        }

        const option1SelectorDesktop = document.querySelectorAll('.btn--option')
        if (variant && option1SelectorDesktop.length > 0) {
          const price = Math.round(variant.price / 100) * 100

          option1SelectorDesktop.forEach(el => {
            const priceEl = el.querySelector('.price--identifier')
            if (priceEl) {
              const priceFromEl = parseInt(priceEl.dataset.price)

              if (price == priceFromEl) {
                if (!priceEl.classList.contains('v-hidden')) priceEl.classList.add('v-hidden')
              }
              else {
                if (priceEl.classList.contains('v-hidden')) priceEl.classList.remove('v-hidden')
              }
            }
          })
        }

        this.container.dispatchEvent(new CustomEvent('variantChange', { detail }));
        document.dispatchEvent(new CustomEvent('variant:change', { detail }));

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },

      _updateImages: function (variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant && this.currentVariant.featured_image || {};

        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updatePrice: function (variant) {
        if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateUnitPrice: function (variant) {
        if (this.currentVariant && variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateSKU: function (variant) {
        if (this.currentVariant && variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({ path: newurl }, '', newurl);
      },

      _updateMasterSelect: function (variant) {
        let masterSelect = this.container.querySelector(this.originalSelectorId);
        if (!masterSelect) return;

        masterSelect.value = variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    return Variants;
  })();

  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true;

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function () {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        document.dispatchEvent(new CustomEvent('vimeoReady'));
      });
  }

  function checkIfVimeoIsReady() {
    var wait;
    var timeout;

    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return;
        }

        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);

      timeout = setTimeout(function () {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });

    return deferred;
  }

  theme.VimeoPlayer = (function () {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }

    var defaults = {
      byline: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    };

    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options;

      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent);
      }

      this.setAsLoading();

      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
        document.addEventListener('vimeoReady', this.init.bind(this));
      }
    }

    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        var args = defaults;
        args.id = this.videoId;

        this.videoPlayer = new Vimeo.Player(this.el, args);

        this.videoPlayer.ready().then(this.playerReady.bind(this));
      },

      playerReady: function () {
        this.iframe = this.el.querySelector('iframe');
        this.iframe.setAttribute('tabindex', '-1');

        if (this.options.loop === 'false') {
          this.videoPlayer.setLoop(false);
        }

        // When sound is enabled in section settings,
        // for some mobile browsers Vimeo video playback
        // will stop immediately after starting and
        // will require users to tap the play button once more
        if (this.options.style === 'sound') {
          this.videoPlayer.setVolume(1);
        } else {
          this.videoPlayer.setVolume(0);
        }

        this.setAsLoaded();

        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, { rootMargin: '0px 0px 50px 0px' });

        observer.observe(this.iframe);
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        this.parent.classList.add(classes.interactable); // Once video is loaded, we should be able to interact with it
        if (Shopify && Shopify.designMode) {
          if (window.AOS) { AOS.refreshHard() }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause();
        }
      },

      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });

    return VimeoPlayer;
  })();

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }

  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function () {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }

    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };

    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;

      this.attemptedToPlay = false;

      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };

      this.options = Object.assign({}, defaults, options);

      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }

        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }

        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }

      }

      this.setAsLoading();

      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }

    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function () {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },

      onVideoPlayerReady: function (evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');

        if (this.options.style !== 'sound') {
          evt.target.mute();
        }

        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, { rootMargin: '0px 0px 50px 0px' });

        observer.observe(this.iframe);
      },

      onVideoStateChange: function (evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) { AOS.refreshHard() }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },

      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });

    return YouTube;
  })();

  // Prevent vertical scroll while using flickity sliders
  (function () {
    var e = !1;
    var t;

    document.body.addEventListener('touchstart', function (i) {
      if (!i.target.closest('.flickity-slider')) {
        return e = !1;
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY
      }
    })

    document.body.addEventListener('touchmove', function (i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y
        };
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
      }
    }, { passive: !1 })
  })();

  // Prevent vertical scroll while using Swiper sliders
  (function () {
    var isSwiping = false;
    var startPos;
    var dragThreshold = 10; // pixels to move before preventing scroll

    document.body.addEventListener('touchstart', function (e) {
      if (!e.target.closest('.swiper-wrapper')) {
        isSwiping = false;
        return;
      }
      isSwiping = true;
      startPos = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      };
    });

    document.body.addEventListener('touchmove', function (e) {
      if (isSwiping && e.cancelable) {
        var delta = {
          x: e.touches[0].pageX - startPos.x,
          y: e.touches[0].pageY - startPos.y
        };
        // If horizontal movement exceeds threshold, prevent vertical scroll
        if (Math.abs(delta.x) > dragThreshold && Math.abs(delta.x) > Math.abs(delta.y)) {
          e.preventDefault();
        }
      }
    }, { passive: false });
  })();

  /**
   * enforceSearchScope — the ONE authority for the search gender scope.
   * -----------------------------------------------------------------------------
   * Shared by every query builder that can produce a search-page fetch or
   * history URL (the count fetch in getFilterUpdates, the grid prefetch in
   * backgroundUpdatePage, and the merged params inside AjaxRenderer.renderPage
   * that the form-driven render pushes). The search gender is a MODE, not a
   * user-facing facet, so it must survive EVERY rebuilt URL — this function is
   * the single place that guarantees it.
   *
   * Two hazards it closes, neither of which any single call site handled alone:
   *   1. Shopify omits zero-result facets, so the gender checkbox can be absent
   *      from the DOM the params are built from — the scope would silently
   *      vanish, unscoping the search (cross-gender leak).
   *   2. A URL-copied `filter.p.tag=women` can be STALE after a toggle flip to
   *      men — appending men without removing women makes Shopify OR the two
   *      (BOTH genders show). We must strip the conflicting gender value.
   *
   * The hidden [data-gender-search-filter] input (owned by gender-context.js;
   * disabled = unscoped) is the single source of truth and always wins. Every
   * NON-gender filter.p.tag value is left untouched so a future tag facet can
   * safely share this param. Off the search page it is a strict no-op.
   *
   * Mutates and returns the passed URLSearchParams. Idempotent — safe to call
   * more than once on the same params.
   */
  theme.enforceSearchScope = function (queryParams) {
    if (!window.location.pathname.includes('search')) return queryParams;

    var scopeInput = document.querySelector('[data-gender-search-filter]');
    if (!scopeInput || scopeInput.disabled) return queryParams;

    var scope = scopeInput.value;
    if (scope !== 'men' && scope !== 'women') return queryParams;

    // Preserve any non-gender tag values (deduped); drop every gender value so
    // the scope is unambiguous, then append the source-of-truth scope exactly
    // once. Removing ALL gender values (not just the mismatched one) also
    // collapses accidental duplicates into a single authoritative entry.
    var nonGender = [];
    queryParams.getAll('filter.p.tag').forEach(function (value) {
      var down = String(value).toLowerCase();
      if (down !== 'men' && down !== 'women' && nonGender.indexOf(value) === -1) {
        nonGender.push(value);
      }
    });
    queryParams.delete('filter.p.tag');
    nonGender.forEach(function (value) { queryParams.append('filter.p.tag', value); });
    queryParams.append('filter.p.tag', scope);

    return queryParams;
  };

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */

  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }

    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, newParams, updateURLHash = true) {
        const currentParams = new URLSearchParams(window.location.search);
        const updatedParams = this.getUpdatedParams(currentParams, newParams)

        // Scope must win on the MERGED params (this is the form-driven render
        // path, e.g. renderFromFormData): getUpdatedParams may carry a stale
        // gender copied from the URL, and it now preserves filter.p.tag rather
        // than delete it — so this is the step that strips a conflicting gender
        // and stamps the source-of-truth scope on both the fetched section URLs
        // AND the pushed history URL below. No-op off the search page.
        theme.enforceSearchScope(updatedParams);

        const sectionRenders = this.sections.map(section => {

          const url = `${basePath}?section_id=${section.sectionId}&${updatedParams.toString()}`;
          const cachedSectionUrl = cachedSection => cachedSection.url === url;

          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });

        if (updateURLHash) this.updateURLHash(updatedParams);

        return Promise.all(sectionRenders);
      },

      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);

        this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },

      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] rendering from fetch: url=${url}`);

        return new Promise((resolve, reject) => {
          fetch(url)
            .then(response => response.text())
            .then(responseText => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch(err => reject(err));
        });
      },

      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
        );

        const newDom = new DOMParser().parseFromString(html, 'text/html');
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === 'string') {
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }

            // Guard against the live target being missing (renamed/removed by
            // an earlier render). Without this, a single missing id throws
            // mid-pipeline so e.g. the header renders but the grid doesn't.
            var liveEl = document.getElementById(section.nodeId);
            if (liveEl) liveEl.innerHTML = newContentEl.innerHTML;
          } else {
            section.nodeId.forEach(id => {
              var liveEl = document.getElementById(id);
              var newEl = newDom.getElementById(id);
              if (liveEl && newEl) liveEl.innerHTML = newEl.innerHTML;
            });
          }
        }

        return section;
      },

      getUpdatedParams: function (currentParams, newParams) {
        const clone = new URLSearchParams(currentParams);
        // filter.p.tag carries the search gender SCOPE — a browsing mode, not a
        // user-facing filter: no legitimate flow removes it (gender has no pill
        // and clearAll exempts it), so it must never be stripped by the delete
        // loop when a facet checkbox is absent. Staleness after a toggle flip is
        // corrected downstream by theme.enforceSearchScope (called in renderPage
        // on these merged params), not here.
        const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type', 'filter.p.tag'];

        // Find what params need to be removed
        // delete happens first as we cannot specify keys based off of values
        for (const [key, value] of clone.entries()) {
          if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
            clone.delete(key);
          };
        }

        // Find what params need to be added
        for (const [key, value] of newParams.entries()) {
          if (!clone.getAll(key).includes(value) && value !== '') {
            clone.append(key, value);
          }
        }

        return clone;
      },

      updateURLHash: function (searchParams) {
        history.pushState(
          {},
          '',
          `${window.location.pathname}${searchParams && '?'.concat(searchParams)
          }`,
        );
      },

      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });

    return AjaxRenderer;
  })();

  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }
  theme.cart = {
    getCart: function () {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
    },

    getCartProductMarkup: function () {
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());

      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');

      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
        .then(function (response) { return response.text() });
    },

    changeItem: function (key, qty) {
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },

    _updateCart: function (params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => response.json())
        .then(function (cart) {
          return cart;
        });
    },

    updateAttribute: function (key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        })
      });
    },

    updateNote: function (note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        })
      });
    },

    attributeToString: function (attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }

  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function () {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',

      cartBubble: '.cart-link__bubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout'
    };

    var classes = {
      btnLoading: 'btn--loading'
    };

    var config = {
      requiresTerms: false
    };

    function CartForm(form) {
      if (!form) {
        return;
      }

      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = form.querySelector(selectors.checkoutBtn);

      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);

      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }

      this.init();
    }

    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function () {
        this.initQtySelectors();

        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));

        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));

        if (this.noteInput) {
          this.noteInput.addEventListener('change', function () {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }

        // Dev-friendly way to build the cart
        document.addEventListener('cart:build', function () {
          this.buildCart();
        }.bind(this));
      },

      reInit: function () {
        this.initQtySelectors();
      },

      onSubmit: function (evt) {
        this.submitBtn.classList.add(classes.btnLoading);

        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        }
      },

      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        return {
          items: doc.querySelector('.cart__items'),
          discounts: doc.querySelector('.cart__discounts')
        }
      },

      buildCart: function () {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },

      cartMarkup: function (html) {
        var markup = this._parseProductHTML(html);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;

        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);

        if (count > 0) {
          if (this.wrapper) this.wrapper.classList.remove('is-empty');

        } else {
          if (this.wrapper) this.wrapper.classList.add('is-empty');
        }

        this.updateCount(count);

        // Append item markup
        if (this.product) {
          this.products.innerHTML = '';
          this.products.append(items);
        }

        // Update subtotal
        if (this.subtotal) {
          this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
        }

        this.reInit();

        if (window.AOS) { AOS.refreshHard() }

        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },

      updateCartDiscounts: function (markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },

      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function () {
        if (this.form) {
          this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
            var selector = new theme.QtySelector(el, {
              namespace: this.namespace,
              isCart: true
            });
          });
        }
      },

      quantityChanged: function (evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        const parent = el.closest('.cart__item')

        const qtyElements = parent.querySelectorAll('.js-qty__info .__qty')

        if (!key || !qty) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add('is-loading');
        }


        theme.cart.changeItem(key, qty)
          .then(function (cart) {
            if (cart.item_count > 0) {
              this.wrapper.classList.remove('is-empty');
            } else {
              this.wrapper.classList.add('is-empty');
            }

            this.buildCart();

            if (el) {
              el.classList.remove('is-loading');
            }
            qtyElements.forEach(item => {
              item.innerHTML = qty
            })

            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: cart
              }
            }));
          }.bind(this))
          .catch(function (XMLHttpRequest) { });
      },

      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function (subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },

      updateSavings: function (savings) {
        if (!this.savings) {
          return;
        }

        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },

      updateCount: function (count) {
        var countEls = document.querySelectorAll('.cart-link__bubble-num');

        if (countEls.length) {
          countEls.forEach(el => {
            el.innerText = count;
          });
        }

        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          // Note: the bubble is deliberately NOT hidden when the count drops
          // to 0 (the remove() call was commented out long before this
          // cleanup) — at zero this block does nothing; only the count
          // texts above update.
          if (count > 0) {
            bubbles.forEach(b => {
              b.classList.add('cart-link__bubble--visible');
              b.textContent = count;
            });
          }
        }
      }
    });

    return CartForm;
  })();

  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function () {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      wrapper: '.collapsible-wrapper',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };

    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };

    var namespace = '.collapsible';

    var isTransitioning = false;

    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);

        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }

    async function toggle(evt) {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
      var closeElHeight = 0;

      var wrapper = evt.target.closest(selectors.wrapper)
      async function closeSiblings(wrapper) {
        if (wrapper) {
          let siblings = getSiblings(wrapper);
          let promises = siblings.map(async openItem => {
            let target = openItem.querySelector(selectors.trigger);
            let opened = target.classList.contains(classes.open);
            let hasChildOpen = openItem.querySelector(selectors.moduleInner).querySelector('.' + classes.open)
            if (hasChildOpen) {
              await closeAccordion(hasChildOpen)
            }
            if (opened) {
              const isClose = await closeAccordion(target);
              closeElHeight = isClose
            }
          });

          await Promise.all(promises);
        }
      }

      await closeSiblings(wrapper)

      if (!moduleId) {
        moduleId = el.dataset.controls;
      }

      // No ID, bail
      if (!moduleId) {
        return;
      }

      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }

      if (!container) {
        isTransitioning = false;
        return;
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var searchWrapper = container.querySelector('.filter-search--wrapper')

      if (searchWrapper) {
        height = height + searchWrapper.offsetHeight
      }

      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isTab) {
        if (isOpen) {
          isTransitioning = false;
          return;
        }

        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="' + el.dataset.id + '"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function () {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }

      setTransitionHeight(container, height + 1, isOpen, isAutoHeight);

      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;

        if (isOpen && parentHeight === 'auto') {
          childHeight = 0; // Set childHeight to 0 if parent is initially opened
        }

        var totalHeight = isOpen ? parentCollapsibleEl.offsetHeight - childHeight : (height + parentCollapsibleEl.offsetHeight) - closeElHeight;

        setTransitionHeight(parentCollapsibleEl, totalHeight + 1, false, false);
      }

      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (!btn) { return }
        btn.off('click' + namespace);
        btn.on('click' + namespace, function () {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }

    function closeAccordion(el) {
      return new Promise((resolve, reject) => {
        var moduleId = el.getAttribute('aria-controls');
        var container = document.getElementById(moduleId);

        if (!moduleId) {
          moduleId = el.dataset.controls;
        }

        // No ID, bail
        if (!moduleId) {
          return;
        }

        // If container=null, there isn't a matching ID.
        // Check if data-id is set instead. Could be multiple.
        // Select based on being in the same parent div.
        if (!container) {
          var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
          if (multipleMatches.length > 0) {
            container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
          }
        }

        if (!container) {
          return;
        }

        var height = container.querySelector(selectors.moduleInner).offsetHeight;
        var searchWrapper = container.querySelector('.filter-search--wrapper')

        if (searchWrapper) {
          height = height + searchWrapper.offsetHeight
        }

        var isAutoHeight = container.classList.contains(classes.autoHeight);
        var parentCollapsibleEl = container.parentNode.closest(selectors.module);
        var childHeight = height;

        // If isAutoHeight, set the height to 0 just after setting the actual height
        // so the closing animation works nicely
        setTimeout(function () {
          height = 0;
          setTransitionHeight(container, height, true, isAutoHeight);
        }, 0);

        if (!isAutoHeight) {
          height = 0;
        }

        el.setAttribute('aria-expanded', false);
        el.classList.remove(classes.open);

        setTransitionHeight(container, height, true, isAutoHeight);

        // If we are in a nested collapsible element like the mobile nav,
        // also set the parent element's height
        if (parentCollapsibleEl) {
          var parentHeight = parentCollapsibleEl.style.height;

          if (parentHeight === 'auto') {
            childHeight = 0; // Set childHeight to 0 if parent is initially opened
          }

          var totalHeight = parentCollapsibleEl.offsetHeight - childHeight;

          setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
        }
        resolve(childHeight)
      })
    }

    function getSiblings(node) {
      return [...node.parentNode.children].filter(c => c !== node)
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function () {

        container.style.height = height + 'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });

      if (!isOpen && isAutoHeight) {
        // After the open transition settles, hand the container back to
        // natural height so late content reflows (e.g. images loading) don't
        // clip. Was a jQuery leftover (`o.css('height','auto')`) that would
        // TypeError on a plain DOM node. NOTE: this branch is currently
        // unreachable — the `collapsible--auto-height` class sits on the
        // trigger BUTTONS in liquid while isAutoHeight is read off the
        // content container — but the landmine is defused in case that
        // markup mismatch is ever fixed to enable auto-height behavior.
        window.setTimeout(function () {
          container.style.height = 'auto';
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init
    };
  })();

  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function () {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };

    var classes = {
      listVisible: 'disclosure-list--visible'
    };

    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },

      _setupListeners: function () {
        this.eventHandlers = this._setupEventHandlers();

        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },

      _setupEventHandlers: function () {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
        };
      },

      _connectOptions: function (event) {
        event.preventDefault();

        this._submitForm(event.currentTarget.dataset.value);
      },

      _onDisclosureToggleFocusOut: function (event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;

        if (disclosureLostFocus) {
          this._hideList();
        }
      },

      _onDisclosureListFocusOut: function (event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);

        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },

      _onDisclosureKeyUp: function (event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },

      _onBodyClick: function (event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !isOption) {
          this._hideList();
        }
      },

      _submitForm: function (value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },

      _hideList: function () {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
      },

      _toggleList: function () {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },

      destroy: function () {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        );
      }
    });

    return Disclosure;
  })();
  // Drawers — generic drawer/modal system used across the theme.
  // Opens/closes off-canvas panels (cart drawer, filter drawer, variant drawer, menu).
  // Listens for clicks on elements with .js-drawer-open-[name] and manages
  // body scroll lock, focus trap, and close-on-overlay-click.
  theme.Drawers = (function () {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };

      this.nodes = {
        page: document.querySelector('#MainContent')
      };

      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;

      if (!this.drawer) {
        return;
      }

      this.init();
    }

    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function () {
        // Store bound handlers once for proper cleanup
        this._boundOpen = this._boundOpen || this.open.bind(this);
        this._boundClose = this._boundClose || this.close.bind(this);
        this._boundModalClose = this._boundModalClose || this.close.bind(this);

        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this._boundOpen);
        });

        document.addEventListener('drawer-open', this._boundOpen)

        this.drawer.querySelector(this.config.close).addEventListener('click', this._boundClose);

        // Close modal if a drawer is opened
        document.addEventListener('modalOpen', this._boundModalClose);
      },

      destroyListeners: function () {
        document.removeEventListener('drawer-open', this._boundOpen);
        document.removeEventListener('modalOpen', this._boundModalClose);
      },

      getScrollbarWidth: function () {
        const scrollDiv = document.createElement("div");
        scrollDiv.style.visibility = "hidden";
        scrollDiv.style.overflow = "scroll";
        scrollDiv.style.msOverflowStyle = "scrollbar"; // For older IE
        scrollDiv.style.position = "absolute";
        scrollDiv.style.top = "-9999px";
        scrollDiv.style.width = "100px";
        document.body.appendChild(scrollDiv);

        const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
      },

      open: function (evt, returnFocusEl) {
        var hasTarget = evt.detail.target

        if (evt) {
          evt.preventDefault();
        }

        if (this.isOpen) {
          return;
        }

        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close

          if (hasTarget) {
            hasTarget.setAttribute('aria-expanded', 'true');
            this.activeSource = hasTarget;
          } else {
            evt.currentTarget.setAttribute('aria-expanded', 'true');
            this.activeSource = evt.currentTarget;
          }

        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }

        this.drawer.removeAttribute('inert');

        if (this.config.id === 'NavDrawer') {
          var sf = this.drawer.querySelector('.slide-nav__search-field');
          var title = this.drawer.querySelector('.title__placeholder');
          if (sf) sf.classList.remove('disappear');
          if (title) title.textContent = '';
        }

        // Redundant reflow removed — prepareTransition below already forces
        // a reflow via offsetWidth, which commits the inert removal above.

        theme.utils.prepareTransition(this.drawer, function () {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this));

        document.documentElement.classList.add(this.config.openClass);
        const scrollbarWidth = this.getScrollbarWidth()
        document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)

        this.isOpen = true;

        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });

        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
        this.bindEvents();
      },
      close: function (evt) {

        if (window.startTracking) {
          document.documentElement.classList.remove('trigger-from-search-close')
          document.documentElement.classList.remove('track-collection-filter')

          var navDrawer = document.querySelector('#NavDrawer')
          var filterDrawer = document.querySelector('#FilterDrawer')
          var filterDrawerMobile = document.querySelector('#FilterDrawerMobile')

          if (navDrawer) {
            navDrawer.removeAttribute('inert');
            navDrawer.classList.add('drawer--is-open');
          }
          if (filterDrawer) {
            filterDrawer.classList.remove('drawer--is-open');
            filterDrawer.setAttribute('inert', '');
          }
          if (filterDrawerMobile) {
            filterDrawerMobile.classList.remove('drawer--is-open');
            filterDrawerMobile.setAttribute('inert', '');
          }

          if (this.drawer.getAttribute('id') == 'FilterDrawer') this.isOpen = false
          if (this.drawer.getAttribute('id') == 'FilterDrawerMobile') this.isOpen = false
          return
        }

        if (!this.isOpen) {
          return;
        }

        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }

        // deselect any focused form elements
        document.activeElement.blur();

        const langNCurDrawer = this.drawer.querySelector('.lang--drawer.is-active')
        const drawerFixedHeader = this.drawer.querySelector('.drawer__fixed-header.is-removed-height')
        if (langNCurDrawer) langNCurDrawer.classList.remove('is-active')
        if (drawerFixedHeader) drawerFixedHeader.classList.remove('is-removed-height')

        this.drawer.setAttribute('inert', '');

        theme.utils.prepareTransition(this.drawer, function () {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));

        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.style.removeProperty('--scrollbar-width')

        if (!document.documentElement.classList.contains('trigger-from--drawer')) {
          document.documentElement.classList.add(this.config.closingClass);
        }

        window.setTimeout(function () {
          document.documentElement.classList.remove(this.config.closingClass);

          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            // Don't steal focus when transitioning from drawer to search
            if (!document.documentElement.classList.contains('trigger-from--drawer')) {
              this.activeSource.focus();
            }
          }
        }.bind(this), 500);

        this.isOpen = false;

        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });

        this.unbindEvents();

        const accords = this.drawer.querySelectorAll('.accordion-collapse.show')
        const accordsTrigger = this.drawer.querySelectorAll('.accordion-button[aria-expanded="true"]')
        accords.forEach(_ => {
          _.classList.remove('show')
        })
        accordsTrigger.forEach(_ => {
          _.classList.add('collapsed')
          _.setAttribute('aria-expanded', false)
        })
      },
      bindEvents: function () {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function (evt) {
          this.close(evt)
          return;
        }.bind(this));

        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));

        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },

      unbindEvents: function () {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);

        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });

    return Drawers;
  })();

  theme.Modals = (function () {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {
        return false;
      }

      this.modalContent = this.modal.querySelector('.modal__inner');

      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function () {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });

      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function () {
        this.close();
      }.bind(this));
    };

    Modal.prototype.open = function (evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);

      document.documentElement.classList.add(...this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: 'modal_focus'
      });

      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));

      this.bindEvents();
    };

    Modal.prototype.close = function (evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);

      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(function () {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 350); // modal close css transition (--motion-panel-out + buffer)

      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });

      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function () {
      window.on('keyup.modal', function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function () {
      document.documentElement.off('.modal');

      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };

    return Modal;
  })();

  /*============================================================================
    ParallaxImage
  ==============================================================================*/

  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      this.parallaxImage = this.querySelector('[data-parallax-image]');
      this.windowInnerHeight = window.innerHeight;
      this.isActive = false;
      this.timeout = null;
      this.directionMap = {
        right: 0,
        top: 90,
        left: 180,
        bottom: 270
      }
      this.directionMultipliers = {
        0: [1, 0],
        90: [0, -1],
        180: [-1, 0],
        270: [0, 1]
      }

      this._boundScrollHandler = () => this.scrollHandler();

      this.init();
      window.addEventListener('scroll', this._boundScrollHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._boundScrollHandler);
      if (this.timeout) clearTimeout(this.timeout);
    }

    getParallaxInfo() {
      const { width, height, top } = this.parallaxImage.getBoundingClientRect();
      let element = this.parallaxImage;
      let multipliers;
      let { angle, movement } = element.dataset;

      let movementPixels = angle === 'top' ? Math.ceil(height * (parseFloat(movement) / 100)) : Math.ceil(width * (parseFloat(movement) / 100));

      // angle has shorthands "top", "left", "bottom" and "right"
      // nullish coalescing. using `||` here would fail for `0`
      angle = this.directionMap[angle] ?? parseFloat(angle);

      // fallback if undefined
      // NaN is the only value that doesn't equal itself
      if (angle !== angle) angle = 270; // move to bottom (default parallax effect)
      if (movementPixels !== movementPixels) movementPixels = 100; // 100px

      // check if angle is located in top half and/or left half
      angle %= 360;
      if (angle < 0) angle += 360

      const toLeft = angle > 90 && angle < 270;
      const toTop = angle < 180;

      element.style[toLeft ? 'left' : 'right'] = 0;
      element.style[toTop ? 'top' : 'bottom'] = 0;

      // if it's not a perfectly horizontal or vertical movement, get cos and sin
      if (angle % 90) {
        const radians = angle * Math.PI / 180
        multipliers = [Math.cos(radians), Math.sin(radians) * -1] // only sin has to be inverted
      } else {
        multipliers = this.directionMultipliers[angle];
      }

      // increase width and height according to movement and multipliers
      if (multipliers[0]) element.style.width = `calc(100% + ${movementPixels * Math.abs(multipliers[0])}px)`;
      if (multipliers[1]) element.style.height = `calc(100% + ${movementPixels * Math.abs(multipliers[1])}px)`;

      return {
        element,
        movementPixels,
        multipliers,
        top,
        height
      }
    }

    init() {
      const { element, movementPixels, multipliers, top, height } = this.getParallaxInfo();

      const scrolledInContainer = this.windowInnerHeight - top;
      const scrollArea = this.windowInnerHeight + height;
      const progress = scrolledInContainer / scrollArea;

      if (progress > -0.1 && progress < 1.1) {
        const position = Math.min(Math.max(progress, 0), 1) * movementPixels;
        element.style.transform = `translate3d(${position * multipliers[0]}px, ${position * multipliers[1]}px, 0)`;
      }

      if (this.isActive) requestAnimationFrame(this.init.bind(this));
    }

    scrollHandler() {
      if (this.isActive) {
        clearTimeout(this.timeout);
      } else {
        this.isActive = true;
        requestAnimationFrame(this.init.bind(this));
      }

      this.timeout = setTimeout(() => this.isActive = false, 20);
    }
  }

  customElements.define('parallax-image', ParallaxImage);


  theme.AjaxProduct = (function () {
    var status = {
      loading: false
    };

    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;

      var submitSelector = submit ? submit : '.add-to-cart';

      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.addToCartMirror = form.querySelector('.add-to-cart--sticky')
        this.addToCartSecondary = document.querySelector('[data-add-to-cart-secondary]')
        this.form.addEventListener('submit', this.addItemFromForm.bind(this));
      }

      this.init()
    };

    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      init: function () {
        if (this.addToCartSecondary) {
          this.addToCartSecondary.addEventListener('click', () => {
            this.form.dispatchEvent(new Event('submit'))
          })
        }
      },
      addItemFromForm: function (evt, callback) {
        evt.preventDefault();
        let selectedList = []
        let isSelected = false

        const optionSelectors = document.querySelectorAll('.option-selector--wrapper')
        optionSelectors.forEach(selector => {
          const list = selector.querySelector('.option--list')
          const selected = list.dataset.selected
          if (selected == 'true') { selectedList.push('true') }
          else { selectedList.push('false') }
        })
        if (!selectedList.includes('false')) isSelected = true

        if (isSelected) {
          // Defensive: `status` was a stray reference that silently bound to window.status
          // (the deprecated browser status-bar string), so the double-click guard never
          // worked. Lazy-init instance state if no constructor has done it yet.
          this.status = this.status || { loading: false };
          if (this.status.loading) {
            return;
          }

          // Loading indicator on add to cart button.
          // addToCartSecondary is OPTIONAL: it lives inside the variant picker
          // (variant-dropdown.liquid), which is not rendered when there is no size to
          // choose — one-size "OS" products suppress the whole picker block. init()
          // already null-guards it; these state updates must too, or submitting the
          // form on such a product throws here and silently blocks add-to-cart.
          this.addToCart.classList.add('btn--loading');
          this.addToCartSecondary?.classList.add('btn--loading');
          this.addToCartMirror?.classList.add('btn--loading');

          this.status.loading = true;

          var data = theme.utils.serialize(this.form);
          var _self = this;
          fetch(theme.routes.cartAdd, {
            method: 'POST',
            body: data,
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
            .then(response => response.json())
            .then(function (data) {
              if (data.status === 422) {
                _self.error(data);
              } else {
                var product = data;
                _self.success(product);
              }

              _self.status.loading = false;
              _self.addToCart.classList.remove('btn--loading');
              _self.addToCartSecondary?.classList.remove('btn--loading');
              _self.addToCartMirror?.classList.remove('btn--loading');

              _self.addToCart.classList.add('btn--success');
              _self.addToCartSecondary?.classList.add('btn--success');
              _self.addToCartMirror?.classList.add('btn--success');

              const optionSelectors = document.querySelectorAll('.option-selector--wrapper')


              setTimeout(() => {
                this.addToCart.classList.remove('btn--success');
                this.addToCartSecondary?.classList.remove('btn--success');
                this.addToCartMirror?.classList.remove('btn--success');

                if (optionSelectors[0]) {
                  if (optionSelectors[0].classList.contains('open')) optionSelectors[0].classList.remove('open')
                }
                if (optionSelectors[1]) {
                  if (optionSelectors[1].classList.contains('open')) optionSelectors[1].classList.remove('open')
                }
                if (optionSelectors[2]) {
                  if (optionSelectors[2].classList.contains('open')) optionSelectors[2].classList.remove('open')
                }

                const event = new Event('selector:close')
                document.dispatchEvent(event)
              }, 1600)

              // Reload page if adding product from a section on the cart page
              if (document.body.classList.contains('template-cart')) {
                window.scrollTo(0, 0);
                location.reload();
              }
            }.bind(this));
        }
        else {
          if (window.innerWidth > 768) {
            const drawerTrigger = document.querySelector('.js-drawer-open-option')
            drawerTrigger.click()
          }

          const optionSelectors = document.querySelectorAll('.option-selector--wrapper')
          if (!optionSelectors[0].classList.contains('open')) optionSelectors[0].classList.add('open')
          const event = new Event('selector:open')
          document.dispatchEvent(event)
        }
      },

      success: function (product) {
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: this.addToCart
          }
        }));

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
            detail: {
              product: product,
              addToCartBtn: this.addToCart
            }
          }));
        }
      },

      error: function (error) {
        if (!error.description) {
          console.warn(error);
          return;
        }

        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement('div');
        errorDiv.classList.add('errors', 'text-center');
        errorDiv.textContent = error.description;
        this.form.append(errorDiv);

        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: error.description
          }
        }));

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
            detail: {
              errorMessage: error.description
            }
          }));
        }
      }
    });

    return ProductForm;
  })();

  theme.ProductMedia = (function () {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};

    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };

      modelViewerContainers.forEach(function (container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;

        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId
          };
        }

        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement
        };

      });

      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);

      theme.LibraryLoader.load('modelViewerUiStyles');
    }

    function setupShopifyXr(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function () {
          setupShopifyXr();
        });
        return;
      }

      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];

          if (modelSection.loaded) continue;

          var modelJson = document.querySelector('#ModelJson-' + sectionId);

          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
      if (errors) return;

      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];

      model.container.addEventListener('mediaVisible', function () {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });

      model.container.addEventListener('mediaHidden', function () {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });

      model.container.addEventListener('xrLaunch', function () {
        model.modelViewerUi.pause();
      });
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }

    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();

  theme.QtySelector = (function () {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;

      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function () {
        if (!this.plus.hasListenerAttached) {
          this.plus.addEventListener('click', function () {
            var qty = this._getQty();
            this._change(qty + 1);
          }.bind(this));
          this.plus.hasListenerAttached = true
        }


        if (!this.minus.hasListenerAttached) {
          this.minus.addEventListener('click', function () {
            var qty = this._getQty();
            this._change(qty - 1);
          }.bind(this));
          this.minus.hasListenerAttached = true
        }

        this.input.addEventListener('change', function (evt) {
          this._change(this._getQty());
        }.bind(this));
      },

      _getQty: function () {
        var qty = this.input.value;
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },

      _change: function (qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        this.input.value = qty;
        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
            detail: [this.options.key, qty, this.wrapper]
          }));
        }
      }
    });

    return QtySelector;
  })();

  theme.initQuickShop = function () {
    var ids = [];
    var products = document.querySelectorAll('.grid-product');

    if (!products.length || !theme.settings.quickView) {
      return;
    }

    products.forEach(product => {
      product.addEventListener('mouseover', productMouseover);
    });

    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');
        theme.preloadProductModal(handle, productId, btn);
      }
    }
  };

  theme.preloadProductModal = function (handle, productId, btn) {
    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = theme.routes.home + '/products/' + handle + '?view=modal';

    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');

    fetch(url).then(function (response) {
      return response.text();
    }).then(function (html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var div = doc.querySelector('.product-section[data-product-handle="' + handle + '"]');

      if (!holder) {
        return;
      }

      holder.innerHTML = '';
      holder.append(div);

      // Setup quick view modal
      var modalId = 'QuickShopModal-' + productId;
      var name = 'quick-modal-' + productId;
      new theme.Modals(modalId, name);

      // Register product template inside quick view
      theme.sections.register('product', theme.Product, holder);

      // Register collapsible elements
      theme.collapsibles.init();

      // Register potential video modal links (when video has sound)
      theme.videoModal();

      if (btn) {
        btn.classList.remove('quick-product__btn--not-ready');
      }
    });
  }

  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function () {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active'
    };

    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };

    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true
    };

    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);

      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      if (this.args.avoidReflow) {
        avoidReflow(el);
      }

      this.slideshow = new Flickity(el, this.args);

      // Prevent dragging on the product slider from triggering a zoom on product images
      if (el.dataset.zoom && el.dataset.zoom === 'true') {
        this.slideshow.on('dragStart', () => {
          this.slideshow.slider.style.pointerEvents = 'none';

          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'none';
          }
        });
        this.slideshow.on('dragEnd', () => {
          this.slideshow.slider.style.pointerEvents = 'auto';

          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'auto';
          }
        });
      }

      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }

      // Reset dimensions on resize
      window.on('resize', theme.utils.debounce(300, function () {
        this.resize();
      }.bind(this)));

      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while (firstChild != null && firstChild.nodeType == 3) { // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }

    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function (el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }

        if (window.AOS) { AOS.refresh() }
      },

      slideChange: function (index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener('transitionend', function () {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this));
        }

        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }

        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }

        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function (index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function () {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach(a => {
            a.classList.remove(classes.isActive);
          });
        }

        this.slideshow.destroy();
      },
      reposition: function () {
        this.slideshow.reposition();
      },
      _togglePause: function () {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function () {
        this.slideshow.resize();
      },
      play: function () {
        this.slideshow.playPlayer();
      },
      pause: function () {
        this.slideshow.pausePlayer();
      },
      goToSlide: function (i) {
        this.slideshow.select(i);
      },
      setDraggable: function (enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },

      initChildNav: function () {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');

        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);

          link.addEventListener('click', function (evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function (evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function (evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });

        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });
        }
      },

      getChildIndex: function (target) {
        return parseInt(target.dataset.index);
      },

      childNavGoTo: function (index) {
        this.childNavLinks.forEach(a => {
          a.blur();
          a.classList.remove(classes.isActive);
        });

        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);

        if (!this.args.childNavScroller) {
          return;
        }

        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },

      arrowClick: function (evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });

    return slideshow;
  })();

  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, use the Variant Picker Block setting
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/

  theme.VariantAvailability = (function () {
    var classes = {
      disabled: 'disabled'
    };

    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;
      this.init();
    }

    availability.prototype = Object.assign({}, availability.prototype, {
      init: function () {
        this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));

        // Set default state based on current selected variant
        this.setInitialAvailability();
      },

      // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
      createAvailableOptionsTree(variants, currentlySelectedValues) {
        // Reduce variant array into option availability tree
        return variants.reduce((options, variant) => {

          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {
            if (variant[index] === null) return;

            let entry = options[index].find(option => option.value === variant[index]);

            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = { value: variant[index], soldOut: true }
              options[index].push(entry);
            }

            const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1')
            const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2')

            switch (index) {
              case 'option1':
                // Option1 inputs should always remain enabled based on all available variants
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                break;
              case 'option2':
                // Option2 inputs should remain enabled based on available variants that match first option group
                if (currentOption1 && variant['option1'] === currentOption1.value) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
              case 'option3':
                // Option 3 inputs should remain enabled based on available variants that match first and second option group
                if (
                  currentOption1 && variant['option1'] === currentOption1.value
                  && currentOption2 && variant['option2'] === currentOption2.value
                ) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
            }
          })

          return options;
        }, { option1: [], option2: [], option3: [] })
      },

      setInitialAvailability: function () {
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          this.disableVariantGroup(group);
        });

        const currentlySelectedValues = this.currentVariantObject.options.map((value, index) => { return { value, index: `option${index + 1}` } })
        const initialOptions = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, this.currentVariantObject);

        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      },

      setAvailability: function (evt) {

        const { value: lastSelectedValue, index: lastSelectedIndex, currentlySelectedValues, variant } = evt.detail;

        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        const valuesToManage = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, variant, lastSelectedIndex, lastSelectedValue)

        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values, lastSelectedValue);
        }
      },

      manageOptionState: function (option, values) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="' + option + '"]');

        // Loop through each option value
        values.forEach(obj => {
          this.addSoldOutText(group, obj)
          this.enableVariantOption(group, obj);
        });
      },
      addSoldOutText: function (group, option) {
        if (option.soldOut) {
          const el = group.querySelector('option[value="' + option.value + '"]')
          // Build via DOM nodes instead of innerHTML so merchant-supplied
          // option.value can't break out of the <span> as HTML. Also pull
          // "Out of stock" from theme.strings.soldOut (already translated)
          // instead of hardcoding English.
          if (el) {
            const valueSpan = document.createElement('span')
            valueSpan.textContent = option.value
            const stockSpan = document.createElement('span')
            stockSpan.className = 'stock--availability'
            stockSpan.textContent = ' ' + (theme.strings.soldOut || 'Out of stock')
            el.replaceChildren(valueSpan, stockSpan)
          }
        }
      },
      enableVariantOption: function (group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');

        if (this.type === 'dropdown') {
          if (obj.soldOut) {
            group.querySelector('option[value="' + value + '"]').disabled = true;
          } else {
            group.querySelector('option[value="' + value + '"]').disabled = false;
          }
        } else {
          var buttonGroup = group.querySelector('.variant-input[data-value="' + value + '"]');
          var input = buttonGroup.querySelector('input');
          var label = buttonGroup.querySelector('label');

          // Variant exists - enable & show variant
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);

          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
        }

      },

      disableVariantGroup: function (group) {
        if (this.type === 'dropdown') {
          group.querySelectorAll('option').forEach(option => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll('input').forEach(input => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll('label').forEach(label => {
            label.classList.add(classes.disabled);
          });
        }
      }

    });

    return availability;
  })();

  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function () {
    var youtubePlayer;
    var vimeoPlayer;

    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };

    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var vimeoTriggers = document.querySelectorAll(selectors.vimeo);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

    if (!youtubeTriggers.length && !vimeoTriggers.length && !mp4Triggers.length) {
      return;
    }

    var videoHolderDiv = document.getElementById(videoHolderId);

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }

    if (vimeoTriggers.length) {
      theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
    }

    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      bodyOpenClass: ['modal-open', 'video-modal-open'],
      solid: true
    });

    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });

    vimeoTriggers.forEach(btn => {
      btn.addEventListener('click', triggerVimeoModal);
    });

    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });

    document.addEventListener('modalClose.VideoModal', closeVideoModal);

    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }

    function triggerVimeoModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.vimeoReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = evt.currentTarget.dataset.videoId;
      var videoLoop = evt.currentTarget.dataset.videoLoop;
      vimeoPlayer = new theme.VimeoPlayer(
        videoHolderId,
        videoId,
        {
          style: 'sound',
          loop: videoLoop,
        }
      );
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder();

      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);

      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');

      videoHolderDiv.append(playerClone);
      modal.open(evt);

      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }

    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match && match[7].length == 11) ? match[7] : false;
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else if (vimeoPlayer && typeof vimeoPlayer.destroy === 'function') {
        vimeoPlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };


  /*============================================================================
    ToolTip
  ==============================================================================*/

  class ToolTip extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.inner = this.querySelector('[data-tool-tip-inner]');
      this.closeButton = this.querySelector('[data-tool-tip-close]');
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.toolTipTitle = this.querySelector('[data-tool-tip-title]');

      this.triggers = document.querySelectorAll('[data-tool-tip-trigger]');

      document.addEventListener('tooltip:open', e => {
        this._open(e.detail.context, e.detail.content);
      });
    }

    _open(context, insertedHtml) {
      this.toolTipContent.innerHTML = insertedHtml;

      // Ensure we set a title for product availability
      if (context != 'store-availability') {
        this.toolTipTitle.remove();
      }

      this._lockScrolling();

      if (this.closeButton) {
        this.closeButton.on('click' + '.tooltip-close', () => {
          this._close();
        });
      }

      document.documentElement.on('click' + '.tooltip-outerclick', event => {
        if (this.el.dataset.toolTipOpen === 'true' && !this.inner.contains(event.target)) this._close();
      });

      document.documentElement.on('keydown' + '.tooltip-esc', event => {
        if (event.code === 'Escape') this._close();
      });

      this.el.dataset.toolTipOpen = true;
      this.el.dataset.toolTip = context;
    }

    _close() {
      this.toolTipContent.innerHTML = '';
      this.el.dataset.toolTipOpen = 'false';
      this.el.dataset.toolTip = '';

      this._unlockScrolling();

      this.closeButton.off('click' + '.tooltip-close');
      document.documentElement.off('click' + '.tooltip-outerclick');
      document.documentElement.off('keydown' + '.tooltip-esc');
    }

    _lockScrolling() {
      theme.a11y.trapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });

      theme.a11y.lockMobileScrolling();
      document.documentElement.classList.add('modal-open');
    }

    _unlockScrolling() {
      theme.a11y.removeTrapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });

      theme.a11y.unlockMobileScrolling();
      document.documentElement.classList.remove('modal-open');
    }
  }

  customElements.define('tool-tip', ToolTip);

  /*============================================================================
    ToolTipTrigger
  ==============================================================================*/

  class ToolTipTrigger extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.init();
    }

    init() {
      const toolTipOpen = new CustomEvent('tooltip:open', {
        detail: {
          context: this.dataset.toolTip,
          content: this.toolTipContent.innerHTML
        },
        bubbles: true
      });

      this.el.addEventListener('click', e => {
        e.stopPropagation();
        this.dispatchEvent(toolTipOpen);
      });
    }
  }

  customElements.define('tool-tip-trigger', ToolTipTrigger);

  theme.announcementBar = (function () {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left'
    };
    var bar;
    var flickity;

    function init() {
      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }

      unload();

      // A single announcement block needs no slider. dataset values are
      // always strings, so compare against '1' — the old `=== 1` never
      // matched and a 1-block bar initialized Flickity for nothing.
      if (bar.dataset.blockCount === '1') {
        return;
      }

      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }

      document.addEventListener('matchSmall', function () {
        unload();
        initSlider();
      });

      document.addEventListener('unmatchSmall', function () {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
    }

    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }

    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);

      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }

    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play();
      }
    }

    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();

  theme.customerTemplates = function () {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }

    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }

      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');

      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }

      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');

      if (!newAddressForm || !addressForms.length) {
        return;
      }

      // Country/province selector can take a short time to load
      setTimeout(function () {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;

          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);

      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function () {
          newAddressForm.classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;

          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
            }
          }
        })
      });
    }
  };

  theme.CartDrawer = (function () {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };

    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');

      this.init();
    }

    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function () {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();

        document.addEventListener('ajaxProduct:added', function (evt) {
          this.cartForm.buildCart();
          if (theme.settings.cartType === 'drawer') {
            this.open();
          }
        }.bind(this));

        // Dev-friendly way to open cart
        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },

      open: function () {
        this.drawer.open();
      },

      close: function () {
        this.drawer.close();
      }
    });

    return CartDrawer;
  })();

  theme.headerNav = (function () {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      searchBtnTrigger: '.slide-nav__search-trigger',
      closeSearch: '#SearchClose',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      megamenu: '.megamenu',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };

    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };

    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--sticky',
      announcementBarHeight: 0,
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };

    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;

    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);

      const headerEl = document.querySelector('.header-group--main-header')

      const elementRect = headerEl.getBoundingClientRect();
      const scrollPosition = window.scrollY;

      if (scrollPosition >= 10) {
        siteHeader.classList.add('sticky--active')
      }
      else {
        siteHeader.classList.remove('sticky--active')
      }

      // Header state must CONVERGE after browser scroll restoration, which
      // can land before this script runs (fast loads) or seconds after
      // first paint (slow loads) — and whose scroll event is missed when
      // the guarded/throttled listener isn't ready or enabled. The check
      // above runs once, at whatever scroll position happens to be current;
      // on a slow reload that's 0 (pre-restore), leaving the header in the
      // wrong mode until the first touch — the "header flashes on reload"
      // bug. scrollHandler is idempotent, so re-run it at every settle
      // point, with the header's transitions suppressed (--settling) so a
      // late correction PAINTS the right state instead of animating to it.
      function settleHeaderState() {
        if (!siteHeader) return;
        siteHeader.classList.add('site-header--settling');
        scrollHandler();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            siteHeader.classList.remove('site-header--settling');
          });
        });
      }
      window.on('load' + config.namespace, settleHeaderState);
      window.on('pageshow' + config.namespace, settleHeaderState);
      // Restoration itself fires a scroll event — catch the very first one
      // unguarded (the throttled listener may be disabled or not yet bound).
      window.addEventListener('scroll', settleHeaderState, { once: true, passive: true });
      // Convergence poll: under slow network the ordering of restoration vs
      // this script is racy (restoration can precede the scroll binding,
      // and the load event trails image downloads by seconds). A few
      // idempotent, paint-only re-checks guarantee the header settles
      // within ~1.5s of the script running, whatever the ordering.
      settleHeaderState();
      setTimeout(settleHeaderState, 100);
      setTimeout(settleHeaderState, 500);
      setTimeout(settleHeaderState, 1500);

      const announcementBar = document.querySelector('.announcement-bar')
      if (announcementBar) config.announcementBarHeight = announcementBar.clientHeight

      if (window.innerWidth > 768) {
        if (announcementBar) {
          config.announcementBarHeight = 250
        }
        else {
          config.announcementBarHeight = 200
        }
      }

      config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
        stickyHeaderCheck();
      }

      theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
          this.disableOverlayHeader();
        }
      }

      accessibleDropdowns();
      searchDrawer();

      window.on('load' + config.namespace, resizeLogo);
      window.on('resize' + config.namespace, theme.utils.debounce(150, resizeLogo));
    }

    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }

    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();

      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }

    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });

      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }

      return true;
    }

    function stickyHeader() {
      config.lastScroll = 0;

      var wrapWith = document.createElement('div');
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);

      stickyHeaderHeight();

      window.on('resize' + config.namespace, theme.utils.debounce(50, stickyHeaderHeight));
      window.on('scroll' + config.namespace, theme.utils.throttle(20, stickyHeaderScroll));

      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function () {
          stickyHeaderHeight();
        }, 250);
      }
    }

    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }

      var h = siteHeader.offsetHeight;

      // If sticky header is 'active' i.e. we have scrolled a bit down the page
      // the site header has 20px less padding when sticky
      // and this is not factored into the height calculation
      // The 20px is what causes the header to overlap the announcement bar
      // This only applies when the height is being calculated on larger screen sizes
      if (siteHeader.classList.contains('site-header--stuck') && !theme.config.bpSmall) {
        let siteHeaderPadding = parseFloat(window.getComputedStyle(siteHeader, null).getPropertyValue('padding-top'));
        h += siteHeaderPadding * 2;
      }

      // stickyHeaderWrapper is created lazily by stickyHeader() only if the
      // mega menu fits. The 250ms editor-mode setTimeout can fire before that
      // — bail out if the wrapper isn't there yet rather than throwing.
      var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
      if (stickyHeader) stickyHeader.style.height = h + 'px';
    }

    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }

      if (config.forceStopSticky) {
        return;
      }

      requestAnimationFrame(scrollHandler);

      config.lastScroll = window.scrollY;

      // Trailing call: ensures final scroll position is captured
      // even when the leading-only throttle drops the last event
      clearTimeout(config.scrollTrailingTimeout);
      config.scrollTrailingTimeout = setTimeout(function() {
        requestAnimationFrame(scrollHandler);
      }, 40);
    }

    function scrollHandler() {
      const headerEl = document.querySelector('.header-group--main-header');
      const stickyInner = document.querySelector(selectors.siteHeader);

      const elementOffsetTop = headerEl.offsetTop; // Distance from the top of the document
      const scrollPosition = window.scrollY; // Current scroll position

      if (scrollPosition >= 10) {
        stickyInner.classList.add('sticky--active');
      } else {
        stickyInner.classList.remove('sticky--active');
      }
    }

    // Mega menu dropdown system for desktop navigation.
    // mouseleave is bound to the parent <li> (not the <a>) with a 150ms debounced close,
    // giving the cursor time to cross any gap between the link and the dropdown.
    // When switching between mega menus, transitions are suppressed for an instant swap
    // (no fade-out + fade-in, just content change — perceived as one persistent panel).
    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;

      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        document.querySelectorAll(selectors.navLinksWithDropdown).forEach(el => {
          el.on('touchend' + config.namespace, function (evt) {
            var parent = evt.currentTarget.parentNode;
            if (!parent.classList.contains(classes.dropdownActive)) {
              evt.preventDefault();
              closeDropdowns();
              openFirstLevelDropdown(evt.currentTarget);
            } else {
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        });
      }

      // Open/hide top level dropdowns
      var dropdownCloseTimeout = null;

      document.querySelectorAll(selectors.navLinks).forEach(el => {
        el.on('focusin' + config.namespace, accessibleMouseEvent);
        el.on('mouseover' + config.namespace, accessibleMouseEvent);
      });

      // Close dropdowns on mouseleave from parent <li>, not the <a> link.
      // Uses a short delay so the cursor can cross any gap to reach the dropdown.
      document.querySelectorAll(selectors.navItems).forEach(el => {
        el.on('mouseenter' + config.namespace, function() {
          if (dropdownCloseTimeout) {
            clearTimeout(dropdownCloseTimeout);
            dropdownCloseTimeout = null;
          }
        });
        el.on('mouseleave' + config.namespace, function() {
          dropdownCloseTimeout = setTimeout(function() {
            closeDropdowns();
            dropdownCloseTimeout = null;
          }, 150);
        });
      });

      document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
        if (theme.config.isTouch) {
          el.on('touchend' + config.namespace, function (evt) {
            var parent = evt.currentTarget.parentNode;

            // Open third level menu or go to link based on active state
            if (parent.classList.contains(classes.hasSubDropdownClass)) {
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeThirdLevelDropdown();
                openSecondLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute('href'));
              }
            } else {
              // No third level nav, go to link
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        }

        // Open/hide sub level dropdowns
        el.on('focusin' + config.namespace, function (evt) {
          closeThirdLevelDropdown();
          openSecondLevelDropdown(evt.currentTarget, true);
        })
      });

      // Clicking outside of the megamenu should close it
      if (theme.config.isTouch) {
        document.body.on('touchend' + config.namespace, function () {
          closeDropdowns();
        });

        // Exception to above: clicking anywhere on the megamenu content will NOT close it
        siteHeader.querySelectorAll(selectors.megamenu).forEach(el => {
          el.on('touchend' + config.namespace, function (evt) {
            evt.stopImmediatePropagation();
          });
        });
      }

      function accessibleMouseEvent(evt) {
        var newParent = evt.currentTarget.parentNode;
        var currentMega = document.querySelector('.site-nav--is-megamenu.is-focused');
        var switchingMegas = currentMega
          && newParent !== currentMega
          && newParent.classList.contains('site-nav--is-megamenu');

        if (switchingMegas) {
          var outgoing = currentMega.querySelector('.megamenu');
          var incoming = newParent.querySelector('.megamenu');
          if (outgoing) outgoing.classList.add('megamenu-switching');
          if (incoming) incoming.classList.add('megamenu-switching');

          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              if (outgoing) outgoing.classList.remove('megamenu-switching');
              if (incoming) incoming.classList.remove('megamenu-switching');
            });
          });
        }

        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }

        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }

        openFirstLevelDropdown(evt.currentTarget);
      }

      // Private dropdown functions
      function openFirstLevelDropdown(el) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasDropdownClass)) {
          parent.classList.add(classes.dropdownActive);
          hasActiveDropdown = true;
        }

        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            document.documentElement.on(eventType + config.namespace, function () {
              closeDropdowns();
              document.documentElement.off(eventType + config.namespace);
              closeOnClickActive = false;
            }.bind(this));
          }
        }
      }

      function openSecondLevelDropdown(el, skipCheck) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasSubDropdownClass) || skipCheck) {
          parent.classList.add(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }

      function closeDropdowns() {
        if (dropdownCloseTimeout) {
          clearTimeout(dropdownCloseTimeout);
          dropdownCloseTimeout = null;
        }
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }

      function closeSecondLevelDropdown() {
        document.querySelectorAll(selectors.navItems).forEach(el => {
          el.classList.remove(classes.dropdownActive)
        });
      }

      function closeThirdLevelDropdown() {
        document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
          el.parentNode.classList.remove(classes.dropdownActive);
        });
      }
    }

    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', openSearchDrawer);
      });

      document.querySelectorAll(selectors.searchBtnTrigger).forEach(btn => {
        btn.addEventListener('click', triggerSearchDrawer);
      });

      document.querySelector(selectors.closeSearch).addEventListener('click', closeSearchDrawer);
    }

    function triggerSearchDrawer(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();

      var drawerClose = document.querySelector('.js-drawer-close');

      document.documentElement.classList.add('trigger-from--drawer');
      window.startTracking = false;
      if (drawerClose) drawerClose.click();

      // Open search immediately (no setTimeout) to keep .focus()
      // in the user gesture chain — required for mobile keyboard
      openSearchDrawerDirect();
    }

    function openSearchDrawer(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      openSearchDrawerDirect();
    }

    function openSearchDrawerDirect() {
      var container = document.querySelector(selectors.searchContainer);
      container.classList.add('is-active');

      document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');

      // Prevent mobile zoom on input focus
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width,initial-scale=1.0,maximum-scale=1.0');
      }

      // Focus input immediately for mobile keyboard support
      var input = container.querySelector('.site-header__search-input');
      if (input) {
        // RAF gives browser one frame to paint the container before focusing,
        // avoiding a forced synchronous reflow while still ensuring focus works.
        requestAnimationFrame(() => input.focus());
      }

      // Set up focus trap after drawer animation completes
      setTimeout(function () {
        theme.a11y.trapFocus({
          container: container,
          namespace: 'header_search',
          elementToFocus: input
        });
      }, 600);

      theme.a11y.lockMobileScrolling(config.namespace);

      bindSearchEvents();
    }

    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }

            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      if (document.documentElement.classList.contains('trigger-from--drawer')) {
        document.documentElement.classList.remove('js-drawer-open--search', 'trigger-from--drawer');
        var jsDrawerOpen = document.querySelector('.js-drawer-open-nav')
        if (jsDrawerOpen) {
          document.documentElement.classList.add('trigger-from-search-close', 'track-collection-filter');
          document.dispatchEvent(new CustomEvent('drawer-open', { detail: { target: jsDrawerOpen } }));
          window.startTracking = true
          window.setTimeout(function () {
            window.startTracking = false
          }, 1000)
        }
      }
      else {
        document.documentElement.classList.add('js-drawer-closing');
        document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
      }

      window.setTimeout(function () {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);

      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function () {
        container.classList.remove('is-active');
      }.bind(this));

      theme.a11y.removeTrapFocus({
        container: container,
        namespace: 'header_search'
      });

      // Restore normal viewport zoom
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width,initial-scale=1.0');
      }

      theme.a11y.unlockMobileScrolling(config.namespace);

      unbindSearchEvents();
    }

    function bindSearchEvents() {
      window.on('keyup' + config.namespace, function (evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      }.bind(this));

      // Clicking out of container closes it
      document.documentElement.on('click' + config.namespace, function (evt) {
        closeSearchDrawer(evt);
      }.bind(this));
    }

    function unbindSearchEvents() {
      window.off('keyup' + config.namespace);
      document.documentElement.off('click' + config.namespace);
    }

    function resizeLogo(evt) {
      document.querySelectorAll(selectors.logo).forEach(logo => {
        var logoWidthOnScreen = logo.clientWidth;
        var containerWidth = logo.closest('.header-item').clientWidth;

        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          logo.style.maxWidth = containerWidth;
        }
        else {
          logo.removeAttribute('style')
        }
      });
    }
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader
    };
  })();

  window.onpageshow = function (evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });
    }
  };

  theme.predictiveSearch = (function () {
    var currentString = '';
    // Holds the AbortController for the in-flight suggest request so a newer
    // query/scope can cancel a stale one before it renders.
    var predictController = null;
    var searchTimeout;
    var namespace = '.predictive';

    var selectors = {
      form: '#HeaderSearchForm',
      input: 'input[type="search"]',
      wrapper: '#PredictiveWrapper',
      resultDiv: '#PredictiveResults',
      searchButton: '[data-predictive-search-button]'
    };

    var cache = {};
    var config = {
      imageSize: 'square'
    }

    var classes = {
      isActive: 'predicitive-active'
    };

    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9
    };

    // Whether we've already warned about a tags-less suggest payload —
    // warn once, not once per keystroke.
    var warnedMissingTags = false;

    /**
     * Escape user-controllable strings before they are interpolated into
     * innerHTML. suggest.json echoes merchant-set product title/vendor and
     * the product URL; without escaping, a crafted product name (e.g. one
     * containing `"><img onerror=…>`) could inject markup into the dropdown.
     * Applied at THIS mapping layer only — NOT inside the shared
     * theme.buildProductGridItem, whose other callers may already pass
     * pre-escaped data (escaping there would risk double-escaping). ES5 so
     * it lives comfortably in this legacy IIFE.
     */
    function escapeHtml(str) {
      if (str == null) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    /**
     * The gender the current search is scoped to. The hidden filter.p.tag
     * input in #HeaderSearchForm is the single source of truth (owned and
     * kept in sync by gender-context.js: cookie default + overlay toggle
     * override). Disabled input = unscoped search.
     */
    function currentSearchGender() {
      var input = document.querySelector('[data-gender-search-filter]');
      if (!input || input.disabled) return null;
      return input.value === 'men' || input.value === 'women' ? input.value : null;
    }

    /**
     * Gender gate for suggest.json product results. Fail-closed: if the API
     * stops returning tags, we hide products from a scoped dropdown rather
     * than leak cross-gender items (store rule: a women browser must NEVER
     * see a men-only product on a browsing surface).
     */
    function productMatchesGender(product, gender) {
      if (!gender) return true;
      if (!Array.isArray(product.tags)) {
        if (!warnedMissingTags) {
          console.warn('[predictive] suggest.json returned no tags array; hiding products from scoped search (fail-closed)');
          warnedMissingTags = true;
        }
        return false;
      }
      var tags = product.tags.map(function (t) { return String(t).toLowerCase(); });
      var hasMen = tags.indexOf('men') !== -1;
      var hasWomen = tags.indexOf('women') !== -1;
      if (!hasMen && !hasWomen) return true; // ungendered item
      return tags.indexOf(gender) !== -1;
    }

    /**
     * Gender gate for suggest.json collection results. Collections are
     * gendered by handle convention (…-men / …-women). Fail-closed: a
     * scoped dropdown shows ONLY collections carrying the matching
     * suffix, so a collection that skips the naming convention can never
     * leak into the wrong gender's suggestions (it just won't appear in
     * scoped dropdowns — the safe failure mode).
     */
    function collectionMatchesGender(collection, gender) {
      if (!gender) return true;
      var handle = collection.handle || '';
      var suffix = '-' + gender;
      return handle.slice(-suffix.length) === suffix;
    }

    function init() {
      // Only some languages support predictive search
      if (document.getElementById('shopify-features')) {
        var supportedShopifyFeatures = JSON.parse(document.getElementById('shopify-features').innerHTML);
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }

      cache.wrapper = document.querySelector(selectors.wrapper);

      if (!cache.wrapper) {
        return;
      }

      config.imageSize = cache.wrapper.dataset.imageSize;

      cache.form = document.querySelector(selectors.form);
      cache.form.setAttribute('autocomplete', 'off');
      cache.form.on('submit' + namespace, submitSearch);

      cache.input = cache.form.querySelector(selectors.input);
      cache.input.on('keyup' + namespace, handleKeyup);

      cache.submit = cache.wrapper.querySelector(selectors.searchButton);
      cache.submit.on('click' + namespace, triggerSearch);

      cache.results = document.querySelector(selectors.resultDiv);

      // Re-run the live query when the search scope or site gender flips —
      // the dropdown may be open with now-wrongly-scoped results. The
      // request key includes the scope, so this is never suppressed as a
      // duplicate.
      ['search-gender:changed', 'gender:changed'].forEach(function (evt) {
        document.addEventListener(evt, function () {
          if (cache.input && cache.input.value !== '') {
            // A scope flip invalidates any in-flight AND any rendered results.
            // Abort the live request, wipe the dropdown, and clear the dedupe
            // key BEFORE re-querying: otherwise the 500ms debounce could let an
            // old-scope response paint after the user picked a new scope, and a
            // failed replacement request would strand wrong-scope markup on
            // screen indefinitely (a cross-gender leak).
            if (predictController) predictController.abort();
            cache.results.innerHTML = '';
            currentString = '';
            search();
          }
        });
      });
    }

    function reset() {
      // Abort any in-flight suggest request: a response landing after the
      // dropdown was cleared must not repaint it (same supersession rule as
      // scope flips).
      if (predictController) predictController.abort();
      cache.results.innerHTML = '';
      clearTimeout(searchTimeout);
      // Clear the dedupe key so re-typing the same first query after the input
      // was emptied still fires a fresh request (the key is q+scope).
      currentString = '';
    }

    function triggerSearch() {
      cache.form.submit();
    }

    // Append * wildcard to search
    function submitSearch(evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;

      var obj = {};
      var formData = new FormData(evt.target);
      for (var key of formData.keys()) {
        obj[key] = formData.get(key);
      }

      if (obj.q) {
        obj.q += '*';
      }

      var params = paramUrl(obj);

      window.location.href = `${theme.routes.search}?${params}`;
      return false;
    }

    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        return;
      }

      if (evt.keyCode === keys.down_arrow) {
        return;
      }

      if (evt.keyCode === keys.tab) {
        return;
      }

      search();
    }

    function search() {
      var keyword = cache.input.value;

      if (keyword === '') {
        reset();
        return;
      }
      var q = _normalizeQuery(keyword);

      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }

    function predictQuery(q) {
      var searchGender = currentSearchGender();

      // Key the in-flight guard by query AND scope: the same q under a
      // different gender is a different search (the old guard suppressed
      // the refresh after a toggle flip).
      var requestKey = q + '|' + (searchGender || '');
      if (currentString === requestKey) {
        return;
      }
      currentString = requestKey;

      // No in-flight guard here on purpose: an early-return guard made
      // AbortController supersession unreachable while a request was live
      // (a slow stale-scope response could render over fresher results).
      // Abort + the scoped request key are the supersession mechanism.
      cache.results.classList.add('loading');

      var searchObj = {
        'q': q,
        // Only the types the dropdown renders (pages/articles were disabled
        // before this project and stay off) — no wasted payload.
        'resources[type]': 'product,collection',
        // Overfetch: the gender gate filters client-side, so ask for more
        // than we show to keep a scoped dropdown filled; capped at render.
        'resources[limit]': 8,
        // Apply that limit PER resource type. suggest.json's default limit
        // scope is 'all' (shared across product+collection combined), which
        // would let collections eat into our product budget and starve a
        // scoped dropdown. 'each' = up to 8 products AND 8 collections.
        'resources[limit_scope]': 'each',
        // Sold-out products are hidden on every browsing surface (store
        // policy; was 'last').
        'resources[options][unavailable_products]': 'hide',
        'resources[options][fields]': 'title,product_type,variants.title,vendor'
      };

      var params = paramUrl(searchObj);
      // Locale-aware root (replaces the old sv-only special case — the
      // store runs 8 locales). Shopify.routes.root is injected by
      // content_for_header on every OS 2.0 storefront.
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var url = root + 'search/suggest.json?';

      // Abort any in-flight suggest request: a slow response for a stale
      // query/scope must never render over fresher results.
      if (predictController) predictController.abort();
      predictController = new AbortController();

      fetch(url + params, { signal: predictController.signal })
        .then(response => response.json())
        .then(suggestions => {
          cache.results.classList.remove('loading');
          var data = {};
          var resultCount = 0;

          cache.wrapper.classList.remove('hide');
          var resultTypes = Object.entries(suggestions.resources.results);

          Object.keys(resultTypes).forEach(function (i) {
            var obj = resultTypes[i];
            var type = obj[0];
            var results = obj[1];

            // Scope suggestions to the active search gender BEFORE building
            // markup. suggest.json has no server-side filters, so this
            // client-side gate is the only thing standing between a women
            // browser and men-only suggestions. Cap at 4 AFTER filtering
            // (we overfetch 8 for exactly this reason).
            if (type == 'products') {
              var products = results.filter(function (p) {
                return productMatchesGender(p, searchGender);
              }).slice(0, 4);
              resultCount += products.length;
              data[type] = buildProducts(products);
            }

            if (type == 'collections') {
              var collections = results.filter(function (c) {
                return collectionMatchesGender(c, searchGender);
              }).slice(0, 4);
              resultCount += collections.length;
              data[type] = buildCollections(collections);
            }
          });

          if (resultCount === 0) {
            // Wipe results for THIS query only — a full reset() would clear
            // the shared debounce timer (a newer keystroke may already be
            // queued behind this response) and the dedupe key (letting the
            // identical zero-result q+scope re-fetch pointlessly).
            cache.results.innerHTML = '';
            return;
          }

          // Build and append result markup
          var output = buildOutput(data);
          cache.results.innerHTML = '';
          cache.results.innerHTML = output;
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          cache.results.classList.remove('loading');
          // Real (non-abort) failure: clear the dedupe key so the user can
          // retry the IDENTICAL q+scope — otherwise the request-key guard
          // would swallow the retry and leave the dropdown stuck empty.
          currentString = '';
        });
    }

    function buildProducts(results) {
      var output = '';
      var products = [];

      results.forEach(product => {
        // Null-safe media: a media-less product has no `featured_image` and
        // no `image`. Dereferencing featured_image.aspect_ratio unconditionally
        // would throw and kill the ENTIRE dropdown (all suggestions vanish).
        // When media is missing we default the image fields to empty/neutral:
        // theme.buildProductGridItem still renders the tile (title/vendor/price
        // via theme.buildProductImage's data-src=""), just without a thumbnail,
        // so the remaining suggestions survive. aspect_ratio defaults to 1
        // (square) to avoid a NaN in the padding-bottom sizing.
        var featuredImage = product.featured_image;
        var new_product = {
          // Escape merchant-controlled text/URL before it reaches innerHTML.
          title: escapeHtml(product.title),
          url: escapeHtml(product.url),
          image_responsive_url: product.image ? theme.Images.lazyloadImagePath(product.image) : '',
          image_aspect_ratio: featuredImage ? featuredImage.aspect_ratio : 1,
          vendor: escapeHtml(product.vendor),
          price_min: product.price_min,
        };

        products.push(new_product);
      });

      if (products.length) {
        var markup = theme.buildProductGridItem(products, 'small--one-half medium-up--one-quarter', 4, config.imageSize);

        output = `
          <div data-type-products>
            <div class="grid grid--uniform">
              ${markup}
            </div>
          </div>
        `;
      }

      return output;
    }

    function buildCollections(collections) {
      var output = '';

      if (collections.length) {
        var markup = theme.buildCollectionItem(collections);

        output = `
          <div data-type-collections>
            <p class="h6 predictive__label hidden">${theme.strings.searchCollections}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }

      return output;
    }

    // Combine all search result markup and print to page.
    // Only products and collections are built — predictQuery requests only
    // those resource types, so the old pages/articles builders were removed
    // as dead code (2026-07-11 cleanup).
    function buildOutput(data) {
      var output = '';

      if (data.products && data.products !== '') {
        output += data.products;
      }

      if (data.collections && data.collections !== '') {
        output += data.collections;
      }

      return output;
    }

    function _normalizeQuery(string) {
      if (typeof string !== 'string') {
        return null;
      }

      return string
        .trim()
        .replace(/\ /g, '-')
        .toLowerCase();
    }

    function paramUrl(obj) {
      return Object.keys(obj).map(function (key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }

    return {
      init: init
    };
  })();

  theme.buildProductGridItem = function (items, gridWidth, rowOf, imageSize) {
    var output = '';

    items.forEach(product => {
      var image = theme.buildProductImage(product, imageSize);

      let priceMarkup = '';
      let vendorMarkup = '';

      if (theme.settings.predictiveSearchPrice) priceMarkup = `<div class="grid-product__price">${theme.strings.productFrom}${theme.Currency.formatMoney(product.price_min, theme.moneyFormat)}</div>`;
      if (theme.settings.predictiveSearchVendor) vendorMarkup = `<div class="grid-product__vendor">${product.vendor}</div>`;

      var markup = `
        <div class="grid__item grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}">
          <div class="grid-product__content">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                ${vendorMarkup}
                <div class="grid-product__title">${product.title}</div>
                ${priceMarkup}
              </div>
            </a>
          </div>
        </div>
      `;

      output += markup;
    });

    return output;
  }

  theme.buildProductImage = function (product, imageSize, useOverlay) {
    var size = imageSize ? imageSize : theme.settings.productImageSize;
    var output = '';

    if (size === 'natural') {
      output = `
        <div class="image-wrap" style="height: 0; padding-bottom: ${product.image_aspect_ratio}%;">
          <img class="grid-product__image lazyload"
            data-src="${product.image_responsive_url}"
            data-widths="[180, 360, 540, 720, 900]"
            data-aspectratio="${product.image_aspect_ratio}"
            data-sizes="auto"
            alt="${product.title}">
        </div>`;
    } else {
      var classes = 'lazyload';
      if (!theme.settings.productImageCover) {
        classes += ' grid__image-contain';
      }
      output = `
        <div class="grid__image-ratio grid__image-ratio--${size}">
          <img class="${classes}"
              data-src="${product.image_responsive_url}"
              data-widths="[360, 540, 720, 900, 1080]"
              data-aspectratio="${product.image_aspect_ratio}"
              data-sizes="auto"
              alt="${product.title}">
        </div>
      `;
      if (product.images) {
        if (product.images.length > 1) {

          output = `
            ${output}
            <div class="grid-product__secondary-image small--hide">
              <img class="lazyload"
                  data-src="${product.media[1].preview_image.src}"
                  data-widths="[360, 540, 720, 900, 1080]"
                  data-aspectratio="${product.image_aspect_ratio}"
                  data-sizes="auto"
                  alt="${product.title}">
            </div>
          `
        }
      }
    }

    return output;
  }

  theme.buildCollectionItem = function (items) {
    var output = '';

    items.forEach(collection => {
      var markup = `
        <li>
          <a href="${collection.url}">
            ${collection.title}
          </a>
        </li>
      `;

      output += markup;
    });

    return output;
  }

  /*============================================================================
    Shipping Reminder Popup
  ==============================================================================*/

  class ShippingReminderPopup extends HTMLElement {
    constructor() {
      super();

      this.cookieName = this.id;
      this.cookie = Cookies.get(this.cookieName);

      this.classes = {
        activeContent: 'shipping-reminder-popup__content--active',
        inactiveContent: 'shipping-reminder-popup__content--inactive',
        inactiveDeclineContent: 'shipping-reminder-popup__decline-content--inactive',
        activeDeclineContent: 'shipping-reminder-popup__decline-content--active',
        modalInnerActive: 'active'
      }

      // this.declineButton = this.querySelector('[data-shipping-reminder-popup-decline-button]');
      this.declineContent = this.querySelector('[data-shipping-reminder-popup-decline-content]');
      this.content = this.querySelector('[data-shipping-reminder-popup-content]');
      this.returnButton = this.querySelector('[data-shipping-reminder-popup-return-button]');
      this.exitButton = this.querySelector('[data-shipping-reminder-popup-exit-button]');
      this.backgroundImage = this.querySelector('[data-background-image]');
      this.mobileBackgroundImage = this.querySelector('[data-mobile-background-image]');

      this.allowedCountries = this.dataset.allowedCountries.split(',').map(_ => _.toLowerCase().trim()) || [];

      if (Shopify.designMode) {
        // Bound handlers stored on `this` so disconnectedCallback can remove them.
        // Without this, each section reload in the editor leaks two document
        // listeners that reference a detached element.
        this._onSectionSelect = (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
          }
        };
        this._onSectionLoad = (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            // If 'Test mode' is enabled, remove the cookie we've set
            if (this.dataset.testMode === 'true' && this.cookie) {
              Cookies.remove(this.cookieName);
            }

            // Check session storage if user was editing on the second view
            const secondViewVisited = sessionStorage.getItem(this.id);

            if (!secondViewVisited) return;

            this.showDeclineContent();
          }
        };
        document.addEventListener('shopify:section:select', this._onSectionSelect);
        document.addEventListener('shopify:section:load', this._onSectionLoad);
      }

      // Age verification popup will only be hidden if test mode is disabled AND
      // either a cookie exists OR 'Show age verification popup' setting is unchecked
      if ((this.cookie || this.dataset.enabled === 'false') && this.dataset.testMode === 'false') return;

      this.init();
    }

    disconnectedCallback() {
      if (this._onSectionSelect) document.removeEventListener('shopify:section:select', this._onSectionSelect);
      if (this._onSectionLoad) document.removeEventListener('shopify:section:load', this._onSectionLoad);
    }

    triggerPopup() {
      if (this.dataset.testMode !== 'false') {
        this.modal.open();
        this.showTextContent();
        return;
      }

      fetch('https://api.ipify.org/')
        .then(res => res.text())
        .then(ip => fetch(`https://ipapi.co/${ip}/json/`))
        .then(res => res.json())
        .then(data => {
          const country = data.country_name;
          if (!this.allowedCountries.includes(country.toLowerCase())) {
            this.modal.open();
            this.showTextContent();
          } else {
            Cookies.set(this.cookieName, 'entered', { expires: 30 });
          }
        })
        .catch(() => {
          // IP lookup failed — don't block the user, silently skip
        });
    }

    init() {
      this.modal = new theme.Modals(this.id, 'shipping-reminder-popup-modal', {
        closeOffContentClick: false
      });

      if (this.backgroundImage) {
        this.backgroundImage.style.display = 'block';
      }

      if (theme.config.bpSmall && this.mobileBackgroundImage) {
        this.mobileBackgroundImage.style.display = 'block';
      }

      this.triggerPopup();

      theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));

      if (this.returnButton) {
        this.returnButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.hideDeclineContent();

          // Remove data from session storage so second view doesn't persist
          const secondViewVisited = sessionStorage.getItem(this.id);

          if (Shopify.designMode && secondViewVisited) {
            sessionStorage.removeItem(this.id);
          }
        })
      }

      if (this.exitButton) {
        this.exitButton.addEventListener('click', (e) => {
          e.preventDefault();

          // We don't want to set a cookie if in test mode
          if (this.dataset.testMode === 'false') {
            Cookies.set(this.cookieName, 'entered', { expires: 30 });
          }

          if (this.backgroundImage) {
            this.backgroundImage.style.display = 'none';
          }

          if (theme.config.bpSmall && this.mobileBackgroundImage) {
            this.mobileBackgroundImage.style.display = 'none';
          }

          this.modal.close();

          theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
        })
      }
    }

    showTextContent() {
      const modalInner = this.querySelector('.modal__inner')
      if (modalInner) {
        setTimeout(() => {
          if (!modalInner.classList.contains(this.classes.modalInnerActive)) modalInner.classList.add(this.classes.modalInnerActive)
        }, 500)
      }
    }

    hideTextContent() {
      const modalInner = this.querySelector('.modal__inner')
      if (modalInner) {
        setTimeout(() => {
          if (modalInner.classList.contains(this.classes.modalInnerActive)) modalInner.classList.remove(this.classes.modalInnerActive)
        }, 500)
      }
    }

    showDeclineContent() {
      this.declineContent.classList.remove(this.classes.inactiveDeclineContent);
      this.declineContent.classList.add(this.classes.activeDeclineContent);

      this.content.classList.add(this.classes.inactiveContent);
      this.content.classList.remove(this.classes.activeContent);
    }

    hideDeclineContent() {
      this.declineContent.classList.add(this.classes.inactiveDeclineContent);
      this.declineContent.classList.remove(this.classes.activeDeclineContent);

      this.content.classList.remove(this.classes.inactiveContent);
      this.content.classList.add(this.classes.activeContent);
    }
  }

  customElements.define('shipping-reminder-popup', ShippingReminderPopup);



  theme.PasswordHeader = (function () {
    function PasswordHeader() {
      this.init();
    }

    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function () {
        if (!document.querySelector('#LoginModal')) {
          return;
        }

        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });

        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });

    return PasswordHeader;
  })();

  theme.Photoswipe = (function () {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.is-selected'
    };

    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;

      if (!container || container.dataset.zoom === 'false') {
        return;
      }

      this.init();
    }

    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function () {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },

      triggerClick: function (evt) {
        // Streamline changes between a slideshow and
        // stacked images, so recheck if we are still
        // working with a slideshow when initializing zoom
        if (this.container.dataset && this.container.dataset.hasSlideshow === 'true') {
          this.inSlideshow = true;
        } else {
          this.inSlideshow = false;
        }

        if (!theme.config.bpSmall) {
          this.inSlideshow = false;
        }
        this.items = this.getImageData();
        var image = this.inSlideshow ? this.container.querySelector(selectors.activeImage) : evt.srcElement.parentElement.childNodes[0];
        var index = this.inSlideshow ? this.getChildIndex(image) : image.dataset.index;
        this.initGallery(this.items, index);
      },

      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function (el) {
        var i = 0;
        while ((el = el.previousSibling) != null) {
          i++;
        }

        // 1-based index required
        return i + 1;
      },

      getImageData: function () {
        this.images = this.inSlideshow
          ? this.container.querySelectorAll(selectors.slideshowTrack + selectors.images)
          : this.container.querySelectorAll(selectors.images);

        var items = [];

        this.images.forEach(el => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: el.getAttribute('data-photoswipe-width'),
            h: el.getAttribute('data-photoswipe-height'),
            el: el,
            initialZoomLevel: 0.5
          }

          items.push(item);
        });

        return items;
      },

      initGallery: function (items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];

        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function (index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        }

        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.listen('afterChange', this.afterChange.bind(this));
        this.gallery.init();

        this.preventiOS15Scrolling();
      },

      afterChange: function () {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: index
          }
        }));
      },

      syncHeight: function () {
        document.documentElement.style.setProperty(
          "--window-inner-height",
          `${window.innerHeight}px`
        );
      },

      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function () {
        let initialScrollPos;

        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

        this.syncHeight();

        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;

        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add('pswp-open-in-ios');

        window.addEventListener('resize', this.syncHeight);

        this.gallery.listen('destroy', () => {
          document.documentElement.classList.remove('pswp-open-in-ios');
          window.removeEventListener('resize', this.syncHeight);
          window.scrollTo(0, initialScrollPos);
        });
      }
    });

    return Photoswipe;
  })();


  theme.Recommendations = (function () {
    var selectors = {
      placeholder: '.product-recommendations-placeholder',
      sectionClass: ' .product-recommendations',
      productResults: '.grid-product'
    }

    function Recommendations(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.url = container.dataset.url;

      selectors.recommendations = 'Recommendations-' + this.sectionId;

      theme.initWhenVisible({
        element: container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }

    Recommendations.prototype = Object.assign({}, Recommendations.prototype, {
      init: function () {
        var section = document.getElementById(selectors.recommendations);

        if (!section || section.dataset.enable === 'false') {
          return;
        }

        var url = this.url;

        // When section his hidden and shown, make sure it starts empty
        if (Shopify.designMode) {
          var wrapper = section.querySelector(selectors.sectionClass)
          if (wrapper) {
            wrapper.innerHTML = '';
          }
        }

        fetch(url).then(function (response) {
          return response.text();
        }).then(function (html) {
          // Convert the HTML string into a document object
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var div = doc.querySelector(selectors.sectionClass);
          var placeholder = section.querySelector(selectors.placeholder);
          if (!placeholder) {
            return;
          }

          placeholder.innerHTML = '';

          if (!div) {
            this.container.classList.add('hide');
            if (window.AOS) { AOS.refreshHard() }
            return;
          }

          placeholder.appendChild(div);

          // Show the recommendations wrapper (hidden until products load)
          var wrapper = section.querySelector('[data-recommendations-wrapper]');
          if (wrapper) { wrapper.classList.remove('hide'); }

          theme.reinitProductGridItem(section);

          document.dispatchEvent(new CustomEvent('recommendations:loaded', {
            detail: {
              section: section
            }
          }));

          // If no results, hide the entire section
          var results = div.querySelectorAll(selectors.productResults);
          if (results.length === 0) {
            this.container.classList.add('hide');
          }
        }.bind(this));
      }
    });

    return Recommendations;
  })();

  theme.SlideshowSection = (function () {

    var selectors = {
      parallaxContainer: '.parallax-container'
    };

    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;

      this.initialIndex = 0;

      if (!this.slideshow) { return }

      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);

      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }

    }

    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function () {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');

        if (this.container.hasAttribute('data-immediate-load')) {
          this.slideshow.classList.remove('loading', 'loading--delayed');
          this.slideshow.classList.add('loaded');
        } else {
          // Wait for image to load before marking as done
          theme.loadImageSection(this.slideshow);
        }

        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? parseInt(this.slideshow.dataset.speed)
              : false
          };

          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('is-selected');
        }
      },

      forceReload: function () {
        this.onUnload();
        this.init();
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function () {
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.pause();
            }
          }.bind(this), 1000);
        }
      },

      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      }
    });

    return SlideshowSection;
  })();

  theme.StoreAvailability = (function () {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability',
      modalOpenBtn: '.js-modal-open-availability',
      productTitle: '[data-availability-product-title]'
    };

    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }

    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      updateContent: function (variantId) {
        var variantSectionUrl =
          this.baseUrl +
          '/variants/' +
          variantId +
          '/?section_id=store-availability';

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((html) => {
            if (html.trim() === '') {
              this.container.innerHTML = '';
              return;
            }

            this.container.innerHTML = html;
            this.container.innerHTML = this.container.firstElementChild.innerHTML;

            // Setup drawer if have open button
            if (this.container.querySelector(selectors.drawerOpenBtn)) {
              this.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
            }

            // Setup modal if have open button
            if (this.container.querySelector(selectors.modalOpenBtn)) {
              this.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
            }

            var title = this.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = this.productTitle;
            }
          });
      }
    });

    return StoreAvailability;
  })();

  theme.VideoSection = (function () {
    var selectors = {
      videoParent: '.video-parent-section'
    };

    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }

    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function () {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;

        switch (type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },

      initYoutubeVideo: function (videoId) {
        this.videoObject = new theme.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },

      initVimeoVideo: function (videoId) {
        this.videoObject = new theme.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },

      initMp4Video: function () {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);

        if (mp4Div) {
          parent.classList.add('loaded');

          var playPromise = document.querySelector('#' + mp4Video).play();

          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function () {
              // playback normal
            }).catch(function () {
              mp4Div.setAttribute('controls', '');
              parent.classList.add('video-interactable');
            });
          }
        }
      },

      onUnload: function (evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });

    return videoSection;
  })();

  theme.Blog = (function () {



    function Blog(container) {

      this.tagFilters();

    }



    Blog.prototype = Object.assign({}, Blog.prototype, {

      tagFilters: function () {

        var filterBy = document.getElementById('BlogTagFilter');



        if (!filterBy) {

          return;

        }



        filterBy.addEventListener('change', function () {

          location.href = filterBy.value;

        });

      }

    });



    return Blog;

  })();


  theme.CollectionHeader = (function () {
    var hasLoadedBefore = false;

    function CollectionHeader(container) {
      this.namespace = '.collection-header';

      var heroImageContainer = container.querySelector('.collection-hero');
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        theme.loadImageSection(heroImageContainer);
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }

      hasLoadedBefore = true;
    }

    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function () {
        if (!Shopify.designMode) {
          return;
        }

        if (theme.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper');
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload();
          }
        }
      }
    });

    return CollectionHeader;
  })();

  theme.CollectionSidebar = (function () {
    var drawerStyle = false;
    var selectors = {
      sidebar: '#CollectionSidebar',
      childList: '.slide-nav__dropdown',
      subNavToggleBtn: '.js-toggle-submenu'
    };

    var classes = {
      isActive: 'is-active'
    };

    // CollectionSidebar — manages the mobile filter drawer UI.
    // Owns: checkbox state sync (mobile ↔ desktop), sub-nav accordion toggling,
    // category mutual exclusion, "All X" convenience checkboxes, and clear/apply actions.
    // Does NOT own: fetch pipeline, count updates, or product grid rendering (those are in Collection).
    // Communicates with Collection via the _scheduleFilterUpdate callback set during init.
    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }

    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      init: function () {
        // Do not load when no sidebar exists
        if (!this.container) {
          return;
        }

        this.destroy();

        this.wrapper = this.container.querySelector('.slide-nav__wrapper')

        // Create bound handlers once for proper removal
        if (!this._boundContainerChange) {
          this._boundContainerChange = this._onContainerChange.bind(this)
          this._boundContainerClick = this._onContainerClick.bind(this)
          this._boundClearGroup = this.clearGroup.bind(this)
          this._boundApplyGroup = this.applyGroup.bind(this)
          this._boundOnClose = this.onClose.bind(this)
          this._boundBackToSlideOne = this.backToSlideOne.bind(this)
        }

        // Delegated listeners — handles all filter checkboxes and sub-nav buttons
        this.container.addEventListener('change', this._boundContainerChange)
        this.container.addEventListener('click', this._boundContainerClick)

        drawerStyle = this.container.dataset.style === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters');
        theme.FilterDrawerMobile = new theme.Drawers('FilterDrawerMobile', 'collection-filters-mobile');

        this.config = {
          menuLevel: 1,
          activeMenu: 'main'
        }

        this.drawerBottom = this.container.querySelector('.filter-drawer--bottom')
        this.listControl = this.container.querySelector('.list-control')

        this.listControlClearBtn = this.listControl.querySelector('[data-list-control="clear"]')
        this.listControlClearBtn.addEventListener('click', this._boundClearGroup)

        this.listControlApplyBtn = this.listControl.querySelector('.apply__button')
        this.listControlApplyBtn.addEventListener('click', this._boundApplyGroup)

        this.closeBtn = this.container.querySelector('#FilterDrawerMobile .js-drawer-close')
        this.closeBtn.addEventListener('click', this._boundOnClose)

        this.resetBtn = this.container.querySelector('#FilterDrawerMobile .drawer__reset-button')
        this.resetBtn.addEventListener('click', this._boundBackToSlideOne)

        const desktopDrawerScroll = this.container.querySelector('#FilterDrawer .drawer__scrollable')
        this.updateShadowState(desktopDrawerScroll)

        this._resizeObserver = new ResizeObserver((entries) => {
          this.updateShadowState(desktopDrawerScroll)
        })
        this._resizeObserver.observe(desktopDrawerScroll)

        this._scrollHandler = (e) => {
          const scrollTop = desktopDrawerScroll.scrollTop;
          const scrollHeight = desktopDrawerScroll.scrollHeight;
          const clientHeight = desktopDrawerScroll.clientHeight;
          const isAtTop = scrollTop === 0;
          const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1; // -1 for rounding errors

          // Toggle "scrolled" class (not at top)
          desktopDrawerScroll.classList.toggle('scrolled', !isAtTop);

          // Toggle "scroll-end" class (at bottom)
          desktopDrawerScroll.classList.toggle('scroll-end', isAtBottom);
        };
        desktopDrawerScroll.addEventListener('scroll', this._scrollHandler);
        this._desktopDrawerScroll = desktopDrawerScroll;
      },

      updateShadowState: function (drawer) {
        if (!drawer) {
          return;
        }
        if (drawer.scrollHeight > drawer.clientHeight) {

          drawer.classList.add('has-scroll');
        } else {
          drawer.classList.remove('has-scroll');
        }
      },

      _onContainerChange: function (evt) {
        var input = evt.target
        if (!input.classList.contains('tag__input') || !input.hasAttribute('data-name')) return
        if (input.classList.contains('tag__input--all')) {
          this.selectAllUnderList(evt)
        } else {
          this.handleFilterChange(evt)
        }
      },

      _onContainerClick: function (evt) {
        var subNavBtn = evt.target.closest(selectors.subNavToggleBtn)
        if (subNavBtn) {
          this.toggleSubNav({ currentTarget: subNavBtn })
        }
      },

      backToSlideOne: function (e) {
        var titleEl = this.container.querySelector('.title__placeholder')
        titleEl.innerHTML = theme.strings.filterAllFilters
        this.goToSubnav();
        this.updateListControl(e.target)
      },

      onClose: function (e) {
        e.preventDefault()
        const form = document.querySelector('.filter-form')
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
      },

      reInit: function (container) {
        this.container = container.querySelector(selectors.sidebar)
        this.init()
      },

      // Mobile filter checkbox handler. Syncs mobile→desktop by finding the matching
      // desktop input (data-name/data-value → name/value) and checking it.
      // Then triggers the filter pipeline via _scheduleFilterUpdate callback.
      handleFilterChange: function (evt) {
        const target = evt.target
        const listItem = target.closest('li.tag')
        const name = target.dataset.name
        const value = target.dataset.value

        const mainCategory = target.closest('[data-category-main]')

        const input = this.container.querySelector(`input[name="${name}"][value="${value}"]`)
        if (input) input.checked = target.checked

        if (!target.checked) {
          const parent = this.findParentWithDataParent(evt.target, 'data-parent')
          if (parent) {
            const hasClearAllThisLevel = parent.querySelector('.tag__input--all')
            if (hasClearAllThisLevel) {
              hasClearAllThisLevel.checked = false
              const inputWrapper = hasClearAllThisLevel.closest('li.tag')
              inputWrapper.classList.remove('tag--active')
            }
          }
          const hasParentsParent = this.findParentWithDataParent(parent, 'data-parent')
          if (hasParentsParent) {
            const hasAllInput = this.findImmediateChildWithTagInputAllClass(hasParentsParent)
            if (hasAllInput) {
              hasAllInput.querySelector('.tag__input--all').checked = false
            }
          }

          if (listItem.classList.contains('tag--active')) listItem.classList.remove('tag--active')

        } else {
          if (!listItem.classList.contains('tag--active')) listItem.classList.add('tag--active')
        }

        if (mainCategory) {
          this.clearOtherMainCategory(mainCategory)
        }

        this.listControl.classList.add('show')
        if (this._scheduleFilterUpdate) this._scheduleFilterUpdate()
      },

      selectAllUnderList: function (evt) {
        const target = evt.target
        const mainCategory = target.closest('[data-category-main]')
        const list = target.closest('.filter__list')
        const inputs = list.querySelectorAll('.tag__input')
        inputs.forEach(item => {
          const listItem = item.closest('li.tag')

          const name = item.dataset.name
          const value = item.dataset.value
          const input = this.container.querySelector(`input[name="${name}"][value="${value}"]`)
          const action = target.checked ? 'add' : 'remove'

          if (target.checked) {
            item.checked = true

            if (input) input.checked = true
          } else {
            item.checked = false

            if (input) input.checked = false
          }
          if (listItem) listItem.classList[action]('tag--active')
        })

        if (mainCategory) {
          this.clearOtherMainCategory(mainCategory)
        }

        this.listControl.classList.add('show')
        if (!target.checked) { this.listControl.classList.remove('show') }

        if (this._scheduleFilterUpdate) this._scheduleFilterUpdate()
      },

      clearOtherMainCategory: function (currentCategory) {
        theme.utils.clearOtherMainCategory(currentCategory, this.container)
      },

      findParentWithDataParent: function (element, identifier) {
        let parent = element.parentElement;
        while (parent) {
          if (parent.hasAttribute(identifier)) {
            return parent;
          }
          parent = parent.parentElement;
        }
        return null;
      },

      findImmediateChildWithTagInputAllClass: function (element) {
        let children = element.children;
        for (let i = 0; i < children.length; i++) {
          if (children[i].querySelector('.tag__input--all')) {
            return children[i];
          }
        }
        return null;
      },

      applyGroup: function (evt) {
        const listControlEl = evt.target.closest('[data-control]')
        const currentGroupName = listControlEl.dataset.control

        const currentMenu = this.container.querySelector(`.slide-nav__dropdown[data-title="${currentGroupName}"]`)
        if (!currentMenu) return
        const backButton = currentMenu.querySelector('[data-back]')
        backButton.click()
      },

      clearGroup: function (evt) {
        evt.preventDefault()
        const listControlEl = evt.target.closest('[data-control]')
        const currentGroupName = listControlEl.dataset.control

        let target = null

        const groupEl = this.container.querySelector(`li[data-list-control="${currentGroupName}"]`)
        const groupItems = groupEl.querySelectorAll('input')
        groupItems.forEach(item => {
          if (item.checked) {
            if (!target) {
              target = item
            }

            const name = item.getAttribute('data-name')
            const value = item.getAttribute('data-value')

            const mainInput = document.querySelector(`input[name="${name}"][value="${value}"]`)
            if (mainInput) {
              mainInput.checked = false
            }
          }
          item.checked = false
          const listItem = item.closest('li.tag')
          if (listItem) listItem.classList.remove('tag--active')
        })

        this.listControl.classList.remove('show')
        if (this._scheduleFilterUpdate) this._scheduleFilterUpdate()
      },

      toggleSubNav: function (evt) {
        var btn = evt.currentTarget;

        var title = btn.dataset.title
        var titleEl = this.container.querySelector('.title__placeholder')
        if (title) {
          titleEl.innerHTML = title
        } else {
          titleEl.innerHTML = theme.strings.filterAllFilters
        }
        this.goToSubnav(btn.dataset.target);
        this.updateListControl(btn.parentNode)
      },

      updateListControl: function (el) {
        const controlTarget = el.dataset.listControl
        if (controlTarget) {
          this.listControl.setAttribute('data-control', controlTarget)
          this.closeBtn.classList.add('hidden')
          this.resetBtn.classList.remove('hidden')
        } else {
          this.listControl.setAttribute('data-control', "")
          this.closeBtn.classList.remove('hidden')
          this.resetBtn.classList.add('hidden')
        }

        if (this.checkAnyInputSelected(el)) {
          this.listControl.classList.add('show')
        }
      },

      checkAnyInputSelected: function (el) {
        const hasAnythingChecked = el.querySelector('input[data-name]:checked')
        return hasAnythingChecked ? true : false
      },

      // If a level is sent we are going up, so target list doesn't matter
      goToSubnav: function (target) {
        // Activate new list if a target is passed
        var targetMenu = this.container.querySelector(selectors.childList + '[data-parent="' + target + '"]')
        if (targetMenu) {
          this.config.menuLevel = targetMenu.dataset.level;
          this.config.activeMenu = target

          // Hide all level 3 menus if going to level 2
          if (this.config.menuLevel == 2) {
            this.container.querySelectorAll(selectors.childList + '[data-level="3"]').forEach(list => {
              list.classList.remove(classes.isActive);
              list.parentElement.classList.remove(classes.isActive);
            });
          }

          if (this.config.menuLevel == 3) {
            this.container.querySelectorAll(selectors.childList + '[data-level="4"]').forEach(list => {
              list.classList.remove(classes.isActive);
              list.parentElement.classList.remove(classes.isActive);
            });
          }


          setTimeout(() => {
            targetMenu.classList.add(classes.isActive);
            targetMenu.parentElement.classList.add(classes.isActive);
          }, 150)

          this.drawerBottom.classList.add('submenu-active')

        } else {
          // Going to top level, reset
          this.config.menuLevel = 1;
          this.wrapper.removeAttribute('style');
          this.container.querySelectorAll(selectors.childList).forEach(list => {
            list.classList.remove(classes.isActive);
            list.parentElement.classList.remove(classes.isActive);
          });

          this.drawerBottom.classList.remove('submenu-active')
          this.listControl.classList.remove('show')
        }

        this.wrapper.dataset.level = this.config.menuLevel;
      },

      forceReload: function () {
        this.init();
      },

      onSelect: function () {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }

          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
        if (theme.FilterDrawerMobile) {
          if (!drawerStyle) {
            theme.FilterDrawerMobile.close()
            return;
          }

          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawerMobile.open()
          }
        }
      },

      onDeselect: function () {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        if (theme.FilterDrawerMobile) {
          theme.FilterDrawerMobile.close()
        }
      },

      destroy: function () {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
          theme.FilterDrawer.destroyListeners();
        }

        if (theme.FilterDrawerMobile) {
          theme.FilterDrawerMobile.close();
          theme.FilterDrawerMobile.destroyListeners();
        }

        // Remove delegated container listeners
        if (this.container && this._boundContainerChange) {
          this.container.removeEventListener('change', this._boundContainerChange)
        }
        if (this.container && this._boundContainerClick) {
          this.container.removeEventListener('click', this._boundContainerClick)
        }

        // Remove button listeners
        if (this.listControlClearBtn && this._boundClearGroup) {
          this.listControlClearBtn.removeEventListener('click', this._boundClearGroup)
        }
        if (this.listControlApplyBtn && this._boundApplyGroup) {
          this.listControlApplyBtn.removeEventListener('click', this._boundApplyGroup)
        }
        if (this.closeBtn && this._boundOnClose) {
          this.closeBtn.removeEventListener('click', this._boundOnClose)
        }
        if (this.resetBtn && this._boundBackToSlideOne) {
          this.resetBtn.removeEventListener('click', this._boundBackToSlideOne)
        }

        // Remove observer and scroll
        if (this._resizeObserver) {
          this._resizeObserver.disconnect();
        }

        if (this._scrollHandler && this._desktopDrawerScroll) {
          this._desktopDrawerScroll.removeEventListener('scroll', this._scrollHandler);
        }
      },

      // Legacy alias for section manager compatibility
      onUnload: function () {
        this.destroy();
      }
    });

    return CollectionSidebar;
  })();

  theme.Collection = (function () {
    var isAnimating = false;

    var selectors = {
      sortSelect: '#SortBy',

      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',

      collectionGrid: '.collection-grid__wrapper',
      trigger: '.collapsible-trigger',
      sidebar: '#CollectionSidebar',
      filterSidebar: '.collapsible-content--sidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list input',
      tagsForm: '.filter-form',
      filtersWrapper: '.sticky-filter--wrapper',
    };

    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove',
      filterSidebar: 'collapsible-content--sidebar',
      isOpen: 'is-open',
    };

    // Collection — orchestrates the entire collection page: filter pipeline, product grid AJAX,
    // URL history, and coordination between CollectionSidebar (UI) and the Section Rendering API.
    //
    // Filter pipeline (Farfetch-inspired):
    //   1. Checkbox change → onFormInput() fires immediately
    //   2. executeFilterUpdate() → fetches collection-count section (lightweight, ~5KB)
    //      → updates count badge, filter options, size visibility, active pills
    //   3. scheduleBackgroundUpdate() → debounced 300ms → backgroundUpdatePage()
    //      → prefetches full page sections in parallel, caches result
    //   4. "Show Results" button applies cached result instantly (or waits if still loading)
    //
    // Race condition protection: AbortController cancels in-flight fetches on new input.
    // Smart disable: unchecked inputs dim briefly if user clicks faster than server responds.
    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      this.sidebar = new theme.CollectionSidebar(container);

      this.header = document.querySelector('[data-section-type="collection-header"]')
      this.headerId = this.header?.getAttribute('data-section-id')

      this.ajaxRenderer = new theme.AjaxRenderer({
        sections: [
          {
            sectionId: this.sectionId,
            nodeId: 'CollectionAjaxContent',
          },
          {
            sectionId: this.headerId,
            nodeId: 'CollectionHeaderAjaxContent'
          }
        ],
        onReplace: this.onReplaceAjaxContent.bind(this),
      });

      // Background prefetch state
      this._prefetchController = null
      this._prefetchResult = null
      this._prefetchReady = false
      this._applyOnComplete = false

      this.init();
    }

    Collection.prototype = Object.assign({}, Collection.prototype, {
      destroy: function () {
        // Abort pending fetch
        if (this.filterAbortController) {
          this.filterAbortController.abort();
          this.filterAbortController = null;
        }

        // Abort pending prefetch
        if (this._prefetchController) {
          this._prefetchController.abort();
          this._prefetchController = null;
        }
        this._prefetchResult = null
        this._prefetchReady = false
        this._applyOnComplete = false

        // Clear timers
        clearTimeout(this._bgUpdateTimer);

        // Remove active tag container delegation
        if (this._activeTagContainers && this._boundActiveTagClick) {
          this._activeTagContainers.forEach(function (list) {
            list.removeEventListener('click', this._boundActiveTagClick)
          }.bind(this))
        }

        // Remove clear all button listeners
        if (this._clearAllBtns && this._boundClearAll) {
          this._clearAllBtns.forEach(button => {
            button.removeEventListener('click', this._boundClearAll)
          })
        }

        // Remove form input/submit listeners
        if (this._filterForms) {
          this._filterForms.forEach(form => {
            if (this._boundFormInput) form.removeEventListener('input', this._boundFormInput)
            if (this._boundFormSubmit) form.removeEventListener('submit', this._boundFormSubmit)
          })
        }

        // Remove resize listener
        if (this._boundStickyResize) {
          window.off('resize', this._boundStickyResize);
        }

        // Remove popstate
        if (this.namespace) {
          window.off('popstate' + this.namespace);
        }
      },

      init: function () {
        this.destroy();
        this.initSort();
        this.colorSwatchHovering();
        this.initFilters();
        this.sidebar.init();
        this.sidebar._scheduleFilterUpdate = function () {
          this.executeFilterUpdate()
          this.scheduleBackgroundUpdate()
        }.bind(this)
      },

      initSort: function () {
        this.sortSelect = document.querySelector(selectors.sortSelect);

        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue();
          this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
        }
      },

      getSortValue: function () {
        return this.sortSelect.value || this.defaultSort;
      },

      getDefaultSortValue: function () {
        return this.sortSelect.getAttribute('data-default-sortby');
      },

      onSortChange: function () {
        this.queryParams = new URLSearchParams(window.location.search);

        this.queryParams.set('sort_by', this.getSortValue());
        this.queryParams.delete('page'); // Delete if it exists

        window.location.search = this.queryParams.toString();
      },

      colorSwatchHovering: function () {
        var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
        if (!colorImages.length) {
          return;
        }

        this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
          swatch.addEventListener('mouseenter', function () {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            // After an AJAX filter swap the matching image node may be gone
            // even though the swatch still has a hover handler — guard both
            // mouseenter and mouseleave against the stale-target throw.
            var el = document.querySelector('.grid-product__color-image--' + id);
            if (!el) return;
            el.style.backgroundImage = 'url(' + image + ')';
            el.classList.add('is-active');
          });
          swatch.addEventListener('mouseleave', function () {
            var id = swatch.dataset.variantId;
            var el = document.querySelector('.grid-product__color-image--' + id);
            if (el) el.classList.remove('is-active');
          });
        });
      },

      /*====================
        Collection filters
      ====================*/
      initFilters: function () {
        var tags = document.querySelectorAll(selectors.tags);

        if (!tags.length) {
          return;
        }

        this.bindBackButton();

        // Set mobile top value for filters if sticky header enabled
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();

          if (!this._boundStickyResize) {
            this._boundStickyResize = theme.utils.debounce(500, this.setFilterStickyPosition);
          }
          window.on('resize', this._boundStickyResize);
        }

        // Create bound handlers once for proper removal
        if (!this._boundActiveTagClick) {
          this._boundActiveTagClick = this._onActiveTagClick.bind(this)
          this._boundClearAll = this.clearAll.bind(this)
          this._boundFormInput = this.onFormInput.bind(this)
          this._boundFormSubmit = this.onFormSubmit.bind(this)
        }

        // Delegated click on pill containers — survives innerHTML replacement
        this._activeTagContainers = document.querySelectorAll(selectors.activeTagList)
        this._activeTagContainers.forEach(list => {
          list.addEventListener('click', this._boundActiveTagClick)
        })

        this._clearAllBtns = document.querySelectorAll('.clear--all button')
        this._clearAllBtns.forEach(button => {
          button.addEventListener('click', this._boundClearAll)
        })

        this._filterForms = document.querySelectorAll(selectors.tagsForm)
        this._filterForms.forEach(form => {
          form.addEventListener('input', this._boundFormInput);
          form.addEventListener('submit', this._boundFormSubmit);
        });

        this.searchEnabledFilters = []

        const searchFields = document.querySelectorAll('[data-filter-search-input]')
        searchFields.forEach(el => {
          var parent = document.getElementById(el.dataset.parentId)
          var name = el.dataset.filterSearchInput
          var valueListItem = parent.querySelectorAll('[data-filter-value]')
          var values = []

          valueListItem.forEach(item => {
            if (!values.includes(item.dataset.filterValue.toLowerCase())) values.push(item.dataset.filterValue.toLowerCase())
          })
          this.searchEnabledFilters.push({ name, parentId: el.dataset.parentId, parent, values, items: [...valueListItem] })
        })

        const allItemsEl = document.querySelector('input[name="all_items"][value="1"]')

        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        if (urlParams.has('all_items') && allItemsEl) {
          allItemsEl.checked = true
        }

        const hasMainCategory = document.querySelector('[data-has-main-category]')
        const hasSubCategory = document.querySelector('[data-has-sub-category]')

        if (!hasMainCategory && !hasSubCategory) {
          this.toggleSizeFilter(true)
        }
      },

      clearAll: async function (evt) {
        evt.preventDefault()

        // Abort any running prefetch
        if (this._prefetchController) { this._prefetchController.abort(); this._prefetchController = null }
        this._prefetchReady = false
        this._prefetchResult = null
        this._applyOnComplete = false
        this.setShowResultsState('idle')

        const checkedInputs = document.querySelectorAll('input.tag__input:checked')
        checkedInputs.forEach(input => {
          const inputName = input.getAttribute('name')
          // filter.p.tag is the gender scope (a mode) — "clear all filters"
          // must never unscope the search itself.
          if (inputName === 'filter.p.tag') return
          if (inputName != 'filter.v.availability') {
            input.checked = false
            const listItem = input.closest('li.tag')
            if (listItem) {
              listItem.classList.remove('tag--active')
            }
          }
          else {
            if (input.value != 1) {
              input.checked = false
              const listItem = input.closest('li.tag')
              if (listItem) {
                listItem.classList.remove('tag--active')
              }
            }
          }
        })

        const tagList = document.querySelectorAll('.tag-list.tag-list--active-tags')
        tagList.forEach(list => {
          list.innerHTML = ""
        })
        document.querySelectorAll('span[data-count]').forEach(span => span.innerHTML = "")

        var emptyState = document.getElementById('filter-empty-state')
        if (emptyState) emptyState.remove()

        this.updateUrlAfterClear()

        const update = await this.getFilterUpdates(true)
        // F1: bail on a superseded (aborted) or failed (error) fetch — discriminated result.
        if (!update || update.aborted || update.error) return

        // Reset succeeded — clear any error toast left over from a prior failed attempt
        // (mirrors executeFilterUpdate's success path).
        this._dismissFilterError()

        this.updateFilter(update.html)
        this.syncAllCheckboxes()

        const hasMainCategory = document.querySelector('[data-has-main-category]')
        const hasSubCategory = document.querySelector('[data-has-sub-category]')

        if (!hasMainCategory && !hasSubCategory) {
          this.toggleSizeFilter(true)
        } else {
          this.toggleSizeFilter(false)
        }
      },

      // Debounced (300ms) trigger for the heavier product page prefetch.
      // Separated from executeFilterUpdate so count updates are instant while
      // product grid prefetch collapses rapid clicks into a single request.
      scheduleBackgroundUpdate: function () {
        clearTimeout(this._bgUpdateTimer)
        this._bgUpdateTimer = setTimeout(function () {
          this.backgroundUpdatePage()
        }.bind(this), 300)
      },

      // Dims unchecked filter checkboxes while a count fetch is in-flight.
      // Prevents clicking stale options that may no longer be valid.
      // Only triggers when user clicks faster than the server responds (~200ms) —
      // most users never see it.
      _setFilterInputsStale: function (stale) {
        // Scope to this Collection instance — two Collections on one page
        // (editor preview) would otherwise see each other's stale state.
        var root = this.container || document;
        root.querySelectorAll('.filter__list').forEach(function (list) {
          if (stale) {
            list.classList.add('filter-inputs--stale')
          } else {
            list.classList.remove('filter-inputs--stale')
          }
        })
      },

      // Core filter pipeline — fires immediately on every checkbox change (no debounce).
      // Fetches collection-count section → updates: count badge, empty state,
      // filter option availability (brand/color/size counts), size filter visibility
      // (only categories can show/hide size tab), active filter pills.
      // Does NOT update the product grid — that's handled by backgroundUpdatePage().
      executeFilterUpdate: async function () {
        // If a previous fetch is still pending, dim unchecked options to prevent stale clicks
        if (this._countFetchPending) {
          this._setFilterInputsStale(true)
        }
        this._countFetchPending = true

        var update = await this.getFilterUpdates()

        this._countFetchPending = false
        this._setFilterInputsStale(false)

        // F1: only a real update proceeds. A superseded fetch (aborted) or a genuine
        // failure (error — toast already shown in getFilterUpdates) both bail WITHOUT
        // dismissing the toast, so a network error stays visible long enough to see.
        if (!update || update.aborted || update.error) return

        // Reached only on success: clear any error toast left over from a prior
        // failed attempt now that filters have updated cleanly.
        this._dismissFilterError()

        if (update.data?.count !== undefined) {
          document.querySelectorAll('span[data-count]').forEach(function (span) {
            span.innerHTML = '&nbsp;(' + update.data.count + ')'
          })
          var srRegion = document.getElementById('filter-sr-announcements')
          if (srRegion) {
            srRegion.textContent = theme.strings.filterSrProductsFound.replace('[count]', update.data.count)
          }
        }

        // Show/hide filter empty state
        var emptyState = document.getElementById('filter-empty-state')
        if (update.data?.count === 0) {
          if (!emptyState) {
            var gridWrapper = document.querySelector('.collection-grid__wrapper')
            if (gridWrapper) {
              var div = document.createElement('div')
              div.id = 'filter-empty-state'
              div.className = 'filter-empty-state'
              div.innerHTML = '<p class="h4">' + theme.strings.filterNoResults + '</p>' +
                '<p>' + theme.strings.filterNoResultsHint + '</p>' +
                '<button class="btn filter-empty-state__clear" type="button">' + theme.strings.filterClearAll + '</button>'
              gridWrapper.prepend(div)
              div.querySelector('.filter-empty-state__clear').addEventListener('click', function () {
                document.querySelector('.clear--all button')?.click()
              })
            }
          }
        } else {
          if (emptyState) emptyState.remove()
        }

        try {
          this.updateFilter(update.html)
        } catch (e) {
          console.warn('[filter] updateFilter error:', e)
        }

        var isCategoryActive = document.querySelectorAll('input[name="filter.p.m.property.product_type"]:checked')
        var hasMainCategory = document.querySelector('[data-has-main-category]')
        var hasSubCategory = document.querySelector('[data-has-sub-category]')

        if (!hasMainCategory && !hasSubCategory) {
          this.toggleSizeFilter(true)
        } else {
          if (isCategoryActive.length > 0) {
            this.toggleSizeFilter(true)
          } else {
            this.toggleSizeFilter(false)
          }
        }

        this.renderSelectedElement()

        // Clear count when no user filters are active
        if (!document.querySelector('.tag-list--active-tags .tag--remove')) {
          document.querySelectorAll('span[data-count]').forEach(function (span) { span.innerHTML = '' })
        }

        // A2: Background prefetch runs on its own debounced schedule (already triggered from onFormInput)
      },

      // B3: Show subtle error toast on fetch failure
      showFilterError: function () {
        if (document.getElementById('filter-error-toast')) return
        var toast = document.createElement('div')
        toast.id = 'filter-error-toast'
        toast.setAttribute('aria-live', 'polite')
        toast.className = 'filter-error-toast'
        toast.textContent = theme.strings.filterError || 'Could not update filters. Try again.'
        var filterArea = document.querySelector('.collection-filter') || document.querySelector('.collection-grid__wrapper')
        if (filterArea) filterArea.prepend(toast)
        setTimeout(function () { toast.remove() }, 3000)
      },

      _dismissFilterError: function () {
        var toast = document.getElementById('filter-error-toast')
        if (toast) toast.remove()
      },

      _onActiveTagClick: function (evt) {
        var link = evt.target.closest('a[data-name]')
        if (!link) return
        evt.preventDefault()
        evt.stopPropagation()
        this.tagClick({ currentTarget: link, preventDefault: function () {} })
      },

      updateUrlAfterClear: function () {
        const url = window.location.href;
        const urlObj = new URL(url);
        const params = urlObj.searchParams;
        const keysToRemove = [];

        params.forEach((value, key) => {
          // Gender scope (filter.p.tag) survives a clear — it's a mode.
          if (key.startsWith('filter') && key !== 'filter.v.availability' && key !== 'filter.p.tag') {
            keysToRemove.push(key);
          }
        });

        keysToRemove.forEach(key => {
          params.delete(key);
        });

        window.history.replaceState({}, '', urlObj.toString());
      },

      normalizeString: function (str) {
        return str.normalize("NFD").replace(/\p{Diacritic}/gu, "")
      },

      updateCategory: function (html, trigger) {
        const hasCategory = document.querySelector('#FilterDrawerMobile [data-main-category-count]')
        if (!hasCategory) return;

        let collapsibleWrapper = document.querySelector('.accordion-collapse[data-collapsible-id="filter-category"]')
        if (!collapsibleWrapper) {
          collapsibleWrapper = document.querySelector('.accordion-collapse[data-collapsible-id="filter-kategori"]')
        }
        if (!collapsibleWrapper) return;
        const collapsibleButton = document.querySelector(`.accordion-button[data-bs-target="#${collapsibleWrapper.id}"]`)
        if (!collapsibleButton) return;

        const collapsibleWrapperMobile = document.querySelector('[data-main-category-count]')
        if (!collapsibleWrapperMobile) return;

        // Use string compare instead of JSON.parse to tolerate any non-boolean
        // value an editor session might leave behind.
        const isCategoryOpen = collapsibleButton.getAttribute('aria-expanded') === 'true'
        const isCategoryActive = collapsibleWrapperMobile.classList.contains('is-active')

        if (!isCategoryOpen) {
          const categoryDesktopNew = html.querySelector('[data-category] .accordion-content')
          const categoryDesktopCurrent = document.querySelector(`.accordion-content#${categoryDesktopNew.id}`)

          if (categoryDesktopCurrent) {
            categoryDesktopCurrent.replaceWith(categoryDesktopNew);
          }
        } else {
          if (trigger == 'clear-all') {
            collapsibleWrapper.classList.remove('show')
            collapsibleButton.classList.add('collapsed')
            collapsibleButton.setAttribute('aria-expanded', false)

            const categoryDesktopNew = html.querySelector('[data-category] .accordion-content')
            const categoryDesktopCurrent = document.querySelector(`.accordion-content#${categoryDesktopNew.id}`)

            if (categoryDesktopCurrent) {
              categoryDesktopCurrent.replaceWith(categoryDesktopNew);
            }
          }
        }

        if (!isCategoryActive) {
          const categoryMobileNew = html.querySelector('li[data-category-main]')
          const categoryMobileCurrent = document.querySelector('li[data-category-main]')
          if (categoryMobileCurrent) {
            categoryMobileCurrent.replaceWith(categoryMobileNew)
          }
        }
      },

      // Generic, LABEL-AGNOSTIC count application. Replaces the old per-label
      // updateBrand/updateColor/updateSize trio. Those hard-coded a short list of
      // translated label keys (`data['brand'/'märke'/'varumärke']`, `['color'/'färg']`,
      // `['size'/'storlek']`) to find each filter's data in the count payload — but the
      // payload is keyed by the RAW translated filter label, which drifts across
      // languages and Search & Discovery config. Any filter whose label wasn't on the
      // list (e.g. a "TC-Storlek-TC" size, a non-umlaut "Marke") rendered fine but then
      // silently stopped receiving count updates. Matching each option by param_name +
      // value instead is immune to labels entirely, and covers every filter type at once.
      // Category is deliberately excluded — updateCategory() owns the category tree via
      // server-rendered HTML, and hiding a parent category by its own count would fight it.
      updateFilterCounts: function (html) {
        const scriptEl = html.querySelector('[data-product-count]')
        if (!scriptEl) return

        // Escape param_name + value before interpolating into a selector so a value with
        // quotes/metacharacters (e.g. a `32"` size) can't throw and abort the whole pass.
        const esc = window.CSS && CSS.escape ? CSS.escape : (s => s)

        let data
        try {
          data = JSON.parse(scriptEl.textContent)
        } catch (e) {
          console.warn('[filter] updateFilterCounts parse error:', e)
          return
        }

        Object.keys(data).forEach(key => {
          const values = data[key]
          if (!Array.isArray(values)) return // skip scalars: count, has_category_filter, price
          values.forEach(item => {
            if (!item || !item.param_name) return
            // Category is owned by updateCategory() (tree, server-rendered) — leave it alone.
            if (item.param_name === 'filter.p.m.property.product_type') return
            const pn = esc(item.param_name)
            const val = esc(theme.utils.decodeString(item.value))
            const inputs = document.querySelectorAll(`input[name=${pn}][value=${val}], input[data-name=${pn}][data-value=${val}]`)
            inputs.forEach(input => {
              const li = input.closest('.tag')
              if (!li) return
              if (item.count <= 0) {
                li.classList.add('hide')
              } else {
                li.classList.remove('hide')
              }
            })
          })
        })
      },

      // Brand-specific post-processing, run AFTER updateFilterCounts has set each brand
      // option's .hide state. Also label-agnostic: brand lists are found by the structural
      // data-brand-value hook and letter groups by data-alpha-group (both emitted by
      // facets-brand.liquid), so no filter-label matching is involved. Reads the DOM's
      // post-count-pass state rather than re-deriving counts from the payload.
      updateBrandExtras: function () {
        const brandLists = new Set()
        document.querySelectorAll('[data-brand-value]').forEach(el => {
          const ul = el.closest('ul')
          if (ul) brandLists.add(ul)
        })
        if (brandLists.size === 0) return

        // Guard letters that aren't plain [A-Z0-9] before using them in a selector.
        const esc = window.CSS && CSS.escape ? CSS.escape : (s => s)

        brandLists.forEach(ul => {
          // Hide an alpha-group header (A, B, C…) when every brand under that letter is hidden.
          ul.querySelectorAll('li.brands__alpha-group').forEach(header => {
            const letter = header.getAttribute('data-value')
            if (letter === null) return
            const visible = ul.querySelectorAll(`li.tag[data-alpha-group="${esc(letter)}"]:not(.hide)`).length
            if (visible === 0) {
              header.classList.add('hide')
            } else {
              header.classList.remove('hide')
            }
          })

          // Show the brand search box only when there are enough visible brands to be
          // worth searching (mirrors the Liquid > 4 threshold in collection-grid-filters-form-v2).
          const visibleBrands = ul.querySelectorAll('li.tag:not(.hide)').length
          const searchWrapper = ul.closest('.accordion-content')?.querySelector('.filter-search--wrapper')
          if (searchWrapper) {
            searchWrapper.style.display = visibleBrands > 4 ? '' : 'none'
          }
        })
      },

      updateFilter: function (html) {
        this.updateCategory(html)
        this.updateFilterCounts(html)
        this.updateBrandExtras()
      },

      // IMPORTANT: This fetches sections/collection-count.liquid via Section Rendering API.
      // That section is NOT in any template JSON — it exists solely for this AJAX call.
      //
      // F4: plain `async` function rather than `new Promise(async …)`. The old wrapper
      // could leave the promise pending forever if anything threw before its inner
      // try/catch; an async function rejects on any throw, so callers can't hang.
      // F1: returns a DISCRIMINATED result so executeFilterUpdate can tell the three
      // outcomes apart instead of collapsing them all to null:
      //   - { data, html }  → success
      //   - { aborted: true } → superseded by a newer fetch (not a failure, no toast)
      //   - { error: true }   → genuine failure (toast already shown here, keep it)
      getFilterUpdates: async function (isFromReset) {
        if (this.filterAbortController) this.filterAbortController.abort()
        this.filterAbortController = new AbortController()
        var fetchSignal = this.filterAbortController.signal

        // Whole body inside try/catch so this function is TOTAL — it always resolves to
        // a discriminated object and never rejects. Both callers `await` it WITHOUT a
        // try/catch and depend on the code that runs AFTER the await (clearing
        // _countFetchPending and the stale-input dimming); a reject would skip that and
        // leave the filter checkboxes stuck dimmed. Completes F4: no path can hang OR throw.
        try {
          const inputs = this.container.querySelectorAll('input:checked')
          const queryParams = new URLSearchParams();
          const uniqueParams = new Set();

          if (window.location.pathname.includes('search')) {
            // Include existing query parameters if on the search page
            const existingParams = new URLSearchParams(window.location.search);
            existingParams.forEach((value, key) => {
              const paramKey = `${key}=${value}`;
              if (!uniqueParams.has(paramKey)) {
                queryParams.append(key, value);
                uniqueParams.add(paramKey);
              }
            });
          }

          inputs.forEach(input => {
            const name = input.getAttribute('name');
            const value = input.getAttribute('value');
            const paramKey = `${name}=${value}`;
            if (name && value && !uniqueParams.has(paramKey)) {
              queryParams.append(name, value);
              uniqueParams.add(paramKey);
            }
          });

          // Iron-clad scope enforcement via the shared authority: strips any
          // stale/conflicting gender copied from the URL and stamps the
          // source-of-truth scope, so the count fetch can never carry BOTH
          // genders (Shopify would OR them) nor lose the scope when the gender
          // facet checkbox is absent. See theme.enforceSearchScope.
          theme.enforceSearchScope(queryParams);

          let url = `${window.location.origin}${window.location.pathname}?${queryParams.toString()}&section_id=collection-count&sort_by=price-descending`

          if (!url.includes('filter.v.availability=1')) {
            url = url + '&filter.v.availability=1'
          }

          const response = await fetch(url, { signal: fetchSignal });
          const html = await response.text()

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const scriptTag = doc.querySelector('script[data-product-count]');

          if (scriptTag) {
            const jsonData = scriptTag.textContent;

            // Parse the JSON data (throws on malformed payload → caught below as an error)
            const data = JSON.parse(jsonData);
            this.filterAbortController = null
            return { data, html: doc }
          }
          // Response arrived but the count payload was missing — surface it as a
          // failure so the user gets feedback rather than a silently stale badge.
          this.filterAbortController = null
          this.showFilterError()
          return { error: true }
        }
        catch (error) {
          // Aborted = a newer fetch superseded this one. Not a failure: no toast.
          if (error.name === 'AbortError') {
            return { aborted: true }
          }
          console.warn('[filter] getFilterUpdates fetch error:', error)
          this.showFilterError()
          return { error: true }
        }
      },

      tagClick: function (evt) {
        var el = evt.currentTarget;
        evt.preventDefault()

        const name = el.dataset.name
        const value = el.dataset.value
        const isAll = el.dataset.isAll === 'true'

        if (isAll) {
          // "All X" pill: uncheck the "All X" checkbox and all its individual items
          const allCheckbox = document.querySelector(`#FilterDrawer input[data-name="${name}"]`)
          if (allCheckbox) {
            allCheckbox.checked = false
            allCheckbox.closest('li.tag')?.classList.remove('tag--active')
            const list = allCheckbox.closest('.filter__list')
            if (list) {
              list.querySelectorAll('.tag__input').forEach(input => {
                input.checked = false
                input.closest('li.tag')?.classList.remove('tag--active')
              })
            }
          }
        } else {
          const inputs = document.querySelectorAll(`input[name="${name}"][value="${value}"]`)
          if (inputs.length > 0) {
            inputs.forEach(input => {
              input.checked = false
              input.removeAttribute('checked')
              const li = input.parentNode.parentNode
              if (li.classList.contains('tag--active')) { li.classList.remove('tag--active') }

              // Auto-uncheck "All" checkbox for this group
              const list = input.closest('.filter__list')
              if (list) {
                const allInput = list.querySelector('.tag__input--all:checked')
                if (allInput) {
                  allInput.checked = false
                  const allLi = allInput.closest('li.tag')
                  if (allLi) allLi.classList.remove('tag--active')
                }
              }

              const mblInput = document.querySelector(`#FilterDrawerMobile input[data-name="${name}"][data-value="${value}"]`)
              if (mblInput) {
                mblInput.checked = false
                const inputWrapper = mblInput.closest('li.tag')
                if (inputWrapper) {
                  inputWrapper.classList.remove('tag--active')
                }
              }
            })
          }
        }

        el.remove()

        var srRegion = document.getElementById('filter-sr-announcements')
        if (srRegion) srRegion.textContent = theme.strings.filterSrFilterRemoved

        this.executeFilterUpdate()
        this.scheduleBackgroundUpdate()
      },

      renderSelectedElement: function () {
        const checkedEl = document.querySelectorAll('#FilterDrawer .tag__checkbox-wrapper')

        // Build set of specific name=value pairs covered by each checked "All X" group.
        // Only items in that group are suppressed — items from other subcategories still show.
        const allGroupValues = new Set()
        document.querySelectorAll('#FilterDrawer .tag__input--all:checked').forEach(allInput => {
          const list = allInput.closest('.filter__list')
          if (list) {
            list.querySelectorAll('.tag__input:not(.tag__input--all)').forEach(input => {
              const n = input.getAttribute('name')
              const v = input.getAttribute('value')
              if (n && v) allGroupValues.add(n + '=' + v)
            })
          }
        })

        let removableContent = ""
        checkedEl.forEach(label => {
          const inputEl = label.querySelector('input:checked')

          if (inputEl) {
            const isAllCheckbox = inputEl.classList.contains('tag__input--all')
            // Skip individual items whose group has an "All X" checked
            if (!isAllCheckbox && allGroupValues.has(inputEl.getAttribute('name') + '=' + inputEl.value)) {
              return
            }
            const text = label.querySelector('.tag__text').textContent
            let name = inputEl.getAttribute('name')
            if (!name) {
              name = inputEl.getAttribute('data-name')
            }

            // Gender scope is a mode, not a removable filter — never render
            // it as a pill (mirrors active-filter-pills.liquid).
            if (name === 'filter.p.tag') return

            if (text.toLowerCase() != 'in stock') {
              let deleteUrl
              if (isAllCheckbox) {
                // "All" pill: build URL removing every individual value in the group
                const deleteQuery = new URLSearchParams(window.location.search)
                const list = inputEl.closest('.filter__list')
                if (list) {
                  list.querySelectorAll('.tag__input:not(.tag__input--all)').forEach(groupInput => {
                    const gName = groupInput.getAttribute('name')
                    const gValue = groupInput.getAttribute('value')
                    if (gName && gValue) {
                      const remaining = deleteQuery.getAll(gName).filter(v => v !== gValue)
                      deleteQuery.delete(gName)
                      remaining.forEach(v => deleteQuery.append(gName, v))
                    }
                  })
                }
                deleteUrl = window.location.pathname + '/?' + deleteQuery.toString()
              } else {
                // Individual pill: remove this specific value
                const deleteQuery = new URLSearchParams(window.location.search)
                const paramValues = deleteQuery.getAll(name).filter(value => value !== inputEl.value)
                deleteQuery.delete(name)
                paramValues.forEach(value => deleteQuery.append(name, value))
                deleteUrl = `${window.location.pathname}/?${deleteQuery.toString()}`
              }

              const li = `
                <li class="tag tag--remove">
                  <a class="btn btn--small" href="${deleteUrl}" data-name="${name}" data-value="${inputEl.value}"${isAllCheckbox ? ' data-is-all="true"' : ''} aria-label="${theme.strings.filterSrRemoveFilter.replace('[filter]', text)}">
                    ${text}
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg>
                  </a>
                </li>
              `
              removableContent = removableContent + li
            }
          }
        })

        var tagsEl = document.querySelectorAll('.tag-list.tag-list--active-tags')

        tagsEl.forEach(function (item) {
          item.innerHTML = removableContent
        })
      },

      syncAllCheckboxes: function () {
        document.querySelectorAll('#CollectionSidebar .tag__input--all').forEach(function (allInput) {
          var list = allInput.closest('.filter__list')
          if (!list) return
          var items = list.querySelectorAll('li.tag:not(.hide) .tag__input:not(.tag__input--all)')
          var checked = list.querySelectorAll('li.tag:not(.hide) .tag__input:not(.tag__input--all):checked')
          var shouldBeChecked = items.length > 0 && items.length === checked.length
          allInput.checked = shouldBeChecked
          var li = allInput.closest('li.tag')
          if (li) li.classList.toggle('tag--active', shouldBeChecked)
        })
      },

      // Handles every desktop filter form input change. Runs synchronously for UI sync:
      // "All" checkbox toggling, tag-active class, desktop→mobile mirror, category
      // mutual exclusion. Then triggers two async paths:
      //   1. executeFilterUpdate() — immediate count + filter option refresh
      //   2. scheduleBackgroundUpdate() — debounced product grid prefetch
      // Search inputs return early (immediate client-side filtering, no fetch).
      onFormInput: function (evt) {
        var el = evt.target;

        // "All" checkbox: auto-check/uncheck all individual items in the group
        if (el.classList.contains('tag__input--all')) {
          var list = el.closest('.filter__list')
          if (list) {
            list.querySelectorAll('.tag__input:not(.tag__input--all)').forEach(function (input) {
              input.checked = el.checked
              var li = input.closest('li.tag')
              if (li) li.classList.toggle('tag--active', el.checked)
            })
          }
          var allLi = el.closest('li.tag')
          if (allLi) allLi.classList.toggle('tag--active', el.checked)
        }

        // Search filtering — immediate, no fetch pipeline
        if (el.hasAttribute('data-filter-search-input')) {
          var params = el.value
          var ref = el.dataset.parentId
          var filterInfo = this.searchEnabledFilters.find(function (_) { return _.parentId == ref })

          if (filterInfo) {
            var alphaList = filterInfo.parent.querySelectorAll('.brands__alpha-group')
            alphaList.forEach(function (item) { item.classList.add('hidden') })
            var normalizedParams = this.normalizeString(params.toLowerCase())
            var filteredList = filterInfo.values.filter(function (_) { return this.normalizeString(_).includes(normalizedParams) }.bind(this))
            filterInfo.items.forEach(function (item) {
              var value = item.dataset.filterValue.toLowerCase()
              if (!filteredList.includes(value)) {
                if (!item.classList.contains('hidden')) item.classList.add('hidden')
              } else {
                if (item.classList.contains('hidden')) item.classList.remove('hidden')
                if (alphaList.length > 0) {
                  filterInfo.parent.querySelector('.brands__alpha-group[data-value="' + item.dataset.alphaGroup + '"]')
                    .classList.remove('hidden')
                }
              }
            })
            filterInfo.parent.style.height = 'unset'
          }
          return
        }

        // Tag-active class toggle
        if (!el.checked) {
          var li = el.parentNode.parentNode
          if (li.classList.contains('tag--active')) li.classList.remove('tag--active')

          // Auto-uncheck "All" when an individual item is deselected
          if (!el.classList.contains('tag__input--all')) {
            var list = el.closest('.filter__list')
            if (list) {
              var allInput = list.querySelector('.tag__input--all:checked')
              if (allInput) {
                allInput.checked = false
                var allLi = allInput.closest('li.tag')
                if (allLi) allLi.classList.remove('tag--active')
              }
            }
          }
        }

        // Desktop → mobile mirror
        var mirrorInput = this.container.querySelector('input[data-name="' + el.name + '"][data-value="' + el.value + '"]')
        if (mirrorInput) mirrorInput.checked = el.checked

        // Category mutual exclusion
        var parent = el.closest('[data-category-main]')
        if (parent) {
          this.clearOtherMainCategory(parent)
        }

        // A1: Count + filter update fires immediately (no debounce)
        this.executeFilterUpdate()
        // A2: Product prefetch debounced at 300ms (parallel with count)
        this.scheduleBackgroundUpdate()
      },

      toggleSizeFilter: function (isActive) {
        const sizeFilterWrapper = document.querySelectorAll(`.slide-nav__item.mobile-nav__item[data-size], .accordion-item[data-label="size"]`)
        if (sizeFilterWrapper.length !== 0) {
          sizeFilterWrapper.forEach(item => {
            if (isActive) {
              item.classList.remove('hidden')
            } else {
              item.classList.add('hidden')
            }
          })
        }
      },

      clearOtherMainCategory: function (currentCategory) {
        theme.utils.clearOtherMainCategory(currentCategory, this.container)
      },

      onFormSubmit: function (evt) {
        var el = evt.target;

        const isSearch = el.hasAttribute('data-filter-search-input')

        if (isSearch) {
          const params = el.value
          const ref = el.dataset.parentId
          const filterInfo = this.searchEnabledFilters.find(_ => _.parentId == ref)

          if (filterInfo) {
            const normalizedParams = this.normalizeString(params.toLowerCase())
            const filteredList = filterInfo.values.filter(_ => this.normalizeString(_).includes(normalizedParams))
            filterInfo.items.forEach(el => {
              const value = el.dataset.filterValue.toLowerCase()
              if (!filteredList.includes(value)) {
                if (!el.classList.contains('hidden')) el.classList.add('hidden')
              }
              else {
                if (el.classList.contains('hidden')) el.classList.remove('hidden')
              }
            })
            filterInfo.parent.style.height = 'unset'
          }
        }
        else {
          if (theme.FilterDrawer) {
            theme.FilterDrawer.close();
          }

          if (theme.FilterDrawerMobile) {
            theme.FilterDrawerMobile.close();
          }

          // Do not ajax-load collection links
          if (el.classList.contains('no-ajax')) {
            return;
          }

          evt.preventDefault();
          if (isAnimating) {
            return;
          }

          isAnimating = true;

          const parent = el.closest('li');
          const formEl = el.closest('form');

          this.renderActiveTag(parent, el);

          // If background update already applied products to the grid
          if (this._prefetchReady) {
            this._prefetchReady = false
            isAnimating = false
            return
          }

          // If background update is in progress, show page loading and finish when it completes
          if (this._prefetchController) {
            this.startLoading()
            this._applyOnComplete = true
            return
          }

          // Fallback: no prefetch — use current behavior
          const formData = new FormData(formEl);

          if (el.getAttribute('name') == 'filter.v.availability' && el.value == 0) {
            if (el.checked) {
              formData.set("filter.v.availability", "0")
              formData.delete("all_items")
            }
          }
          if (el.getAttribute('name') == 'filter.v.availability' && el.value == 1) {
            if (el.checked) {
              formData.set("filter.v.availability", "1")
              formData.delete("all_items")
            }
          }
          if (el.getAttribute('name') == 'all_items') {
            if (el.checked) {
              formData.delete("filter.v.availability")
            }
            else {
              formData.set("filter.v.availability", "1")
            }
          }
          this.startLoading();
          this.renderFromFormData(formData);
        }
      },

      fetchOpenCollasibleFilters: function () {
        return Array.from(
          document.querySelectorAll(
            `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
          ),
        ).map(trigger => trigger.dataset.collapsibleId);
      },

      renderActiveTag: function (parent, el) {
        if (parent) {
          const textEl = parent.querySelector('.tag__text');

          if (parent.classList.contains(classes.activeTag)) {
            parent.classList.remove(classes.activeTag);
          } else {
            parent.classList.add(classes.activeTag);

            // If adding a tag, show new tag right away.
            // Otherwise, remove it before ajax finishes
            if (el.closest('li').classList.contains(classes.removeTagParent)) {
              parent.remove();
            } else {
              // Append new tag in both drawer and sidebar
              document.querySelectorAll(selectors.activeTagList).forEach(list => {
                const newTag = document.createElement('li');
                const newTagLink = document.createElement('a');
                newTag.classList.add('tag', 'tag--remove');
                newTagLink.classList.add('btn', 'btn--small');
                newTagLink.innerText = textEl.innerText;
                newTag.appendChild(newTagLink);

                list.appendChild(newTag);
              });
            }
          }
        }
      },

      renderFromFormData: function (formData) {
        const searchParams = new URLSearchParams(formData);
        this.renderCollectionPage(searchParams);
      },

      onReplaceAjaxContent: function (newDom, section) {
        const openCollapsibleIds = this.fetchOpenCollasibleFilters();

        openCollapsibleIds.forEach(selector => {
          newDom
            .querySelectorAll(`[data-collapsible-id=${selector}]`)
            .forEach(this.openCollapsible);
        });

        var newContentEl = newDom.getElementById(section.nodeId);
        if (!newContentEl) {
          return;
        }

        document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;
      },

      openCollapsible: function (el) {
        if (el.classList.contains(classes.filterSidebar)) {
          el.style.height = 'auto';
        }

        el.classList.add(classes.isOpen);
      },

      renderCollectionPage: function (searchParams, updateURLHash = true) {
        var savedCount = updateURLHash
          ? (document.querySelector('span[data-count]')?.innerHTML || '')
          : ''

        this.ajaxRenderer
          .renderPage(window.location.pathname, searchParams, updateURLHash)
          .then(() => {
            theme.sections.reinit('collection-grid');
            theme.reinitProductGridItem();

            document.dispatchEvent(new CustomEvent('collection:reloaded', { detail: { searchParams } }));

            isAnimating = false;

            this.sidebar.reInit(this.container)
            this.syncAllCheckboxes()
            this.renderSelectedElement()

            if (savedCount) {
              document.querySelectorAll('span[data-count]').forEach(span => {
                span.innerHTML = savedCount
              })
            }

            var triggerBtn = document.querySelector('.js-drawer-open-collection-filters')
            if (triggerBtn) triggerBtn.focus({ preventScroll: true })
          });
      },

      bindBackButton: function () {
        // Ajax page on back button
        window.off('popstate' + this.namespace);
        window.on('popstate' + this.namespace, function (state) {
          if (state) {
            const newUrl = new URL(window.location.href);
            this.renderCollectionPage(newUrl.searchParams, false);
          }
        }.bind(this));
      },

      setFilterStickyPosition: function () {

        if (window.innerWidth < 769) {
          // Header doesn't exist on cart/checkout-error states — early-return
          // instead of throwing. filtersWrapper similarly may be absent.
          var siteHeader = document.querySelector('.site-header');
          if (!siteHeader) return;
          var headerHeight = siteHeader.offsetHeight;

          var filtersWrapper = document.querySelector(selectors.filtersWrapper);
          if (filtersWrapper) filtersWrapper.style.top = headerHeight + -1 + 'px';

          // Also update top position of sticky sidebar
          var stickySidebar = document.querySelector('.grid__item--sidebar');
          if (stickySidebar) {
            stickySidebar.style.top = headerHeight + 10 + 'px';
          }
        }
      },

      forceReload: function () {
        this.init();
      },

      // Farfetch-style background prefetch: fetches the full collection page sections
      // (product grid + collection header) in parallel while the filter drawer is still open.
      // Results are cached. When user clicks "Show Results", the cached HTML is applied
      // instantly via surgical DOM replacement (only .grid__item--content is swapped,
      // not the filter sidebar). If the fetch is still in-flight when the user closes
      // the drawer, _applyOnComplete ensures it applies when ready.
      backgroundUpdatePage: function () {
        // Cancel any existing background update
        if (this._prefetchController) this._prefetchController.abort()
        this._prefetchController = new AbortController()
        this._prefetchReady = false
        this.setShowResultsState('loading')

        // Build search params from currently checked inputs
        const inputs = this.container.querySelectorAll('input:checked')
        const queryParams = new URLSearchParams()
        const uniqueParams = new Set()

        if (window.location.pathname.includes('search')) {
          const existingParams = new URLSearchParams(window.location.search)
          existingParams.forEach((value, key) => {
            const paramKey = `${key}=${value}`
            if (!uniqueParams.has(paramKey)) {
              queryParams.append(key, value)
              uniqueParams.add(paramKey)
            }
          })
        }

        inputs.forEach(input => {
          const name = input.getAttribute('name')
          const value = input.getAttribute('value')
          const paramKey = `${name}=${value}`
          if (name && value && !uniqueParams.has(paramKey)) {
            queryParams.append(name, value)
            uniqueParams.add(paramKey)
          }
        })

        if (!queryParams.has('filter.v.availability')) {
          queryParams.append('filter.v.availability', '1')
        }

        const updatedParams = this.ajaxRenderer.getUpdatedParams(
          new URLSearchParams(window.location.search),
          queryParams
        )

        // Scope wins on the merged params before we build the prefetch URLs
        // (these same params are pushed to history on apply, line below) — the
        // grid fetch and the address bar must both carry exactly the current
        // scope, never a stale URL gender. See theme.enforceSearchScope.
        theme.enforceSearchScope(updatedParams)

        const signal = this._prefetchController.signal

        // Fetch each section in parallel
        const fetchPromises = this.ajaxRenderer.sections.map(section => {
          const url = `${window.location.pathname}?section_id=${section.sectionId}&${updatedParams.toString()}`
          return fetch(url, { signal })
            .then(r => r.text())
            .then(html => ({ html, section }))
        })

        Promise.all(fetchPromises)
          .then(results => {
            // Surgical DOM replacement: only the product grid, not the filters
            results.forEach(({ html, section }) => {
              const newDom = new DOMParser().parseFromString(html, 'text/html')

              if (section.nodeId === 'CollectionAjaxContent') {
                // Only replace .grid__item--content (products + pagination)
                const newGrid = newDom.querySelector('.grid__item--content')
                const liveGrid = document.querySelector('.grid__item--content')
                if (newGrid && liveGrid) {
                  liveGrid.innerHTML = newGrid.innerHTML
                }
              } else {
                // Collection header — safe to replace entirely
                const newEl = newDom.getElementById(section.nodeId)
                const liveEl = document.getElementById(section.nodeId)
                if (newEl && liveEl) {
                  liveEl.innerHTML = newEl.innerHTML
                }
              }
            })

            // Update browser URL
            this.ajaxRenderer.updateURLHash(updatedParams)

            // Re-init product grid (sidebar was NOT replaced, no reInit needed)
            theme.reinitProductGridItem()
            document.dispatchEvent(new CustomEvent('collection:reloaded', { detail: { searchParams: updatedParams } }))

            this._prefetchReady = true
            this._prefetchController = null
            this.setShowResultsState('ready')

            // If user closed the drawer while we were fetching, clean up loading state
            if (this._applyOnComplete) {
              this._applyOnComplete = false
              isAnimating = false
              var gridWrapper = document.querySelector(selectors.collectionGrid)
              if (gridWrapper) gridWrapper.classList.remove('unload')
            }
          })
          .catch(err => {
            if (err.name === 'AbortError') return
            console.warn('[filter] background update error:', err)
            this._prefetchReady = false
            this._prefetchController = null
            this.setShowResultsState('idle')
          })
      },

      setShowResultsState: function (state) {
        document.querySelectorAll('.show__all_button').forEach(btn => {
          if (state === 'loading') {
            btn.classList.add('is-loading')
            btn.setAttribute('aria-busy', 'true')
            if (!btn.querySelector('.btn-spinner')) {
              const spinner = document.createElement('span')
              spinner.className = 'btn-spinner'
              spinner.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="31.4 31.4" stroke-linecap="round"/></svg>'
              btn.appendChild(spinner)
            }
          } else {
            btn.classList.remove('is-loading')
            btn.removeAttribute('aria-busy')
            const spinner = btn.querySelector('.btn-spinner')
            if (spinner) spinner.remove()
          }
        })
      },

      startLoading: function () {
        document.querySelector(selectors.collectionGrid).classList.add('unload');
      },
    });

    return Collection;
  })();

  theme.FooterSection = (function () {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };

    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;

      this.init();
    }

    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }

        // Change email icon to submit text
        var newsletterInput = document.querySelector('.footer__newsletter-input');
        if (newsletterInput) {
          newsletterInput.addEventListener('keyup', function () {
            newsletterInput.classList.add('footer__newsletter-input--active');
          });
        }

        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },

      onUnload: function () {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });

    return FooterSection;
  })();

  class HeaderOpacityChanger {
    constructor(headerSelector, topBarSelector, logoSelector, descriptionContainerSelector, maxDistance) {
      this.siteHeader = document.querySelector(headerSelector);
      this.headerTopbar = document.querySelector(topBarSelector);
      this.siteHeaderLogoLink = document.querySelector(logoSelector);
      this.productDescriptionContainer = document.querySelector(descriptionContainerSelector);
      this.maxDistance = maxDistance;

      if (this.siteHeader && this.productDescriptionContainer) {
        this.init();
      }
    }

    init() {
      // RAF-throttle scroll/resize to avoid forced reflows on every raw event.
      // Without this, two getBoundingClientRect() calls fire per scroll event
      // (240/sec on 120Hz displays), causing layout thrashing and scroll jank.
      this._rafId = null;
      this._boundUpdate = () => {
        if (!this._rafId) {
          this._rafId = requestAnimationFrame(() => {
            this.updateBackgroundColorBasedOnScroll();
            this._rafId = null;
          });
        }
      };
      this._boundUpdate();
      window.addEventListener('scroll', this._boundUpdate);
      window.addEventListener('resize', this._boundUpdate);
    }

    calculateOpacity(distance) {
      return Math.max(0, Math.min(1, (this.maxDistance - distance) / this.maxDistance));
    }

    updateBackgroundColorBasedOnScroll() {
      const productRect = this.productDescriptionContainer.getBoundingClientRect();
      const headerRect = this.siteHeader.getBoundingClientRect();
      const distance = productRect.top - headerRect.bottom;
      const opacity = this.calculateOpacity(distance);

      if (window.innerWidth >= 769) {
        // Set CSS variable instead of inline backgroundColor
        this.siteHeader.style.setProperty('--scroll-opacity', opacity);
        if (this.headerTopbar) {
          this.headerTopbar.style.setProperty('--scroll-opacity', opacity);
        }
      } else if (this.siteHeaderLogoLink) {
        // Mobile: still use direct opacity for logo
        this.siteHeader.style.setProperty('--scroll-opacity', opacity);
        this.siteHeaderLogoLink.style.opacity = opacity;
        // Enable pointer events if opacity is full, otherwise disable them
        this.siteHeaderLogoLink.style.pointerEvents = opacity === 1 ? 'auto' : 'none';
      }

      if (distance > this.maxDistance) {
        if (window.innerWidth >= 769) {
          this.siteHeader.style.setProperty('--scroll-opacity', 0);
          if (this.headerTopbar) {
            this.headerTopbar.style.setProperty('--scroll-opacity', 0);
          }
        } else if (this.siteHeaderLogoLink) {
          this.siteHeaderLogoLink.style.opacity = '0';
          this.siteHeaderLogoLink.style.pointerEvents = 'none';
        }
      }

      if (distance <= 0) {
        document.body.classList.add('header-touching');
      } else {
        document.body.classList.remove('header-touching');
      }
    }

    destroy() {
      // Removes the scroll/resize window listeners and cancels any pending RAF.
      // Caller (e.g. Product.init re-running on quick-view re-open) should call
      // destroy() on the previous instance before creating a new one to avoid
      // multiple HeaderOpacityChanger instances reading getBoundingClientRect()
      // on every scroll for the same scroll position.
      if (this._boundUpdate) {
        window.removeEventListener('scroll', this._boundUpdate);
        window.removeEventListener('resize', this._boundUpdate);
        this._boundUpdate = null;
      }
      if (this._rafId) {
        cancelAnimationFrame(this._rafId);
        this._rafId = null;
      }
    }
  }

  theme.HeaderSection = (function () {

    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };

    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');

      this.init();
    }

    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function () {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit('slideshow-section');

          // Set a timer to resize the header in case the logo changes size
          setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
          }, 500);
        }

        this.initDrawers();
        this.initDisclosures();
        this.initCurrencySearch();
        theme.headerNav.init();
        theme.announcementBar.init();

        new theme.MobileNav({
          id: 'NavDrawer'
        });
      },

      initDisclosures: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },

      initDrawers: function () {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        if (theme.settings.cartType === 'drawer' || theme.settings.cartType == 'hybrid') {
          if (!document.body.classList.contains('template-cart')) {
            new theme.CartDrawer();
          }
        }

        theme.collapsibles.init(document.getElementById('NavDrawer'));
      },

      initCurrencySearch: function () {
        const searchParent = document.querySelector('.lang--drawer [data-search-parent]');
        const searchInput = searchParent.querySelector('#currencySearchDrawer');
        const listItems = searchParent.querySelectorAll('.slide-nav li.slide-nav__item');

        searchInput.addEventListener('input', e => {
          const target = e.currentTarget;
          const query = target.value.trim().toLowerCase();

          listItems.forEach(item => {
            const country = item.getAttribute('data-country').toLowerCase();
            const currencyIso = item.getAttribute('data-currency-iso').toLowerCase();
            const currencySymbol = item.getAttribute('data-currency-symbol').toLowerCase();

            if (country.includes(query) || currencyIso.includes(query) || currencySymbol.includes(query)) {
              item.classList.remove('hidden');
            } else {
              item.classList.add('hidden');
            }
          });

          if (query === '') {
            listItems.forEach(item => item.classList.remove('hidden'));
          }
        })
      },

      onBlockSelect: function (evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },

      onBlockDeselect: function () {
        theme.announcementBar.onBlockDeselect();
      },

      onUnload: function () {
        theme.NavDrawer.close();
        theme.announcementBar.unload();

        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });

    return HeaderSection;
  })();

  theme.Product = (function () {
    var videoObjects = {};

    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };

    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
      variantType: '.variant-wrapper',
      blocks: '[data-product-blocks]',
      blocksHolder: '[data-blocks-holder]',
      dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
    };

    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
      var productId = this.productId = container.getAttribute('data-product-id');
      var templateVersion = this.templateVersion = container.getAttribute('data-template-version')

      this.inModal = (container.dataset.modal === 'true');
      this.modal;

      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }

      this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        form: '.product-single__form',

        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '[data-product-thumb]',
        thumbSlider: '[data-product-thumbs]',
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '[data-product-photos]',
        imageContainer: '[data-product-images]',
        productImageMain: '[data-product-image-main]',

        priceWrapper: '[data-product-price-wrap]',
        price: '[data-product-price]',
        comparePrice: '[data-compare-price]',
        savePrice: '[data-save-price]',
        priceA11y: '[data-a11y-price]',
        comparePriceA11y: '[data-compare-price-a11y]',
        unitWrapper: '[data-unit-price-wrapper]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-base]',
        sku: '[data-sku]',
        inventory: '[data-product-inventory]',
        incomingInventory: '[data-incoming-inventory]',
        colorLabel: '[data-variant-color-label]',

        addToCart: '[data-add-to-cart]',
        addToCartSecondary: '[data-add-to-cart-secondary]',
        addToCartText: '[data-add-to-cart-text]',
        addToCartSecondaryText: '[data-add-to-cart-secondary-text]',

        originalSelectorId: '[data-product-select]',
        singleOptionSelector: '[data-variant-input]',
        variantColorSwatch: '.variant__input--color-swatch',
        dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',

        availabilityContainer: '[data-store-availability-holder]',

        optionTrigger: '.option-selector--trigger',
      };

      this.cacheElements();

      if (this.templateVersion != 'v2') {
        this.firstProductImage = this.cache.mainSlider.querySelector('img');

        if (!this.firstProductImage) {
          this.settings.hasImages = false;
        }

        var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
        if (dataSetEl) {
          this.settings.imageSetName = dataSetEl.dataset.setName;
        }
      }
      this.init();
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      init: function () {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          // Store bound refs so onUnload can remove them. .bind(this) creates a new
          // function each call, so the originals at registration are otherwise
          // unreachable for removeEventListener — every section reload leaked them.
          this._modalEventNamespace = 'QuickShopModal-' + this.productId;
          this._boundOpenModalProduct = this.openModalProduct.bind(this);
          this._boundCloseModalProduct = this.closeModalProduct.bind(this);
          document.addEventListener('modalOpen.' + this._modalEventNamespace, this._boundOpenModalProduct);
          document.addEventListener('modalClose.' + this._modalEventNamespace, this._boundCloseModalProduct);
        }

        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.addIdToRecentlyViewed();
          this.initVariantSelector();
        }
        if (!this.inModal && this.templateVersion !== 'v2') {
          this.initProductSlider();
          this.customMediaListners();
        } else {
          this.initProductSliderV2()
        }

        if (this.templateVersion == 'v2') {
          this.initHeaderOpacityChanger()
        }
      },

      initHeaderOpacityChanger: function () {
        const headerSelector = '.site-header';
        const topBarSelector = '.toolbar';
        const logoSelector = '.site-header__logo a';
        const descriptionContainerSelector = '.product-discription--container';

        const siteHeader = document.querySelector(headerSelector);
        const siteHeaderLogoLink = document.querySelector(logoSelector);
        const productDescriptionContainer = document.querySelector(descriptionContainerSelector);
        if (siteHeader && siteHeaderLogoLink && productDescriptionContainer) {
          // Dispose any previous instance before creating a new one. Without this,
          // Product.init being re-run (quick view re-open, variant change re-init,
          // section reload) leaks a HeaderOpacityChanger that keeps running its
          // scroll/resize handlers against detached DOM, causing scroll jank.
          if (this._headerOpacityChanger && typeof this._headerOpacityChanger.destroy === 'function') {
            this._headerOpacityChanger.destroy();
          }
          this._headerOpacityChanger = new HeaderOpacityChanger(headerSelector, topBarSelector, logoSelector, descriptionContainerSelector, 400);
        }
      },

      doSlidesOverflow: function (wrapperEl) {
        if (window.innerWidth < 769) return true;

        const slideEls = Array.from(wrapperEl.children);
        const totalSlidesWidth = slideEls.reduce((sum, child) => sum + child.offsetWidth, 0);
        const totalGapWidth = (slideEls.length - 1) * 150;
        return (totalSlidesWidth + totalGapWidth) > window.innerWidth;
      },

      initProductSliderV2: function () {
        const initializeSwiper = () => {
          // Guard against Swiper not loaded yet (vendor script race condition under throttled networks)
          if (typeof Swiper === 'undefined') return;
          const sliderEl = document.querySelector(this.selectors.mainSlider);
          const wrapper = sliderEl?.querySelector('.product-slideshow--wrapper');
          if (!sliderEl || !wrapper) return;

          // Determine if slides overflow the viewport
          const shouldActivateSwiper = this.doSlidesOverflow(wrapper);

          if (!shouldActivateSwiper) {
            wrapper.classList.add('is-centered');
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
            return;
          }

          // Images overflow — activate Swiper for scrolling
          wrapper.classList.remove('is-centered');

          // Destroy previous instance before re-creating (resize path)
          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }

          // Smart preload-ahead: promote the next 2 slides from lazy to eager
          // whenever the active slide changes. The first 5 slides ship eager
          // from the server (snippets/media.liquid); this handles slide 6+ on
          // products with deep slideshows. Bandwidth scales with how far the
          // customer actually swipes -- no waste on slides they never view.
          //
          // Setting loading="eager" alone isn't reliable post-parse in every
          // browser; .decode() forces a network fetch + decode and is well
          // supported (Chrome 63+, Safari 12+, Firefox 63+). Catch swallows
          // failed decodes so a single broken image doesn't break the chain.
          const preloadAdjacent = (swiper) => {
            if (!swiper || !swiper.slides) return;
            const idx = swiper.activeIndex;
            [idx + 1, idx + 2].forEach((i) => {
              const slide = swiper.slides[i];
              if (!slide) return;
              const img = slide.querySelector('img[loading="lazy"]');
              if (!img) return;
              img.loading = 'eager';
              if (typeof img.decode === 'function') {
                img.decode().catch(() => {});
              }
            });
          };

          const mainSliderConfig = {
            slidesPerView: 'auto',
            direction: 'horizontal',
            touchEventsTarget: 'container',

            observer: false,
            observeParents: false,
            observeSlideChildren: false,
            resizeObserver: false,
            updateOnWindowResize: false,
            speed: 750,

            threshold: 5,

            cssMode: false,
            centeredSlides: false,
            centeredSlidesBounds: false,

            touchStartPreventDefault: false,
            preventInteractionOnTransition: false,

            longSwipesRatio: 0.2,
            touchRatio: 0.85,

            resistance: true,
            resistanceRatio: 0.87,
            watchOverflow: true,
            spaceBetween: 8,

            breakpoints: {
              769: {
                speed: 600,
                spaceBetween: 150,
                slidesOffsetAfter: 0,
                slidesPerGroup: 1,
              }
            },

            navigation: {
              nextEl: '.product-slideshow__nav--next',
              prevEl: '.product-slideshow__nav--prev',
            },

            on: {
              init: function () {
                this.el.addEventListener('dragstart', function (e) {
                  e.preventDefault();
                });

                var indicator = document.querySelector('.product-slide-indicator__bar');
                if (indicator) {
                  indicator.style.transform = 'translateX(0%)';
                }

                preloadAdjacent(this);
              },
              slideChange: function () {
                // Run preload before indicator update so a missing indicator
                // (some templates omit it) doesn't short-circuit the preload.
                preloadAdjacent(this);

                var indicator = document.querySelector('.product-slide-indicator__bar');
                if (!indicator) return;
                var index = this.activeIndex;
                indicator.style.transform = 'translateX(' + (index * 100) + '%)';
              }
            }
          };

          this.swiper = new Swiper(this.selectors.mainSlider, mainSliderConfig);
        };

        // First init
        initializeSwiper();

        // Recalculate on resize (debounced, width-only)
        let resizeTimeout;
        let lastWidth = window.innerWidth;
        this._productResizeHandler = () => {
          if (window.innerWidth === lastWidth) return;
          lastWidth = window.innerWidth;
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            initializeSwiper();
          }, 250);
        };
        window.addEventListener('resize', this._productResizeHandler);

      },

      cacheElements: function () {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
          productImageMain: this.container.querySelector(this.selectors.productImageMain),
          optionsTrigger: this.container.querySelectorAll(this.selectors.optionTrigger),

          // Price-related
          priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
          comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
          comparePrice: this.container.querySelector(this.selectors.comparePrice),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y)
        };
      },

      formSetup: function () {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();

        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },

      initOptionDrawer: function () {
        window.addEventListener('DOMContentLoaded', () => {
          this.optionDrawer = new theme.Drawers('OptionDrawer', 'option')
          //'SingleOptionSelector-{{ section_id }}-{{ product.id }}-option-{{ forloop.index0 }}'

          const options = this.container.querySelectorAll('#OptionDrawer .option-input-wrap')
          options.forEach(option => {
            const index = option.dataset.index == 'option2' ? 1 : option.dataset.index == 'option3' ? 2 : 0
            const section_id = option.dataset.sectionId
            const product_id = option.dataset.productId
            const triggerButton = document.querySelector(`button[aria-controls="OptionDrawer"]`)
            const text = triggerButton?.dataset.displayText
            const selectEl = document.querySelector(`select#SingleOptionSelector-${section_id}-${product_id}-option-${index}`)

            const option_list = option.querySelectorAll('button.btn--option')
            option_list.forEach(item => {
              item.addEventListener('click', (e) => {

                const selected = option.querySelector('button.btn--option[data-selected="true"]')
                if (selected) {
                  selected.setAttribute('data-selected', false)
                }

                const target = e.currentTarget
                const value = target.dataset.value
                const displayValue = target.dataset.displayValue

                // textContent (not innerHTML) — text + displayValue come from
                // merchant-controlled dataset attributes and aren't sanitized.
                triggerButton.textContent = `${text}: ${displayValue}`
                target.setAttribute('data-selected', true)

                selectEl.value = value
                selectEl.dispatchEvent(new Event('change'))

                const option_list_global = this.container.querySelector('.option--list')
                option_list_global.setAttribute('data-selected', true)
              })
            })
          })

          document.addEventListener('ajaxProduct:added:close-drawer', () => {
            this.optionDrawer.close()
          })
        })
      },

      initVariantSelector: function () {
        const selectorWrappers = []

        const options = this.container.querySelectorAll('.variant-wrapper--dropdown[data-type="dropdown"]')
        options.forEach(option => {
          const wrapper = option.querySelector('.option-selector--wrapper');
          const trigger = option.querySelector('.option-selector--trigger');
          const list = option.querySelector('.option--list');

          if (!list) return;
          const items = list.querySelectorAll('.option--item')
          const selectEl = option.querySelector('select');
          const width = window.innerWidth;
          selectorWrappers.push(wrapper)

          trigger.addEventListener('click', e => {
            wrapper.classList.toggle('open')
            const event = new Event('selector:open')
            document.dispatchEvent(event)
          })

          items.forEach(option => {
            option.addEventListener('click', e => {
              e.stopPropagation()
              e.preventDefault()
              const target = e.currentTarget
              const value = target.dataset.value
              const displayValue = target.dataset.displayValue
              selectEl.value = value

              const event = new Event('change');
              selectEl.dispatchEvent(event)

              list.setAttribute('data-selected', true)
              const text = trigger.querySelector('.option-selector--text').dataset.displayText
              trigger.querySelector('.option-selector--text').textContent = `${text}: ${displayValue}`

              const preSelectedItems = list.querySelectorAll('[data-selected="true"]')
              preSelectedItems.forEach(_item => {
                if (!_item.isSameNode(target)) _item.setAttribute('data-selected', false)
              })
              target.setAttribute('data-selected', true)
              if (width > 768) {
                if (wrapper.classList.contains('open')) wrapper.classList.remove('open')
                const event = new Event('selector:close')
                document.dispatchEvent(event)
              }
            })
          })
        })
        this._selectorClickHandler = e => {
          const target = e.target
          selectorWrappers.forEach(_ => {
            const listEl = _.querySelector('.option-list--wrapper')
            const trigger = _.querySelector('.option-selector--trigger')
            if (!trigger.isSameNode(target) && !trigger.contains(target)) {
              if (!target.isSameNode(listEl) && !listEl.contains(target)) {
                if (_.classList.contains('open')) {
                  _.classList.remove('open')
                  const event = new Event('selector:close')
                  document.dispatchEvent(event)
                }
              }
            }
          })
        };
        document.addEventListener('click', this._selectorClickHandler);

        this.initOptionDrawer()
      },
      availabilitySetup: function () {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },

      productSetup: function () {
        if (this.templateVersion !== 'v2') {
          this.setImageSizes();
          this.initImageZoom();
          this.initModelViewerLibraries();
          this.initShopifyXrLaunch();

          if (window.SPR) { SPR.initDomEls(); SPR.loadBadges() }
        }
      },

      setImageSizes: function () {
        if (!this.settings.hasImages) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },

      addIdToRecentlyViewed: function () {
        var handle = this.container.getAttribute('data-product-handle');

        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }

        // Add it back to the end
        theme.recentlyViewed.recent[handle] = true;

        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
      },

      initVariants: function () {
        var variantJson = this.container.querySelector(this.selectors.variantsJson);
        if (!variantJson) {
          return;
        }

        this.variantsObject = JSON.parse(variantJson.innerHTML);
        var dynamicVariantsEnabled = !!this.container.querySelector(selectors.dynamicVariantsEnabled)

        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
          dynamicVariantsEnabled
        };


        var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
        if (swatches.length) {
          swatches.forEach(swatch => {
            swatch.addEventListener('change', function (evt) {
              var color = swatch.dataset.colorName;
              var index = swatch.dataset.colorIndex;
              this.updateColorName(color, index);
            }.bind(this))
          });
        }

        this.variants = new theme.Variants(options);

        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;

          this.storeAvailability.updateContent(variant_id);
          this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
        }

        this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        this.container.on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));

        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }

        var inventoryEl = this.container.querySelector(this.selectors.inventory);
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
          this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }

        // Update individual variant availability on each selection
        if (dynamicVariantsEnabled) {
          var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);

          if (currentVariantJson) {
            var variantType = this.container.querySelector(selectors.variantType);

            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
              });
            }
          }
        }

        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector('.variant-input-wrap[data-handle="' + this.settings.imageSetName + '"]');
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this))
          } else {
            this.settings.imageSetName = null;
          }
        }
      },

      initQtySelector: function () {
        this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: '.product'
          });
        });
      },

      initAjaxProductForm: function () {
        if (theme.settings.cartType === 'drawer' || theme.settings.cartType === 'hybrid') {
          new theme.AjaxProduct(this.cache.form);
        }
      },

      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function (color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"`).textContent = color;
      },

      updateCartButton: function (evt) {
        var variant = evt.detail.variant;

        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnSecondary = this.container.querySelector(this.selectors.addToCartSecondary);

        var cartBtnText = this.container.querySelector(this.selectors.addToCartText);
        var cartBtnSecondaryText = this.container.querySelector(this.selectors.addToCartSecondaryText);

        if (!cartBtn) return;

        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text

            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;

            cartBtnSecondary.classList.remove(classes.disabled);
            cartBtnSecondary.disabled = false;

            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;

            var defaultSecondaryText = cartBtnSecondaryText.dataset.defaultText;
            cartBtnSecondaryText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;

            cartBtnSecondary.classList.add(classes.disabled);
            cartBtnSecondary.disabled = true;
            cartBtnSecondaryText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;

          cartBtnSecondary.classList.add(classes.disabled);
          cartBtnSecondary.disabled = true;
          cartBtnSecondaryText.textContent = theme.strings.unavailable;
        }
      },

      updatePrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant) {
          // variant.price comes back in the SHOP's base currency (SEK cents). When the
          // customer has switched currencies, theme.Currency.formatMoney does NOT convert —
          // it only formats. Without applying Shopify.currency.rate, EUR/DKK/CZK/BGN
          // customers would see the raw SEK amount with only per-currency formatting cleanup.
          // rate is "1.0" when active === shop currency, else the conversion factor.
          var _rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;

          // Regular price — convert first, then round to nearest 100 cents (whole displayed unit)
          const _amount = Math.round((variant.price * _rate) / 100) * 100
          switch (Shopify.currency.active) {
            case 'EUR':
              this.cache.price.innerHTML = theme.Currency.formatMoney(_amount, theme.settings.moneyFormat).replace(',00', '').replace('.', '');
              break;
            case 'CZK':
              this.cache.price.innerHTML = theme.Currency.formatMoney(_amount, theme.settings.moneyFormat).replace(',00', '').replace('.', '');
              break;
            default:
              this.cache.price.innerHTML = theme.Currency.formatMoney(_amount, theme.settings.moneyFormat).replace(',00', '').replace(',', '');
              break;
          }

          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            // Apply the same conversion to compare_at_price.
            const _compareAtConverted = Math.round((variant.compare_at_price * _rate) / 100) * 100
            switch (Shopify.currency.active) {
              case 'EUR':
                this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(_compareAtConverted, theme.settings.moneyFormat).replace(',00', '').replace('.', '');
                break;
              case 'CZK':
                this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(_compareAtConverted, theme.settings.moneyFormat).replace(',00', '').replace('.', '');
                break;
              default:
                this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(_compareAtConverted, theme.settings.moneyFormat).replace(',', '');
                break;
            }

            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
            this.cache.priceA11y.setAttribute('aria-hidden', 'false');

            // Savings: percent doesn't need conversion (ratio is stable); dollar amount does.
            var savings = variant.compare_at_price - variant.price;

            if (theme.settings.saveType == 'percent') {
              savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
            } else {
              savings = theme.Currency.formatMoney(savings * _rate, theme.settings.moneyFormat);
            }

            this.cache.savePrice.classList.remove(classes.hidden);
            this.cache.savePrice.querySelector('.product__saving--amount').innerHTML = `-${savings}`
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            this.cache.savePrice.classList.add(classes.hidden);
            this.cache.price.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
            }
            this.cache.priceA11y.setAttribute('aria-hidden', 'true');
          }
        }
      },

      updateUnitPrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
          this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.hidden);
        } else {
          this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.hidden);
        }
      },

      imageSetArguments: function (variant) {
        var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;

        var setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
        var set = this.settings.imageSetName + '_' + setValue;

        // Always start on index 0
        this.settings.currentSlideIndex = 0;

        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="' + set + '"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex
        }
      },

      updateImageSet: function (evt) {
        // If called directly, use current variant
        var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) {
          return;
        }

        var setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);

        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }

        this.initProductSlider(variant);
      },

      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function (set) {
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
        });
      },

      getImageSetName: function (string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },

      updateSku: function (evt) {
        var variant = evt.detail.variant;
        var newSku = '';

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }

          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },

      updateInventory: function (evt) {
        var variant = evt.detail.variant;

        // Hide stock if no inventory management or policy is continue
        if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') {
          this.toggleInventoryQuantity(variant, false);
          this.toggleIncomingInventory(false);
          return;
        }

        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
          var variantInventoryObject = window.inventories[this.productId][variant.id];

          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;

          if (quantity <= 0 || quantity > this.settings.inventoryThreshold || variantInventoryObject.policy === 'continue') {
            showInventory = false;
          }

          this.toggleInventoryQuantity(variant, variantInventoryObject);

          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (showInventory && variantInventoryObject.incoming === 'true' && quantity <= this.settings.inventoryThreshold) {
            showIncomingInventory = true;
          }

          this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
        }
      },

      updateAvailability: function (evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        this.storeAvailability.updateContent(variant.id);
      },

      toggleInventoryQuantity: function (variant, variantInventoryObject) {
        const { quantity, policy } = variantInventoryObject || {};
        if (!this.settings.inventory) {
          return;
        }

        var el = this.container.querySelector(this.selectors.inventory);
        var salesPoint = el.closest('.product-block');

        if (parseInt(quantity) <= parseInt(this.settings.inventoryThreshold) && policy !== 'continue') {
          el.parentNode.classList.add('inventory--low');
          if (quantity > 1) {
            el.textContent = theme.strings.otherStockLabel.replace('[count]', quantity);
          } else {
            el.textContent = theme.strings.oneStockLabel.replace('[count]', quantity);
          }
        } else {
          el.parentNode.classList.remove('inventory--low');
          el.textContent = theme.strings.inStockLabel;
        }

        if (variant && variant.available) {
          el.parentNode.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
        } else {
          el.parentNode.classList.add(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.add(classes.hidden);
          }
        }
      },

      toggleIncomingInventory: function (show, available, date) {
        var el = this.container.querySelector(this.selectors.incomingInventory);

        if (!el) {
          return;
        }

        var salesPoint = el.closest('.product-block');
        var textEl = el.querySelector('.js-incoming-text');

        if (show) {
          var string = available ?
            theme.strings.willNotShipUntil.replace('[date]', date) :
            theme.strings.willBeInStockAfter.replace('[date]', date);

          if (!date) {
            string = theme.strings.waitingForStock;
          }

          el.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
          textEl.textContent = string;
        } else {
          el.classList.add(classes.hidden);
        }
      },

      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function () {
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);

        if (!productVideos.length) {
          return false;
        }

        productVideos.forEach(vid => {
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid);
          } else if (type === 'vimeo') {
            this.initVimeoVideo(vid);
          } else if (type === 'mp4') {
            this.initMp4Video(vid);
          }
        });
      },

      initYoutubeVideo: function (div) {
        videoObjects[div.id] = new theme.YouTube(
          div.id,
          {
            videoId: div.dataset.videoId,
            videoParent: selectors.videoParent,
            autoplay: false, // will handle this in callback
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
            events: {
              onReady: this.youtubePlayerReady.bind(this),
              onStateChange: this.youtubePlayerStateChange.bind(this)
            }
          }
        );
      },

      initVimeoVideo: function (div) {
        videoObjects[div.id] = new theme.VimeoPlayer(
          div.id,
          div.dataset.videoId,
          {
            videoParent: selectors.videoParent,
            autoplay: false,
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
          }
        )
      },

      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function (evt) {
        var iframeId = evt.target.getIframe().id;

        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }

        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;

        if (obj.options.style !== 'sound') {
          player.mute();
        }

        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');
        obj.parent.classList.add('video-interactable'); // Previously, video was only interactable after slide change

        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },

      _isFirstSlide: function (id) {
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },

      youtubePlayerStateChange: function (evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];

        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },

      initMp4Video: function (div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4'
        };

        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },

      stopVideos: function () {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },

      _getVideoType: function (video) {
        return video.getAttribute('data-video-type');
      },

      _getVideoDivId: function (video) {
        return video.id;
      },

      playMp4Video: function (id) {
        var player = this.container.querySelector('#' + id);
        var playPromise = player.play();

        if (playPromise !== undefined) {
          playPromise.then(function () {
            // Playing as expected
          })
            .catch(function (error) {
              // Likely low power mode on iOS, show controls
              player.setAttribute('controls', '');
              player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
            });
        }
      },

      stopMp4Video: function (id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },

      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function () {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener('photoswipe:afterChange', function (evt) {
          if (this.flickity) {
            this.flickity.goToSlide(evt.detail.index);
          }
        }.bind(this));
      },

      getThumbIndex: function (target) {
        return target.dataset.index;
      },

      updateVariantImage: function (evt) {
        var variant = evt.detail.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);

        var newImage = this.container.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this.getThumbIndex(newImage);

        // If there is no index, slider is not initalized
        if (typeof imageIndex === 'undefined') {
          return;
        }

        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        }
      },

      initProductSlider: function (variant) {
        // Stop if only a single image, but add active class to first slide
        if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add('is-selected');
          }
          return;
        }

        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }

        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }

        var mainSliderArgs = {
          dragThreshold: 25,
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this)
          }
        };

        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }

        if (theme.config.bpSmall) {
          this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);
        }
      },

      onSliderInit: function (slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
      },

      onSlideChange: function (index) {
        if (!this.flickity) return;

        var prevSlide = this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + this.settings.currentSlideIndex + '"]');

        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName ?
          this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')[index] :
          this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + index + '"]');

        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);

        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);

        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);

        // Update current slider index
        this.settings.currentSlideIndex = index;
      },

      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }

        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
        }
      },

      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          this.flickity.reposition();
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }

        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
          slide.querySelector('.product-single__close-media').setAttribute('tabindex', 0);
        }
      },

      _slideIndex: function (el) {
        return el.getAttribute('data-index');
      },

      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function () {
        var initialized = false;

        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(selectors.blocksHolder);
          var url = this.blocksHolder.dataset.url;

          fetch(url).then(function (response) {
            return response.text();
          }).then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var blocks = doc.querySelector(selectors.blocks);

            // Because the same product could be opened in quick view
            // on the page we load the form elements from, we need to
            // update any `id`, `for`, and `form` attributes
            blocks.querySelectorAll('[id]').forEach(el => {
              // Update input `id`
              var val = el.getAttribute('id');
              el.setAttribute('id', val + '-modal');

              // Update related label if it exists
              var label = blocks.querySelector(`[for="${val}"]`);
              if (label) {
                label.setAttribute('for', val + '-modal');
              }

              // Update any collapsible elements
              var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
              if (collapsibleTrigger) {
                collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
              }
            });

            // Update any elements with `form` attribute.
            // Form element already has `-modal` appended
            var form = blocks.querySelector(this.selectors.form);
            if (form) {
              var formId = form.getAttribute('id');
              blocks.querySelectorAll('[form]').forEach(el => {
                el.setAttribute('form', formId);
              });
            }

            this.blocksHolder.innerHTML = '';
            this.blocksHolder.append(blocks);
            this.blocksHolder.classList.add('product-form-holder--loaded');

            this.cacheElements();

            this.formSetup();
            this.updateModalProductInventory();

            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            // Re-hook up collapsible box triggers
            theme.collapsibles.init(this.container);

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.productId
              }
            }));
          }.bind(this));

          this.productSetup();
          this.videoSetup();

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener('quickview:loaded', function (evt) {
                if (evt.detail.productId === this.productId) {
                  this.initProductSlider();
                }
              }.bind(this));
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }

        if (window.AOS) { AOS.refreshHard(); }

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.productId
          }
        }));
      },

      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function () {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};

          el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
            window.inventories[productId][el.dataset.id] = {
              'quantity': el.dataset.quantity,
              'policy': el.dataset.policy,
              'incoming': el.dataset.incoming,
              'next_incoming_date': el.dataset.date
            }
          });
        });
      },

      closeModalProduct: function () {
        this.stopVideos();
      },

      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function () {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;

        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },

      initShopifyXrLaunch: function () {
        document.addEventListener(
          'shopify_xr_launch',
          function () {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
              ':not(.' +
              self.classes.hidden +
              ')'
            );
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true
              })
            );
          }.bind(this)
        );
      },

      customMediaListners: function () {
        document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.addEventListener('click', function () {
            var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          }.bind(this))
        });

        var modelViewers = this.container.querySelectorAll('model-viewer');
        if (modelViewers.length) {
          modelViewers.forEach(el => {
            el.addEventListener('shopify_model_viewer_ui_toggle_play', function (evt) {
              this.mediaLoaded(evt);
            }.bind(this));

            el.addEventListener('shopify_model_viewer_ui_toggle_pause', function (evt) {
              this.mediaUnloaded(evt);
            }.bind(this));
          });
        }
      },

      mediaLoaded: function (evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.remove(classes.hidden);
        });

        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },

      mediaUnloaded: function (evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.add(classes.hidden);
        });

        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },

      onUnload: function () {
        theme.ProductMedia.removeSectionModels(this.sectionId);

        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }

        if (this._productResizeHandler) {
          window.removeEventListener('resize', this._productResizeHandler);
        }

        if (this._selectorClickHandler) {
          document.removeEventListener('click', this._selectorClickHandler);
        }

        // Modal-open/close listeners registered in init() when inModal is true.
        if (this._boundOpenModalProduct && this._modalEventNamespace) {
          document.removeEventListener('modalOpen.' + this._modalEventNamespace, this._boundOpenModalProduct);
        }
        if (this._boundCloseModalProduct && this._modalEventNamespace) {
          document.removeEventListener('modalClose.' + this._modalEventNamespace, this._boundCloseModalProduct);
        }

        // HeaderOpacityChanger instance from initHeaderOpacityChanger().
        if (this._headerOpacityChanger && typeof this._headerOpacityChanger.destroy === 'function') {
          this._headerOpacityChanger.destroy();
          this._headerOpacityChanger = null;
        }
      }
    });

    return Product;
  })();

  // RecentlyViewed — stores visited product handles in localStorage, then fetches
  // each product's card HTML via the Section Rendering API (?section_id=product-template-json).
  // Cards are cached in a static Map to avoid re-fetching on subsequent page loads.
  // The section file (sections/product-template-json.liquid) is an AJAX-only endpoint —
  // it is NOT in any template JSON. DO NOT DELETE that file.
  theme.RecentlyViewed = (function () {
    var init = false;

    function RecentlyViewed(container) {
      if (!container) {
        return;
      }

      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.recently-viewed' + this.sectionId;
      this.gridItemWidth = this.container.getAttribute('data-grid-item-class');
      this.rowOf = this.container.getAttribute('data-row-of');
      this.imageSize = this.container.getAttribute('data-image-size')
      this.hasOverlay = this.container.getAttribute('data-use-image-overlay')

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    };

    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function () {
        if (init) {
          return;
        }

        init = true;

        if (Object.keys(theme.recentlyViewed.recent).length === 0 && theme.recentlyViewed.recent.constructor === Object) {
          // No previous history on page load, so bail
          this.container.classList.add('hide');
          return;
        }

        this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
        this.handle = this.container.getAttribute('data-product-handle');

        // Request new product info via JS API
        var promises = [];
        Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
          if (handle !== undefined) {
            promises.push(this.getProductInfo(handle));
          }
        }.bind(this));

        Promise.all(promises).then(function (result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this));
      },

      getProductInfo: function (handle) {
        return new Promise(function (resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve({ handle: handle, html: theme.recentlyViewed.productInfo[handle] });
          } else {
            const root = window.Shopify && window.Shopify.routes
              ? window.Shopify.routes.root
              : '/';
            const url = `${root}products/${handle}?section_id=product-template-json`;

            fetch(url).then(function (response) {
              return response.text();
            }).then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var slide = doc.querySelector('.slide');
              resolve({ handle: handle, html: slide ? slide.outerHTML : null });
            }).catch(function () {
              resolve({ handle: handle, html: null });
            });
          }
        });
      },

      setupOutput: function (products) {
        var allSlides = [];
        var limit = this.container.getAttribute('data-recent-count');

        products.forEach(function (item) {
          if (!item || !item.html) {
            // Product was deleted — remove from localStorage
            if (item && item.handle) {
              delete theme.recentlyViewed.recent[item.handle];
            }
            return;
          }
          if (item.handle === this.handle) return;

          // Skip products with no title or no image (deleted/archived/draft)
          var tmp = new DOMParser().parseFromString(item.html, 'text/html');
          var title = tmp.querySelector('.grid-product__title');
          if (!title || !title.textContent.trim()) {
            delete theme.recentlyViewed.recent[item.handle];
            return;
          }

          allSlides.unshift(item.html);
        }.bind(this));

        // Persist cleaned-up list
        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }

        if (allSlides.length === 0) {
          this.container.classList.add('hide');
          return;
        }

        var slideCount = Math.min(allSlides.length, limit);
        var productMarkup = allSlides.slice(0, limit).join('');
        var sliderMarkup = this.prepareSliderElement(productMarkup, slideCount);
        this.outputContainer.innerHTML = sliderMarkup;

        if (window.AOS) {
          AOS.refreshHard();
        }
      },

      prepareSliderElement: function (slides, slideCount) {
        var _classString = ""
        if (slideCount <= 4) _classString = "class='slider--not-trigger'"
        var markup = `
          <slider-component ${_classString}>
            <div class="position-relative">
              <div class="swiper slider">
                <div class="swiper-wrapper slider--wrapper">
                  ${slides}
                </div>
              </div>
              <div class="pagination-wrapper">
                <div class="swiper-pagination"></div>
              </div>
              <button type="button" class="btn--next--prev btn--prev" aria-label="Previous slide">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="15 6 9 12 15 18"/></svg>
              </button>
              <button type="button" class="btn--next--prev btn--next" aria-label="Next slide">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="9 6 15 12 9 18"/></svg>
              </button>
            </div>
          </slider-component>
        `;
        return markup
      },

      captureProductDetails: function (products) {
        products.forEach(function (item) {
          if (item && item.handle && item.html) {
            theme.recentlyViewed.productInfo[item.handle] = item.html;
          }
        });

        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem(theme.recentlyViewed.cacheKey, JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },

      onUnload: function () {
        init = false;
      }
    });

    return RecentlyViewed;
  })();

  // Drives the CONTENT of the mobile nav drawer: sub-nav level switching
  // (slide-nav tiers) and the language/currency panel. It does NOT open or
  // close the drawer itself — that is theme.Drawers('NavDrawer', 'nav').
  // The old open()/close() half was removed in the 2026-07-11 cleanup: its
  // trigger (.mobile-nav-trigger) existed in no template and its body called
  // two functions (theme.sizeDrawer, theme.headerNav.removeOverlayClass)
  // that are not defined anywhere — a landmine had the trigger ever returned.
  theme.MobileNav = (function () {
    var selectors = {
      wrapper: '.slide-nav__wrapper',
      nav: '.slide-nav',
      childList: '.slide-nav__dropdown',
      subNavToggleBtn: '.js-toggle-submenu',
      mainfixedheader: '.drawer__contents > .drawer__fixed-header',

      langNcurWrapper: '.lang-currency--switcher__wrapper',
      langNcurNav: '.lang-cur--nav'
    };

    var classes = {
      isActive: 'is-active',
      heightRemoved: 'is-removed-height'
    };

    var defaults = {
      menuLevel: 1
    };

    function MobileNav(args) {
      this.config = Object.assign({}, defaults, args);

      this.container = document.getElementById(this.config.id);
      if (!this.container) {
        return;
      }

      // BOTH gender menus render their own .slide-nav__wrapper (women's
      // always, men's once its menu has links — snippets/drawer-menu.liquid).
      // Everything below is per-wrapper: keying off only the FIRST wrapper
      // left the men's submenu buttons without click handlers.
      this.wrappers = this.container.querySelectorAll(selectors.wrapper);
      if (!this.wrappers.length) {
        return;
      }
      this.langNcurWrapper = this.container.querySelector(selectors.langNcurWrapper)
      this.mainfixedheader = this.container.querySelector(selectors.mainfixedheader);
      this.langNcurNav = this.langNcurWrapper.querySelector(selectors.langNcurNav);

      this.init();
    }

    MobileNav.prototype = Object.assign({}, MobileNav.prototype, {
      init: function () {
        // Toggle between menu levels — bind in EVERY gender wrapper, not
        // just the first (the men's menu is a second .slide-nav__wrapper)
        this.container.querySelectorAll(selectors.subNavToggleBtn).forEach(btn => {
          btn.addEventListener('click', this.toggleSubNav.bind(this));
        });

        this.langNcurNav.querySelectorAll('.lang-switcher--btn').forEach(btn => {
          btn.addEventListener('click', (event) => {
            this.toggleLangCurSwitcher(event);
            if (!this.mainfixedheader.classList.contains(classes.heightRemoved)) {
              this.mainfixedheader.classList.add(classes.heightRemoved);
            }
          });
        });

      },

      toggleLangCurSwitcher: function (evt) {
        if (evt) {
          evt.preventDefault();
        }

        const btn = evt.currentTarget;
        this.goToLangCur(btn.dataset.target);
      },

      goToLangCur: function (target) {
        var targetMenu = this.container.querySelector(`div[data-parent='${target}']`)
        if (targetMenu) {
          targetMenu.classList.add(classes.isActive);
        }
      },

      /*============================================================================
        Handle switching between nav levels
      ==============================================================================*/
      toggleSubNav: function (evt) {
        var btn = evt.currentTarget;
        var title = btn.dataset.title
        var titleEl = document.querySelector('.title__placeholder')
        var searchTriggerEl = document.querySelector('.slide-nav__search-field')
        if (title) {
          if (title.toLowerCase() == 'sale') {
            titleEl.classList.add('link--danger')
          } else {
            titleEl.classList.remove('link--danger')
          }
          titleEl.innerHTML = title
          searchTriggerEl.classList.add('disappear')
        } else {
          titleEl.innerHTML = ""
          titleEl.classList.remove('link--danger')
          searchTriggerEl.classList.remove('disappear')
        }
        // Scope the level switch to the gender menu the click came from
        this.goToSubnav(btn.dataset.target, btn.closest(selectors.wrapper));
      },

      // If a level is sent we are going up, so target list doesn't matter.
      // wrapperEl is the .slide-nav__wrapper the triggering button lives in;
      // falls back to the first wrapper so a stray call can't throw.
      goToSubnav: function (target, wrapperEl) {
        var wrapper = wrapperEl || this.wrappers[0];
        var nav = wrapper.querySelector(selectors.nav);

        // Activate new list if a target is passed
        var targetMenu = nav.querySelector(selectors.childList + '[data-parent="' + target + '"]')
        if (targetMenu) {
          this.config.menuLevel = targetMenu.dataset.level;

          // Hide all level 3 menus if going to level 2
          if (this.config.menuLevel == 2) {
            nav.querySelectorAll(selectors.childList + '[data-level="3"]').forEach(list => {
              list.classList.remove(classes.isActive);
              list.parentElement.classList.remove(classes.isActive);
            });
          }


          setTimeout(() => {
            targetMenu.classList.add(classes.isActive);
            targetMenu.parentElement.classList.add(classes.isActive);
            this.setWrapperHeight(wrapper, targetMenu.offsetHeight + 30);
          }, 150)

        } else {
          // Going to top level, reset
          this.config.menuLevel = 1;
          wrapper.removeAttribute('style');
          nav.querySelectorAll(selectors.childList).forEach(list => {
            list.classList.remove(classes.isActive);
            list.parentElement.classList.remove(classes.isActive);
          });
        }

        wrapper.dataset.level = this.config.menuLevel;
      },

      setWrapperHeight: function (wrapper, h) {
        wrapper.style.height = h + 'px';
      }
    });

    return MobileNav;
  })();


  theme.isStorageSupported = function (type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function (scope) {
    if (window.AOS) { AOS.refreshHard() }

    theme.initQuickShop();

    // Refresh reviews app
    if (window.SPR) { SPR.initDomEls(); SPR.loadBadges() }

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported('session');
  theme.config.hasLocalStorage = theme.isStorageSupported('local');
  if (window.AOS) AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

    if (theme.recentlyViewed.localStorage) {
      // Guard against a corrupted entry left by extensions or older theme versions.
      // Without this, a single bad JSON breaks every subsequent line of theme.js.
      try {
        theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
      } catch (e) {
        theme.recentlyViewed.recent = {};
        window.localStorage.removeItem('theme-recent');
      }
    }
  }

  theme.recentlyViewed.cacheKey = 'recent-products-' +
    (window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : '');
  theme.recentlyViewed.productInfo = {};
  if (theme.config.hasSessionStorage && sessionStorage[theme.recentlyViewed.cacheKey]) {
    try {
      theme.recentlyViewed.productInfo = JSON.parse(sessionStorage[theme.recentlyViewed.cacheKey]);
    } catch (e) {
      window.sessionStorage.removeItem(theme.recentlyViewed.cacheKey);
    }
  }

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function (mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function () {
    theme.collapsibles.init();
    theme.videoModal();
  }

  DOMready(function () {
    theme.sections = new theme.Sections();

    theme.sections.register('slideshow-section', theme.SlideshowSection);
    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('product', theme.Product);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('photoswipe', theme.Photoswipe);
    theme.sections.register('product-recommendations', theme.Recommendations);
    theme.sections.register('video-section', theme.VideoSection);
    theme.sections.register('footer-section', theme.FooterSection);
    theme.sections.register('store-availability', theme.StoreAvailability);
    theme.sections.register('recently-viewed', theme.RecentlyViewed);
    theme.sections.register('collection-header', theme.CollectionHeader);
    theme.sections.register('collection-grid', theme.Collection);

    theme.initGlobals();
    theme.initQuickShop();
    theme.rteInit();

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }

    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });

})();

class CollapsibleDescription extends HTMLElement {
  connectedCallback() {
    const showMoreToggle = this.querySelector('.show_more_toggle')
    const showLessToggle = this.querySelector('.show_less_toggle')
    // Scope to THIS component's own wrapper rather than the first one on the page.
    const wrapper = this.closest('.collection__description--wrapper')
    if (!wrapper) return;

    // AbortController tears down every listener in disconnectedCallback so a reconnect
    // (theme-editor section reload, DOM move) can't accumulate duplicate handlers.
    this._ac = new AbortController();
    const { signal } = this._ac;

    const updateToggleVisibility = () => {
      // Measure the WRAPPER — it owns the clipping (`max-height` + `overflow:hidden`).
      // The inner `.rte.collection__description` is not height-constrained, so it never
      // reports overflow; measuring the wrapper is what makes the toggle appear and stay
      // correct on resize. Set "Less" visibility BEFORE measuring — it renders in-flow and
      // only belongs to the expanded state, so measuring it while visible would inflate the
      // collapsed height and false-positive overflow at boundary lengths.
      const isOpen = wrapper.classList.contains('open');
      const active = document.activeElement;

      if (showLessToggle) showLessToggle.classList.toggle('hidden', !isOpen);
      const isOverflowing = wrapper.scrollHeight > wrapper.clientHeight;
      if (showMoreToggle) showMoreToggle.classList.toggle('hidden', !(isOverflowing && !isOpen));

      // Never strand keyboard focus on a toggle we just hid (the ResizeObserver firing
      // mid-collapse, or a resize that makes the text fit): hand focus to the still-visible
      // counterpart, else to the wrapper. preventScroll: the wrapper is overflow-hidden.
      if ((active === showLessToggle || active === showMoreToggle) && active.classList.contains('hidden')) {
        const other = active === showLessToggle ? showMoreToggle : showLessToggle;
        if (other && !other.classList.contains('hidden')) {
          other.focus({ preventScroll: true });
        } else {
          wrapper.setAttribute('tabindex', '-1');
          wrapper.focus({ preventScroll: true });
        }
      }
    }

    // Run cb after the wrapper's max-height transition. prefers-reduced-motion zeroes the
    // duration (transitionend may never fire), so run immediately then. Otherwise listen for
    // the max-height transitionend (target/propertyName-guarded so a descendant transition
    // can't consume it) with a timeout fallback; whichever wins clears the other.
    const afterMaxHeightTransition = (cb) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { cb(); return; }
      let done = false;
      let timer;
      const run = () => { if (done) return; done = true; clearTimeout(timer); wrapper.removeEventListener('transitionend', onEnd); cb(); };
      const onEnd = (e) => { if (e.target === wrapper && e.propertyName === 'max-height') run(); };
      wrapper.addEventListener('transitionend', onEnd, { signal });
      timer = setTimeout(run, 400);
    };

    updateToggleVisibility()

    if (showMoreToggle) {
      showMoreToggle.addEventListener('click', () => {
        // Reveal "Less" and move focus to it first (so focus never sits on the button we're
        // about to hide), then animate max-height from the clamped value to the full height.
        if (showLessToggle) { showLessToggle.classList.remove('hidden'); showLessToggle.focus({ preventScroll: true }); }
        showMoreToggle.classList.add('hidden');
        const fullHeight = wrapper.scrollHeight;

        requestAnimationFrame(() => {
          wrapper.style.maxHeight = fullHeight + 'px';
          wrapper.classList.add('open')
          afterMaxHeightTransition(() => {
            if (wrapper.classList.contains('open')) wrapper.style.maxHeight = 'none';
          })
        })
      }, { signal })
    }
    if (showLessToggle) {
      showLessToggle.addEventListener('click', () => {
        // Pin to the current height, then collapse on the next frame. updateToggleVisibility
        // (via the ResizeObserver during the collapse, and again once it settles) re-shows
        // "More" and hands focus off the now-hidden "Less".
        wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
        wrapper.offsetHeight; // force reflow so the collapse transition runs
        wrapper.classList.remove('open')
        wrapper.style.maxHeight = '';
        afterMaxHeightTransition(updateToggleVisibility)
      }, { signal })
    }

    // Observe the wrapper (not document.body): fires on the reflows that matter and avoids
    // reruns from unrelated body-size changes.
    this._resizeObserver = new ResizeObserver(() => { updateToggleVisibility() })
    this._resizeObserver.observe(wrapper)
  }

  disconnectedCallback() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
    if (this._ac) this._ac.abort();
  }
}

customElements.define('collapsible-description', CollapsibleDescription)

document.addEventListener('DOMContentLoaded', function (e) {
  const availabilityEl = document.querySelector('input[name="filter.v.availability"][value="1"]')
  const unavailableityEl = document.querySelector('input[name="filter.v.availability"][value="0"]')
  const allItemsEl = document.querySelector('input[name="all_items"][value="1"]')
  const formEl = document.querySelector('.filter-form')

  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  if (urlParams.has('all_items') && allItemsEl) {
    allItemsEl.setAttribute('checked', 'checked')
  }
})

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.stickyElement = null;
    this.mainTriggerEl = null;
    this.altTriggerEl = null;
    this.blockerEl = null;

    this.footerVisible = false;
    this._selectorOpen = false;

    this.triggerOffset = 0;
    this.currentScrollY = 0;
    this.ticking = false;
    this.stickyLoadedTimeout = null;

    this.handleBlockerIntersection = this.handleBlockerIntersection.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onSelectorOpen = this.onSelectorOpen.bind(this);
    this.onSelectorClose = this.onSelectorClose.bind(this);
  }

  connectedCallback() {
    this.stickyElement = this.querySelector('[data-sticky-element]');
    if (!this.stickyElement) {
      console.warn('Sticky element not found inside <sticky-add-to-cart>');
      return;
    }

    const mainTriggerSelector = this.dataset.mainTriggerSelector;
    const altTriggerSelector = this.dataset.altTriggerSelector;
    const blockerSelector = this.dataset.blockerSelector;

    if (!mainTriggerSelector || !blockerSelector) {
      console.warn('Missing data-main-trigger-selector or data-blocker-selector');
      return;
    }

    this.mainTriggerEl = document.querySelector(mainTriggerSelector);
    if (!this.mainTriggerEl) {
      console.warn('Main trigger element not found:', mainTriggerSelector);
      return;
    }

    if (altTriggerSelector) {
      this.altTriggerEl = document.querySelector(altTriggerSelector);
    }

    this.blockerEl = document.querySelector(blockerSelector);
    if (!this.blockerEl) {
      console.warn('Blocker element not found:', blockerSelector);
      return;
    }

    this.blockerObserver = new IntersectionObserver(
      this.handleBlockerIntersection,
      { threshold: 0 }
    );
    this.blockerObserver.observe(this.blockerEl);

    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);

    document.addEventListener('selector:open', this.onSelectorOpen);
    document.addEventListener('selector:close', this.onSelectorClose);

    this.updateTriggerOffset();
    this.updateStickyState();
  }

  disconnectedCallback() {
    if (this.blockerObserver) this.blockerObserver.disconnect();

    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);

    document.removeEventListener('selector:open', this.onSelectorOpen);
    document.removeEventListener('selector:close', this.onSelectorClose);

    if (this.stickyLoadedTimeout) {
      clearTimeout(this.stickyLoadedTimeout);
      this.stickyLoadedTimeout = null;
    }
  }

  handleBlockerIntersection(entries) {
    entries.forEach(entry => {
      this.footerVisible = entry.isIntersecting;
      this.updateStickyState();
    });
  }

  updateTriggerOffset() {
    const mainDisabled = this.mainTriggerEl.disabled || this.mainTriggerEl.hasAttribute('disabled');

    if (mainDisabled && this.altTriggerEl) {
      this.triggerOffset = this.altTriggerEl.getBoundingClientRect().top + window.scrollY;
    } else {
      this.triggerOffset = this.mainTriggerEl.getBoundingClientRect().top + window.scrollY;
    }
  }

  updateStickyState() {
    if (this._selectorOpen) {
      this.removeStickyClasses();
      return;
    }

    if (this.currentScrollY > this.triggerOffset && !this.footerVisible) {
      if (!this.stickyElement.classList.contains('position--sticky')) {
        this.stickyElement.classList.add('position--sticky');
        // Add sticky--loaded after 500ms
        this.stickyLoadedTimeout = setTimeout(() => {
          this.stickyElement.classList.add('sticky--loaded');
        }, 0);
      }
    } else {
      this.removeStickyClasses();
    }
  }

  removeStickyClasses() {
    if (this.stickyLoadedTimeout) {
      clearTimeout(this.stickyLoadedTimeout);
      this.stickyLoadedTimeout = null;
    }
    this.stickyElement.classList.remove('position--sticky', 'sticky--loaded');
  }

  onScroll() {
    this.currentScrollY = window.scrollY;
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.updateStickyState();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  onResize() {
    this.updateTriggerOffset();
    this.updateStickyState();
  }

  onSelectorOpen() {
    this._selectorOpen = true;
    document.body.classList.add('lock-scroll');
    this.removeStickyClasses();
  }

  onSelectorClose() {
    this._selectorOpen = false;
    document.body.classList.remove('lock-scroll');
    this.updateStickyState();
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);


class FeaturedCollectionTab extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.tab__btn')

    this._boundToggle = this.toggleTab.bind(this);
    this.tabs.forEach((item) => {
      item.addEventListener('click', this._boundToggle)
    })

    // ARIA tabs keyboard pattern — Arrow/Home/End/Enter/Space.
    this._boundKeydown = this._onKeydown.bind(this);
    this.addEventListener('keydown', this._boundKeydown)

    this.activeTab = this.querySelector('.tab-content[data-active="true"]')
  }

  disconnectedCallback() {
    if (this._boundToggle && this.tabs) {
      this.tabs.forEach((item) => item.removeEventListener('click', this._boundToggle))
    }
    if (this._boundKeydown) {
      this.removeEventListener('keydown', this._boundKeydown)
    }
  }

  toggleTab(e) {
    const target = e.currentTarget
    const id = target.dataset.tabId

    if (this.activeTab) this.activeTab.setAttribute('data-active', false)

    this.tabs.forEach(item => {
      const isActive = item.isSameNode(target)
      item.setAttribute('data-active-tab', isActive ? 'true' : 'false')
      // Keep ARIA + roving tabindex in sync with data-active-tab.
      item.setAttribute('aria-selected', isActive ? 'true' : 'false')
      item.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    const tabContent = this.querySelector(`[data-tab-for="${id}"]`)
    this.activeTab = tabContent
    if (tabContent) tabContent.setAttribute('data-active', true)
  }

  _onKeydown(e) {
    const currentTab = e.target.closest('.tab__btn')
    if (!currentTab) return
    const tabsArr = Array.from(this.tabs)
    const currentIndex = tabsArr.indexOf(currentTab)
    if (currentIndex < 0) return

    let nextIndex = -1
    switch (e.key) {
      case 'ArrowRight':
        e.preventDefault()
        nextIndex = (currentIndex + 1) % tabsArr.length
        break
      case 'ArrowLeft':
        e.preventDefault()
        nextIndex = (currentIndex - 1 + tabsArr.length) % tabsArr.length
        break
      case 'Home':
        e.preventDefault()
        nextIndex = 0
        break
      case 'End':
        e.preventDefault()
        nextIndex = tabsArr.length - 1
        break
      case 'Enter':
      case ' ':
        e.preventDefault()
        currentTab.click()
        return
      default:
        return
    }

    if (nextIndex >= 0) {
      tabsArr[nextIndex].focus()
      tabsArr[nextIndex].click()
    }
  }
}

customElements.define('featured-collection-tab', FeaturedCollectionTab)

class HeightObserver extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.container')

    if (this.dataset.container) {
      this.container = this.querySelector(this.dataset.container)
    }


  }



  connectedCallback() {
    this.addEventListener('slider:inited', (e) => {
      if (e.detail.isTab) this.adjustHeight(e.detail.height)
    })
  }

  adjustHeight(sliderHeight) {
    const button = this.querySelector('.shop-all__btn--wrapper')
    let buttonHeight = 0

    if (button) {
      const buttonStyles = window.getComputedStyle(button)
      const buttonMarginTop = parseFloat(buttonStyles.marginTop)
      const buttonMarginBottom = parseFloat(buttonStyles.marginBottom)
      buttonHeight = button.offsetHeight + buttonMarginTop + buttonMarginBottom
    }

    let height = sliderHeight + buttonHeight + 'px';

    this.container.style.setProperty('--content-height', height || 'auto');
  }
}

customElements.define('height-observer', HeightObserver);

class SliderComponent extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    // Browsing-gender gate for recommendation slides (data-gender-fit =
    // men|women|both, stamped by sections/product-recommendations.liquid).
    // This is the single choke point BOTH render paths flow through:
    // server-rendered (_related collections — theme.Recommendations
    // returns early for those) and AJAX-injected markup.
    //
    // FAIL-CLOSED ORDERING: this gate runs BEFORE the Swiper guard below.
    // If the vendor-script race trips `typeof Swiper === 'undefined'` and we
    // bail, the cross-gender slides must ALREADY be stripped — otherwise a
    // failed Swiper load would leave men-only slides visible to a women
    // browser (the exact leak this project forbids). The gate has zero
    // Swiper dependency and its empty-case `return` precedes any Swiper use,
    // so it is safe here.
    //
    // Skipped in the theme editor (Shopify.designMode): merchants must see
    // ALL slides while editing, consistent with gender-context.js.
    //
    // Reads the RESOLVED gender from body[data-gender], NOT the raw cookie. As of
    // 2026-08 the server sets data-gender from the PAGE's own gender (product tag /
    // collection handle; women fallback on neutral pages) directly in the <body>
    // HTML, so it is already correct here even though theme.js runs before
    // gender-context.js — and crucially it is AUTHORITATIVE: a men PDP filters recs
    // to men even if a stale cookie says women (the old cookie read filtered to the
    // WRONG gender and irreversibly removed the right slides). "none" (design mode /
    // no preference) → no filtering. Sliders without data-gender-fit slides (featured
    // collections, recently viewed — shows all genders) are untouched.
    if (!(window.Shopify && Shopify.designMode)) {
      const fitSlides = this.querySelectorAll('[data-gender-fit]');
      if (fitSlides.length) {
        const bg = document.body.dataset.gender;
        const browsingGender = (bg === 'men' || bg === 'women') ? bg : null;
        if (browsingGender) {
          fitSlides.forEach((slide) => {
            const fit = slide.dataset.genderFit;
            if (fit !== 'both' && fit !== browsingGender) slide.remove();
          });
        }
        // Gate emptied the slider → hide the whole recommendations section
        // (heading included) instead of initializing an empty Swiper.
        if (!this.querySelector('.slider--wrapper .slide')) {
          const section = this.closest('[data-section-type="product-recommendations"]') || this.closest('.index-section');
          if (section) section.classList.add('hide');
          return;
        }
      }
    }

    // Guard against Swiper not loaded yet (vendor script race condition under throttled networks)
    if (typeof Swiper === 'undefined') return;

    this.sliderContainer = this.querySelector('.slider')

    this.isTabSlider = false

    if (this.dataset.sliderType == "tab-slider") this.isTabSlider = true

    const slideElements = this.querySelectorAll('.slider--wrapper .slide')

    let slidesPerViewDesktop = 4
    let spaceBetweenDesktop = 5

    this.btnPrev = this.querySelector('.btn--prev')
    this.btnNext = this.querySelector('.btn--next')

    if (slideElements.length < 5) this.classList.add('swiper--button--hidden')

    if (slideElements.length <= 4) {
      slidesPerViewDesktop = 4
      spaceBetweenDesktop = 5
    };

    this.slider = new Swiper(this.sliderContainer, {
      // Slide behavior
      slidesPerView: 1.43,
      spaceBetween: 5,

      // Tuning — config-level only (no runtime overrides)
      speed: 650,
      threshold: 5,
      touchRatio: 0.85,
      resistance: true,
      resistanceRatio: 0.87,
      longSwipesRatio: 0.2,
      touchStartPreventDefault: false,
      preventInteractionOnTransition: false,
      watchOverflow: true,

      centeredSlides: true,
      centeredSlidesBounds: true,
      direction: 'horizontal',
      followFinger: true,
      grabCursor: true,
      cssMode: false,
      touchEventsTarget: 'container',
      touchMoveStopPropagation: true,
      slidesOffsetAfter: 0,
      navigation: {
        nextEl: this.btnNext,
        prevEl: this.btnPrev
      },
      breakpoints: {
        769: {
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: spaceBetweenDesktop,
          speed: 350,
          slidesPerGroup: 1,
          centeredSlides: false,
          centeredSlidesBounds: false,
        }
      },
      on: {
        init: slider => {
          // Block native image drag-and-drop
          slider.el.addEventListener('dragstart', function (e) {
            e.preventDefault();
          });

          // Size arrow buttons to image area only
          const firstImageMask = slider.el.querySelector('.grid-product__image-mask');
          if (firstImageMask) {
            const imageHeight = firstImageMask.offsetHeight + 'px';
            const prevBtn = slider.el.parentElement.querySelector('.btn--prev');
            const nextBtn = slider.el.parentElement.querySelector('.btn--next');
            if (prevBtn) prevBtn.style.height = imageHeight;
            if (nextBtn) nextBtn.style.height = imageHeight;
          }

          const event = new CustomEvent('slider:inited', {
            bubbles: true,
            detail: {
              height: slider.height,
              isTab: this.isTabSlider
            }
          })
          this.dispatchEvent(event)
        },
        resize: slider => {
          const event = new CustomEvent('slider:inited', {
            bubbles: true,
            detail: {
              height: slider.height,
              isTab: this.isTabSlider
            }
          })
          this.dispatchEvent(event)
        }
      }
    });

    // Store the timer so disconnectedCallback can cancel a pending click
    // before the host element is removed from the DOM.
    this._initTimer = setTimeout(() => {
      if (this.btnPrev) this.btnPrev.click()
    }, 300)
  }

  disconnectedCallback() {
    // Section reload in the editor (and any DOM remove) must tear down the
    // Swiper instance + its delegated touch handlers + its ResizeObserver,
    // and cancel any pending init-click timer. Without this, every reload
    // leaves an orphaned Swiper attached to detached DOM nodes.
    if (this._initTimer) {
      clearTimeout(this._initTimer);
      this._initTimer = null;
    }
    if (this.slider && typeof this.slider.destroy === 'function') {
      this.slider.destroy(true, true);
      this.slider = null;
    }
  }
}

customElements.define('slider-component', SliderComponent)

class ScrollToList extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.links = this.querySelectorAll('a[href*="#"]')
    this.links.forEach(linkEl => {
      linkEl.addEventListener('click', this.goToDestination.bind(this))
    })
  }

  goToDestination(evt) {
    evt.preventDefault()
    const target = evt.currentTarget

    const id = target.getAttribute('href').replace('#', '')
    const destinationEl = document.getElementById(id)

    if (destinationEl) {
      // Respect prefers-reduced-motion — smooth scroll triggers vestibular issues
      // for affected users. matchMedia returns false on browsers that don't support
      // the query, defaulting to smooth (no regression).
      var prefersReduced = typeof window.matchMedia === 'function'
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      destinationEl.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start', inline: 'start' });
    }
  }
}

customElements.define('scroll-to-list', ScrollToList)

/*============================================================================
  Size ordering — shared utility
  Replaces the 21 KB CSS order approach (size-order.liquid) with DOM reorder.
  Handles alpha sizes (XS–XXXXXXXL), numbered sizes (EU 38, IT 48, 42),
  and merchant-configured custom sizes from theme settings.
==============================================================================*/

const ALPHA_SIZE_WEIGHTS = {
  OS: 0,
  XXXXXS: 1, XXXXS: 2, XXXS: 3, XXS: 4, XS: 5, S: 6,
  M: 7, L: 8, XL: 9, XXL: 10, XXXL: 11, XXXXL: 12,
  XXXXXL: 13, XXXXXXL: 14, XXXXXXXL: 15
}

let merchantSizeWeights = null

function loadMerchantSizeConfig() {
  if (merchantSizeWeights !== null) return
  merchantSizeWeights = {}
  const configEl = document.getElementById('size-order-config')
  if (!configEl) return
  try {
    const raw = JSON.parse(configEl.textContent)
    let counter = 1
    raw.split(/[,|]/).forEach(s => {
      const trimmed = s.trim()
      if (trimmed) {
        merchantSizeWeights[trimmed] = counter
        merchantSizeWeights[trimmed.toUpperCase()] = counter
        merchantSizeWeights[trimmed.toLowerCase()] = counter
        counter++
      }
    })
  } catch (e) { /* invalid config — fall through to alpha/numeric */ }
}

function getSizeWeight(sizeStr) {
  if (!sizeStr) return Infinity
  loadMerchantSizeConfig()

  // Merchant config takes priority (exact match, case-insensitive)
  const merchantWeight = merchantSizeWeights[sizeStr] ?? merchantSizeWeights[sizeStr.toUpperCase()]
  if (merchantWeight !== undefined) return merchantWeight

  // Alpha size lookup
  const alphaWeight = ALPHA_SIZE_WEIGHTS[sizeStr.toUpperCase()]
  if (alphaWeight !== undefined) return alphaWeight

  // Numeric extraction — "EU 38", "IT 48", "42", "6.5"
  const numMatch = sizeStr.match(/(\d+(?:\.\d+)?)/)
  if (numMatch) return 100 + parseFloat(numMatch[1])

  return Infinity
}

function sortSizeContainer(container, items, valueAttr, fallbackAttr) {
  if (!container || items.length < 2) return
  items.sort((a, b) => {
    const valA = a.getAttribute(valueAttr) || (fallbackAttr && a.getAttribute(fallbackAttr))
    const valB = b.getAttribute(valueAttr) || (fallbackAttr && b.getAttribute(fallbackAttr))
    return getSizeWeight(valA) - getSizeWeight(valB)
  })
  items.forEach(item => container.appendChild(item))
}

function sortProductPageSizes() {
  // Mobile: .option-input-wrap[data-handle="size"] .option-list
  // Prefer data-display-value (metafield override), fall back to data-value (raw supplier)
  document.querySelectorAll('.option-input-wrap[data-handle="size"] .option-list').forEach(list => {
    sortSizeContainer(list, [...list.querySelectorAll('.btn--option[data-value]')], 'data-display-value', 'data-value')
  })

  // Desktop: .variant-input-wrap[data-handle="size"] .option--list
  document.querySelectorAll('.variant-input-wrap[data-handle="size"] .option--list').forEach(list => {
    sortSizeContainer(list, [...list.querySelectorAll('.option--item[data-value]')], 'data-display-value', 'data-value')
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', sortProductPageSizes)
} else {
  sortProductPageSizes()
}

// SizeFilter — Web Component wrapping the size filter option list.
// On connectedCallback, sorts size options into a logical order (XS→XL, EU 36→46)
// using the shared sortSizeContainer() utility.
class SizeFilter extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.#sortSizes()
  }

  #sortSizes() {
    const list = this.querySelector('ul')
    if (!list) return
    const items = [...list.querySelectorAll('li.tag[data-filter-value]')]
    sortSizeContainer(list, items, 'data-filter-value')
  }
}

customElements.define('size-filter', SizeFilter)

class LocalizationForm extends HTMLElement {
  constructor() {
    super()
    this.submitButtons = document.querySelectorAll('[data-localization-submit]')
    this.submitButtons.forEach(btn => btn.addEventListener('click', this.handleSubmit.bind(this)))
    this.toggleButtons = document.querySelectorAll('button.localization-toggle--btn')
    this.toggleButtons.forEach(btn => btn.addEventListener('click', this.toggleLocal.bind(this)))
    this.langSwitcherBtns = document.querySelectorAll('.lang-switcher--btn')
    this.langSwitcherBtns.forEach(btn => btn.addEventListener('click', this.openLangSwitcher.bind(this)))
    this.form = this.querySelector('#localization_form-header')
    document.body.addEventListener('click', this.closeSwitcher.bind(this))
  }
  closeSwitcher(evt) {

    const disclosers = document.querySelectorAll('.localization--list__container')

    disclosers.forEach(el => {
      el.classList.remove('active')
    })
  }
  openLangSwitcher(evt) {
    evt.stopPropagation()
    const target = evt.currentTarget
    const targetId = target.dataset.target
    const disclosers = document.querySelectorAll('.localization--list__container')
    disclosers.forEach(el => {
      const parent = el.dataset.parent
      if (parent == targetId) {
        el.classList.add('active')
      }
      else {
        el.classList.remove('active')
      }
    })
  }
  toggleLocal(evt) {
    const target = evt.currentTarget
    const type = target.dataset.type
    const value = target.dataset.value
    const isSubmit = target.dataset.isSubmit
    const parent = target.parentNode.parentNode.parentNode
    if (type == 'language') {
      const input = this.form.querySelector('input[name="language_code"]')
      input.value = value
    }
    if (type == 'currency') {
      const input = this.form.querySelector('input[name="country_code"]')
      input.value = value
    }
    const btnList = parent.querySelectorAll('.localization-toggle--btn')
    btnList.forEach(btn => {
      if (btn.isSameNode(target)) {
        btn.setAttribute('aria-current', true)
      } else {
        btn.removeAttribute('aria-current')
      }
    })
    if (isSubmit == 'true') {
      this.submitForm(type, value)
    }
  }
  handleSubmit(evt) {
    evt.preventDefault()
    const target = evt.currentTarget
    const type = target.dataset.submit
    let value = ""

    if (type == 'currency') {
      value = this.form.querySelector('input[name="country_code"]').value
    }
    if (type == 'language') {
      value = this.form.querySelector('input[name="language_code"]').value
    }
    this.submitForm(type, value)
  }
  submitForm(type, value) {
    if (type == 'language') {
      Cookies.set('language_choosen', value, { path: '/', expires: 30 })
    }
    if (type == 'currency') {
      Cookies.set('currency_choosen', value, { path: '/', expires: 30 })
    }
    this.form.submit()
  }
}
customElements.define('localization-form', LocalizationForm)

const ua = navigator.userAgent;

// Detect iOS
const isIOS = /iP(ad|hone|od)/.test(ua);
if (isIOS) {
  document.body.classList.add('is-ios');
}

// Detect Safari (macOS or iOS) and exclude all other browsers
const isSafari = isIOS && navigator.vendor.includes('Apple')

if (isSafari) {
  document.body.classList.add('is-safari');
}